import React, { useState, useEffect, useMemo } from 'react';
import { renderToString } from 'react-dom/server'
import api from '../../services/api_organograma';
import previsaostyles from "./previsao-styles.module.css";
import swalstyles from "./swal-styles.module.css";
import loadingstyles from "./loading-styles.module.css";
import moment from 'moment';
import { useHistory } from "react-router-dom";
import Select, { components } from 'react-select'
import Swal from 'sweetalert2';

import { BsFillXCircleFill, BsFillExclamationCircleFill, BsFillCheckCircleFill, BsFillSquareFill, BsInfoCircle, BsInfoCircleFill, BsTrashFill } from 'react-icons/bs';
import { IoIosArrowUp, IoIosArrowDown, IoIosRemove, IoMdArrowDropdown, IoMdArrowDropup, IoMdAdd } from 'react-icons/io';
import { IoAlert } from 'react-icons/io5';
import { RiSearchLine, RiAlertFill } from 'react-icons/ri';
import { TiTick, TiTickOutline, TiArrowBack } from 'react-icons/ti';
import { MdOutlineMoneyOff } from 'react-icons/md';
import { FaRegCopy } from "react-icons/fa";

export default function OrganogramaPrevisaoAtual() {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [savingPopup, setSavingPopup] = useState(false);
    const [searchingNewFuncionarioToEdit, setSearchingNewFuncionarioToEdit] = useState(false);
    const [previousModal, setPreviousModal] = useState([]);
    const [modalCalcularPrevisao, setModalCalcularPrevisao] = useState(false);
    const [modalFilter, setModalFilter] = useState(false);
    const [modalAjustarEmMassa, setModalAjustarEmMassa] = useState(false);
    const [modalInconsistenciasDepartamentoFuncao, setModalInconsistenciasDepartamentoFuncao] = useState(false);
    const [modalFuncionariosFuncao, setModalFuncionariosFuncao] = useState(false);
    const [modalSelectVaga, setModalSelectVaga] = useState(false);
    const [modalFuncionarioToEdit, setModalFuncionarioToEdit] = useState(false);
    const [modalHistoricoFuncionario, setModalHistoricoFuncionario] = useState(false);
    const [modalNovoDepartamentoFuncao, setModalNovoDepartamentoFuncao] = useState(false);
    const [modalSalario, setModalSalario] = useState(false);
    const [modalHistoricoSalario, setModalHistoricoSalario] = useState(false);
    const [headerOrganograma, setHeaderOrganograma] = useState({});
    const [previsaoEscala, setPrevisaoEscala] = useState([]);
    const [previsaoNotFound, setPrevisaoNotFound] = useState(false);
    const [previsaoCalc, setPrevisaoCalc] = useState(false);
    const [vagasAberto, setVagasAberto] = useState(false);
    const [quantidadeVagasAberto, setQuantidadeVagasAberto] = useState(0);
    const [quantidadeFuncionariosSemEscala, setQuantidadeFuncionariosSemEscala] = useState(0);
    const [quantidadeFuncionariosDemitidos, setQuantidadeFuncionariosDemitidos] = useState(0);
    const [inconsistenciasDepartamentoFuncao, setInconsistenciasDepartamentoFuncao] = useState({});
    const [funcionariosModal, setFuncionariosModal] = useState({});
    const [funcionariosFuncao, setFuncionariosFuncao] = useState({});
    const [verLancamentosFuturos, setVerLancamentosFuturos] = useState(false);
    const [verLancamentosAnteriores, setVerLancamentosAnteriores] = useState(false);
    const [funcionarioVaga, setFuncionarioVaga] = useState({});
    const [selectVagas, setSelectVagas] = useState({});
    const [funcionarioToEdit, setFuncionarioToEdit] = useState({});
    const [historicoFuncionario, setHistoricoFuncionario] = useState({});
    const [historicoSalario, setHistoricoSalario] = useState({});
    const [inputSalarioHistorico, setInputSalarioHistorico] = useState([]);
    const [checkDissidioHistorico, setCheckDissidioHistorico] = useState([]);
    const [inputModalFuncionarioFuncionario, setInputModalFuncionarioFuncionario] = useState('');
    const [inputModalFuncionarioDepartamento, setInputModalFuncionarioDepartamento] = useState('');
    const [inputModalFuncionarioFuncao, setInputModalFuncionarioFuncao] = useState('');
    const [selectModalFuncionarioTipo, setSelectModalFuncionarioTipo] = useState({
        items: [
            { value: 0, label: "TODOS", icon: null, notSelected: false },
            { value: 1, label: "ESCALADOS E ATIVOS", icon: null, notSelected: false },
            { value: 6, label: "VAGAS EM ABERTO", icon: <BsFillSquareFill className={swalstyles.legendaiconvaga}/>, notSelected: false },
            { value: 2, label: "NÃO ESCALADOS (ADM)", icon: <BsFillSquareFill className={swalstyles.legendaiconadm}/>, notSelected: false },
            { value: 4, label: "NÃO ESCALADOS (AFASTADOS)", icon: <BsFillSquareFill className={swalstyles.legendaiconadm}/>, notSelected: false },
            { value: 5, label: "NÃO ESCALADOS (TRANSP/MEC/RURAL)", icon: <BsFillSquareFill className={swalstyles.legendaiconadm}/>, notSelected: false },
            { value: 3, label: "DEMITIDOS", icon: <BsFillSquareFill className={swalstyles.legendaicondem}/>, notSelected: false },
            { value: 245, label: "NÃO ESCALADOS", icon: null, notSelected: true },
        ],
        selectItem: null,
        enableChange: false,
    });
    const [selectModalInconsistenciaTipo, setSelectModalInconsistenciaTipo] = useState({
        items: [
            { value: 0, label: "TODAS AS INCONSISTÊNCIAS" },
            { value: 1, label: "INCONSISTÊNCIAS DE DEPARTAMENTO" },
            { value: 2, label: "INCONSISTÊNCIAS DE FUNÇÃO" },
            { value: 3, label: "INCONSISTÊNCIAS PERMITIDAS" },
        ],
        selectItem: 0,
    });
    const [searchingAjustarEmMassa, setSearchingAjustarEmMassa] = useState(false);
    const [savingAjustarEmMassa, setSavingAjustarEmMassa] = useState(false);
    const [ajustarEmMassa, setAjustarEmMassa] = useState([]);
    const [inputModalAjustarEmMassaFuncionario, setInputModalAjustarEmMassaFuncionario] = useState('');
    const [inputModalAjustarEmMassaIncludeVagas, setInputModalAjustarEmMassaIncludeVagas] = useState(false);
    const [selectModalAjustarEmMassaContrato, setSelectModalAjustarEmMassaContrato] = useState({
        items: [],
        selectItem: null,
    });
    const [selectModalAjustarEmMassaDepartamentoPrevisto, setSelectModalAjustarEmMassaDepartamentoPrevisto] = useState({
        items: [],
        selectItems: [],
    });
    const [selectModalAjustarEmMassaFuncaoPrevista, setSelectModalAjustarEmMassaFuncaoPrevista] = useState({
        items: [],
        selectItems: [],
    });
    const [selectModalAjustarEmMassaDepartamentoContrato, setSelectModalAjustarEmMassaDepartamentoContrato] = useState({
        items: [],
        selectItems: [],
    });
    const [selectModalAjustarEmMassaFuncaoContrato, setSelectModalAjustarEmMassaFuncaoContrato] = useState({
        items: [],
        selectItems: [],
    });
    const [inputModalAjustarEmMassaAdmissaoPrevIni, setInputModalAjustarEmMassaAdmissaoPrevIni] = useState('');
    const [inputModalAjustarEmMassaAdmissaoPrevFin, setInputModalAjustarEmMassaAdmissaoPrevFin] = useState('');
    const [inputModalAjustarEmMassaDemissaoPrevIni, setInputModalAjustarEmMassaDemissaoPrevIni] = useState('');
    const [inputModalAjustarEmMassaDemissaoPrevFin, setInputModalAjustarEmMassaDemissaoPrevFin] = useState('');
    const [inputAdmissaoAjustarEmMassa, setInputAdmissaoAjustarEmMassa] = useState('');
    const [inputDemissaoAjustarEmMassa, setInputDemissaoAjustarEmMassa] = useState('');
    const [selectCalculaRecisaoAjustarEmMassa, setSelectCalculaRecisaoAjustarEmMassa] = useState({
        items: [
            { id: 'cram_s', text: 'SIM', value: 0 },
            { id: 'cram_n', text: 'NÃO', value: 1 },
            { id: 'cram_na', text: 'NÃO ALTERAR', value: 3 },
        ],
        selectItem: 3,
    });
    const [selectFuncaoAjustarEmMassa, setSelectFuncaoAjustarEmMassa] = useState({
        items: [],
        selectItem: null,
    });
    const [selectDepartamentoAjustarEmMassa, setSelectDepartamentoAjustarEmMassa] = useState({
        items: [],
        selectItem: null,
    });
    const [selectPeriodoAjustarEmMassa, setSelectPeriodoAjustarEmMassa] = useState({
        items: [],
        selectItem: null,
    });
    const [selectTurnoAjustarEmMassa, setSelectTurnoAjustarEmMassa] = useState({
        items: [
            { value: 0, label: "A" },
            { value: 1, label: "B" },
            { value: 2, label: "C" },
        ],
        selectItem: null,
    });
    const [inputAtividadeAjustarEmMassa, setInputAtividadeAjustarEmMassa] = useState('');
    const [selectPeriodo, setSelectPeriodo] = useState({
        items: [],
        selectItem: null,
    });
    const [tipoDemissao, setTipoDemissao] = useState(null);
    const [inputDepartamento, setInputDepartamento] = useState('');
    const [inputFuncao, setInputFuncao] = useState('');
    const [selectStatus, setSelectStatus] = useState({
        items: [
            { value: 0, label: "EXIBIR TUDO", icon: null },
            { value: 1, label: "SEM SALÁRIO", icon: <MdOutlineMoneyOff className={[previsaostyles.filterselecticons, previsaostyles.iconerror].join(' ')} /> },
            { value: 2, label: "DIFERENÇAS", icon: <BsFillXCircleFill className={[previsaostyles.filterselecticons, previsaostyles.iconerror].join(' ')} /> },
            { value: 3, label: "INCONSISTÊNCIAS", icon: <BsFillExclamationCircleFill className={[previsaostyles.filterselecticons, previsaostyles.iconalert].join(' ')} /> },
            { value: 4, label: "SEM INCONSISTÊNCIAS", icon: <BsFillCheckCircleFill className={[previsaostyles.filterselecticons, previsaostyles.iconok].join(' ')} /> },
        ],
        selectItem: 0,
    });
    const [inputNewFuncionarioToEdit, setInputNewFuncionarioToEdit] = useState('');
    const [inputObservacaoToEdit, setInputObservacaoToEdit] = useState('');
    const [newFuncionarioToEdit, setNewFuncionarioToEdit] = useState({});
    const [selectDepartamentoHistorico, setSelectDepartamentoHistorico] = useState({
        items: [],
        selectItem: [],
    });
    const [selectFuncaoHistorico, setSelectFuncaoHistorico] = useState({
        items: [],
        selectItem: [],
    });
    const [selectTurnoHistorico, setSelectTurnoHistorico] = useState({
        items: [
            { value: 0, label: "A" },
            { value: 1, label: "B" },
            { value: 2, label: "C" },
        ],
        selectItem: [],
    });
    const [selectPeriodoHistorico, setSelectPeriodoHistorico] = useState({
        items: [],
        selectItem: [],
    });
    const [inputAtividadeHistorico, setInputAtividadeHistorico] = useState([]);
    const [inputQuantidadeHistorico, setInputQuantidadeHistorico] = useState([]);
    const [dataAdmToEdit, setDataAdmToEdit] = useState('');
    const [dataDemToEdit, setDataDemToEdit] = useState('');
    const [calculaRecisao, setCalculaRecisao] = useState(null);
    const [selectNovoDepartamento, setSelectNovoDepartamento] = useState({
        items: [],
        selectItem: null,
    });
    const [selectedDepartamento, setSelectedDepartamento] = useState({});
    const [listNovaFuncao, setListNovaFuncao] = useState({
        items: [],
        selectItem: null,
    });
    const [listedFuncao, setListedFuncao] = useState([]);
    const [listAgrupAgrupamento, setListAgrupAgrupamento] = useState({});
    const [etapaCalculo, setEtapaCalculo] = useState({
        items: [
            { value: 0, title: 'NÃO FOI POSSÍVEL CONCLUIR O PROCESSO!', text: 'É NECESSÁRIO CORRIGIR OS DADOS ANTES DE REALIZAR O CÁLCULO DA PREVISÃO.', isEtapa: false },
            { value: 1, title: 'INICIANDO PROCESSO.', url: 'iniciaCalculoFolha', isEtapa: true },
            { value: 2, title: 'VALIDANDO FUNCIONÁRIOS NÃO ESCALADOS OU DEMITIDOS.', url: 'validaVagasCalculoFolha', isEtapa: true },
            { value: 3, title: 'VALIDANDO INCONSISTÊNCIAS DE DEPARTAMENTO E FUNÇÃO.', url: 'validaInconsistenciasCalculoFolha', isEtapa: true },
            { value: 4, title: 'VALIDANDO SALÁRIOS MÍNIMOS.', url: 'validaSalarioMinimoCalculoFolha', isEtapa: true },
            { value: 5, title: 'VALIDANDO SALÁRIOS CADASTRADOS.', url: 'validaSalariosCalculoFolha', isEtapa: true },
            { value: 6, title: 'CALCULANDO PREVISÃO.', url: 'calculoFolhaByCenarioOrganograma', isEtapa: true },
            { value: 7, title: 'PROCESSO FINALIZADO!', text: 'O CÁLCULO DA PREVISÃO FOI CONCLUÍDO.', isEtapa: false },
        ],
        selectItem: null,
    });
    const [modalReiniciarFuncionarioVaga, setModalReiniciarFuncionarioVaga] = useState(false);
    const [organogramaReiniciarFuncionarioVaga, setOrganogramaReiniciarFuncionarioVaga] = useState({});
    const [idOrganogramaFuncionarioReiniciarFuncionarioVaga, setIdOrganogramaFuncionarioReiniciarFuncionarioVaga] = useState(null);
    const [excluirFuncionarioVagaCheckVagas, setExcluirFuncionarioVagaCheckVagas] = useState(false);
    const [selectVagasCheckPeriodo, setSelectVagasCheckPeriodo] = useState(true);

    const [selectInputValues, setSelectInputValues] = useState({});

    const keepInputOnSelect = (inputId, formatter) => (value, actionMeta) => {
        if (actionMeta.action === 'input-change') {
            const next = formatter ? formatter(value, actionMeta) : value;
            setSelectInputValues(prev => ({ ...prev, [inputId]: next }));
            return next; // mantém o texto digitado
        }
        // não limpar quando a opção é escolhida
        return selectInputValues[inputId] || '';
    };

    let history = useHistory();

    useEffect(() => {
        if(loading) {
            if(!history.location.state || (history.location.state && !history.location.state.hasAccess)) {
                history.push('/organograma');
            } else {
                const id_cenario_organograma = history.location.state && history.location.state.id_cenario_organograma ? history.location.state.id_cenario_organograma : '';
                const status_cenario_organograma = history.location.state && (history.location.state.status != null) ? history.location.state.status : '';

                api.get(`/previsao/getOrganograma?id_cenario_organograma=${id_cenario_organograma}&status_cenario_organograma=${status_cenario_organograma}&periodo=${selectPeriodo.selectItem || ''}`).then(function (response) {
                    if (response.data) {
                        if(response.data.error) {
                            console.log(`ERROR: ${response.data.error}`);
                        } else if(response.data.calc) {
                            setPrevisaoCalc(true);
                        } else {
                            if(response.data.organograma && response.data.organograma.length) {
                                setSelectPeriodo(response.data.periodo);
                                setHeaderOrganograma(response.data.headerOrganograma);
                                setPrevisaoEscala(AdjustShowDetails(previsaoEscala, response.data.organograma));
                                setQuantidadeVagasAberto(response.data.quantidadeVagasAberto);
                                setQuantidadeFuncionariosSemEscala(response.data.quantidadeFuncionariosSemEscala);
                                setQuantidadeFuncionariosDemitidos(response.data.quantidadeFuncionariosDemitidos);
                            } else {
                                setPrevisaoNotFound(true);
                            }

                            setLoading(false);
                        }
                    }
                }).catch(function (error) {
                    // handle error
                    alert(error);
                    console.log(error);
                });
            }
        }
    }, [loading]);

    useEffect(() => {
        if(modalFilter || modalSelectVaga || modalFuncionariosFuncao || modalFuncionarioToEdit || modalNovoDepartamentoFuncao || modalSalario || modalInconsistenciasDepartamentoFuncao || modalHistoricoFuncionario || modalHistoricoSalario || modalCalcularPrevisao || modalReiniciarFuncionarioVaga || modalAjustarEmMassa) {
            document.body.classList.add(swalstyles.blockbody);
        }
        else {
            document.body.classList.remove(swalstyles.blockbody);
        }
    }, [modalFilter, modalSelectVaga, modalFuncionariosFuncao, modalFuncionarioToEdit, modalNovoDepartamentoFuncao, modalSalario, modalInconsistenciasDepartamentoFuncao, modalHistoricoFuncionario, modalHistoricoSalario, modalCalcularPrevisao, modalReiniciarFuncionarioVaga, modalAjustarEmMassa]);

    useEffect(() => {
        if(previsaoCalc) {
            setModalFilter(false);
            setModalFuncionarioToEdit(false);
            setModalFuncionariosFuncao(false);
            setModalHistoricoFuncionario(false);
            setModalHistoricoSalario(false);
            setModalInconsistenciasDepartamentoFuncao(false);
            setModalNovoDepartamentoFuncao(false);
            setModalSalario(false);
            setModalCalcularPrevisao(false);
            clearPreviousModal();
        }
    }, [previsaoCalc]);

    useEffect(() => {
        if(etapaCalculo.selectItem != null && etapaCalculo.items.find(({ value }) => value === etapaCalculo.selectItem).isEtapa) {
            api.post(`/previsao/${etapaCalculo.items.find(({ value }) => value === etapaCalculo.selectItem).url}`, { id_cenario_organograma: headerOrganograma.id_cenario_organograma, id_empresa: headerOrganograma.id_empresa, data_filtro: headerOrganograma.data_filtro, data_inicial: headerOrganograma.data_inicial }).then(function (response) {
                if (response.data) {
                    if(response.data.error) {
                        console.log(`ERROR: ${response.data.error}`);
    
                        Swal.fire({
                            customClass: {
                                container: swalstyles.swalcontainer,
                                popup: swalstyles.swalbackground
                            },
                            title: 'UM ERRO INESPERADO ACONTECEU!',
                            text: 'POR FAVOR CONTATE UM ADMINISTRADOR DO SISTEMA',
                            icon: 'error',
                        });

                        setSaving(false);
                        setEtapaCalculo(handleSelectValue(null, etapaCalculo));
                    } else if(response.data.calc) {
                        setSaving(false);
                        resetCalcularPrevisao();
                        setPrevisaoCalc(true);
                    } else if(response.data.alertMessage.length) {
                        Swal.fire({
                            customClass: {
                                container: swalstyles.swalcontainer,
                                popup: swalstyles.swalbackground
                            },
                            title: 'UM ERRO INESPERADO ACONTECEU!',
                            html: response.data.alertMessage.join('<br />'),
                            icon: 'warning',
                        });
    
                        handleNextCalcularPrevisao(true);
                    } else {
                        handleNextCalcularPrevisao();
                    }
                }
            }).catch(error => {
                // handle error
                alert(error);
                console.log(error);
            });
        } else {
            setSaving(false);
            setLoading(true);
        }
    }, [etapaCalculo]);

    // useEffect(() => {
    //     console.log(previousModal);
    // }, [previousModal]);

    function AdjustShowDetails(previsaoEscalaAtual, previsaoEscalaNova) {
        if(previsaoEscalaAtual.length) {
            previsaoEscalaAtual.filter(({ show_details }) => show_details).forEach(prevAtual => {
                let findedIndex = previsaoEscalaNova.findIndex(prevNova => prevNova.departamento.id === prevAtual.departamento.id);

                if(findedIndex !== -1) {
                    previsaoEscalaNova[findedIndex].show_details = true;
                }
            });
        }

        return previsaoEscalaNova;
    }

    function pushPreviousModal(data) {
        const newPrevious = Object.assign([], previousModal);
        newPrevious.push(data);
        
        setPreviousModal(newPrevious);
    }

    function popPreviousModal(doublePop) {
        const newPrevious = Object.assign([], previousModal);
        newPrevious.pop();
        
        if(doublePop) {
            newPrevious.pop();
        }
        
        setPreviousModal(newPrevious);
    }

    function clearPreviousModal() {
        setPreviousModal([]);
        setLoading(true);
    }

    function searchFuncionarioByMatricula(matricula) {
        if(matricula) {
            setSearchingNewFuncionarioToEdit(true);

            api.get(`/previsao/getNaoEscaladosByMatricula?id_cenario_organograma=${headerOrganograma.id_cenario_organograma}&id_empresa=${headerOrganograma.id_empresa}&matricula=${matricula}`).then(function (response) {
                if (response.data) {
                    if(response.data.error) {
                        console.log(`ERROR: ${response.data.error}`);
                    } else if(response.data.calc) {
                        setPrevisaoCalc(true);
                    } else {
                        if(response.data.newFuncionario) {
                            setNewFuncionarioToEdit(response.data.newFuncionario);
                        }

                        setSearchingNewFuncionarioToEdit(false);
                    }
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            });
        }
    }

    function setBlurOnKeyDown(e) {
        if(e.key === 'Enter') {
            e.target.blur();
        }
    }

    function onlyNumbers(value) {
        return value.replace(/[^0-9]/g, '');
    }

    function floatValue(value, isMonetary) {
        const isInt = !(/[.,]/g).test(value);
        const numLenght = isMonetary ? 8 : 5;

        const price = onlyNumbers(value).slice(0, numLenght) || '0';
        
        if(isInt) {
            return parseFloat(price);
        } else {
            return parseFloat(price.slice(0, (price.length - 2)) + '.' + price.slice(price.length - 2));
        }
    }

    function handleAjustarEmMassa() {
        api.get(`/previsao/getFiltersAjustarEmMassa?id_cenario_organograma=${headerOrganograma.id_cenario_organograma}&id_empresa=${headerOrganograma.id_empresa}`).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else {
                    if(response.data.tiposContrato) {
                        let newItemsTipoContrato = [{value: null, label: 'TODOS OS TIPOS DE CONTRATO'}, ...response.data.tiposContrato];
                        setSelectModalAjustarEmMassaContrato({ items: newItemsTipoContrato, selectItem: null });
                    }
                    if(response.data.departamentosPrevisto) {
                        let newItemsDepartamentosPrevisto = [{value: null, label: 'TODOS OS DEPARTAMENTOS PREVISTOS'}, ...response.data.departamentosPrevisto];
                        setSelectModalAjustarEmMassaDepartamentoPrevisto({ items: newItemsDepartamentosPrevisto, selectItems: [null] });
                        setSelectDepartamentoAjustarEmMassa({ items: response.data.departamentosPrevisto, selectItem: null });
                    }
                    if(response.data.funcoesPrevista) {
                        let newItemsFuncoesPrevista = [{value: null, label: 'TODAS AS FUNÇÕES PREVISTAS'}, ...response.data.funcoesPrevista];
                        setSelectModalAjustarEmMassaFuncaoPrevista({ items: newItemsFuncoesPrevista, selectItems: [null] });
                        setSelectFuncaoAjustarEmMassa({ items: response.data.funcoesPrevista, selectItem: null });
                    }
                    if(response.data.departamentosContrato) {
                        let newItemsDepartamentosContrato = [{value: null, label: 'TODOS OS DEPARTAMENTOS DE CONTRATO'}, ...response.data.departamentosContrato];
                        setSelectModalAjustarEmMassaDepartamentoContrato({ items: newItemsDepartamentosContrato, selectItems: [null] });
                    }
                    if(response.data.funcoesContrato) {
                        let newItemsFuncoesContrato = [{value: null, label: 'TODAS AS FUNÇÕES DE CONTRATO'}, ...response.data.funcoesContrato];
                        setSelectModalAjustarEmMassaFuncaoContrato({ items: newItemsFuncoesContrato, selectItems: [null] });
                    }
                    if(response.data.periodos) {
                        setSelectPeriodoAjustarEmMassa({ items: response.data.periodos, selectItem: null });
                    }
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        });

        setModalAjustarEmMassa(true);
    }

    function handleInconsistenciasDepartamentoFuncao(selectModalInconsistenciasTip, inputModalFuncionarioDpto, inputModalFuncionarioFun) {
        setInputModalFuncionarioDepartamento(inputModalFuncionarioDpto || '');
        setInputModalFuncionarioFuncao(inputModalFuncionarioFun || '');
        setSelectModalInconsistenciaTipo(handleSelectValue(selectModalInconsistenciasTip || 0, selectModalInconsistenciaTipo));
        
        api.get(`/previsao/getInconsistenciasDptoFuncao?id_cenario_organograma=${headerOrganograma.id_cenario_organograma}&id_empresa=${headerOrganograma.id_empresa}&data_filtro=${headerOrganograma.data_filtro}`).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else {
                    if(response.data.inconsistenciasDptoFuncao) {
                        setInconsistenciasDepartamentoFuncao({
                            imported: true,
                            data: response.data.inconsistenciasDptoFuncao
                        });
                    }
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        });

        setModalInconsistenciasDepartamentoFuncao(true);
    }

    function pesquisarFuncionarios(tipo) {
        setFuncionariosModal({});

        api.get(`/previsao/getFuncionarios?id_cenario_organograma=${headerOrganograma.id_cenario_organograma}&id_empresa=${headerOrganograma.id_empresa}&data_filtro=${selectPeriodo.selectItem}&tipo=${tipo}&data_inicial=${headerOrganograma.data_inicial}`).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else {
                    if(response.data.pesquisaFuncionarios) {
                        setFuncionariosModal({
                            imported: true,
                            data: response.data.pesquisaFuncionarios
                        });
                    }
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        });
    }

    function handlePesquisarFuncionarios(selectModalFuncionarioTip, enableChange, inputModalFuncionarioFunc, inputModalFuncionarioDpto, inputModalFuncionarioFun) {
        setInputModalFuncionarioFuncionario(inputModalFuncionarioFunc || '');
        setInputModalFuncionarioDepartamento(inputModalFuncionarioDpto || '');
        setInputModalFuncionarioFuncao(inputModalFuncionarioFun || '');
        setSelectModalFuncionarioTipo(handleSelectValueFuncionarioTipo(selectModalFuncionarioTip, enableChange, selectModalFuncionarioTipo));

        pesquisarFuncionarios(selectModalFuncionarioTip);

        setModalFilter(true);
    }

    function handleVagasEmAberto() {
        setInputDepartamento('');
        setInputFuncao('');
        setSelectStatus(handleSelectValue(0, selectStatus));
        setVagasAberto(!vagasAberto);
    }

    function regexTextoAproximado(baseText, validator) {
        const validText = validator.replace(/([.?*+^~$[\]\\(){}|-])/gi, "\\$1");
        const regex = new RegExp(`${validText}`, 'gi');
        
        return regex.test(baseText);
    }

    function regexMaskDepartamento(departamento) {
        if((/^[0-9.]+$/g).test(departamento)) {
            const regex = (departamento.length < 8) ? /^(\d{3})(\d{1,3})/ : /^(\d{3})\.(\d{3})(\d{1,3})/;
            const regexText = (departamento.length < 8) ? '$1.$2' : '$1.$2.$3';

            return departamento.replace(regex, regexText);
        } else {
            return departamento;
        }
    }

    function regexMaskData(e) {
        const data = e.target.value.replace(/[^0-9]/g, '');
        const regex = (data.length < 5) ? /^(\d{2})(\d{1,2})/ : /^(\d{2})(\d{2})(\d{1,4})/;
        const regexText = (data.length < 5) ? '$1/$2' : '$1/$2/$3';

        return data.replace(regex, regexText).slice(0, 10);
    }

    function completeDataAdm() {
        if(dataAdmToEdit.length < 10 && moment(dataAdmToEdit, 'DD MM YYYY').isValid()) {
            setDataAdmToEdit(moment(dataAdmToEdit, 'DD MM YYYY').format('DD/MM/YYYY'));
        }
    }

    function completeDataDem() {
        if(dataDemToEdit.length < 10 && moment(dataDemToEdit, 'DD MM YYYY').isValid()) {
            setDataDemToEdit(moment(dataDemToEdit, 'DD MM YYYY').format('DD/MM/YYYY'));
        }
    }

    function handlePopupShow(e) {
        if(e.type === 'mouseenter') {
            e.currentTarget.parentElement.children[0].classList.add(swalstyles.popupshow);
        } else {
            e.currentTarget.parentElement.children[0].classList.remove(swalstyles.popupshow);
        }
    }

    function handleToastShow(message) {
        Swal.fire({
            customClass: {
                container: swalstyles.swaltoastconteiner,
                popup: swalstyles.swaltoastpopup,
                htmlContainer: swalstyles.swaltoasttext,
                icon: swalstyles.swaltoasticon,
                timerProgressBar: swalstyles.swaltoastprogressbar,
            },
            position: 'top-right',
            toast: true,
            text: message,
            timer: 5000,
            timerProgressBar: true,
            showConfirmButton: false,
            icon: 'info',
        });
    }

    function handleToastShowHtml(objHtml) {
        Swal.fire({
            customClass: {
                container: swalstyles.swaltoastconteiner,
                popup: swalstyles.swaltoastpopup,
                htmlContainer: swalstyles.swaltoasttext,
                icon: swalstyles.swaltoasticon,
                timerProgressBar: swalstyles.swaltoastprogressbar,
            },
            position: 'top-right',
            html: renderToString(objHtml),
            toast: true,
            timer: 10000,
            timerProgressBar: true,
            showConfirmButton: false,
            icon: 'info',
        });
    }

    function handleSelectValue(value, obj, isString = false, isArray = false) {
        const objselected = Object.assign([], obj);

        if(isArray) {
            if(!value || !value.length) {
                objselected.selectItems = [null];
            } else {
                objselected.selectItems = value.map(({ value }) => isString ? value : parseInt(value));
            }
        } else if(!isString && (value || value === 0)) {
            objselected.selectItem = parseInt(value);
        } else {
            objselected.selectItem = value;
        }

        return objselected;
    }

    function handleSelectMultipleValue(value, obj, index) {
        const objselected = Object.assign([], obj);

        if(value || value === 0) {
            objselected.selectItem[index] = parseInt(value);
        } else {
            objselected.selectItem[index] = value;
        }

        return objselected;
    }

    function handleSelectDepartamento(value, index) {
        let selected = null;

        if(selectFuncaoHistorico.selectItem[index] != null) {
            selected = selectFuncaoHistorico.items.find(({ id, id_departamento }) =>
                id === selectFuncaoHistorico.items.find(funcao => funcao.value === selectFuncaoHistorico.selectItem[index]).id
                && id_departamento === selectDepartamentoHistorico.items.find(departamento => departamento.value === value).id
            );
        }
        
        if(!selected && historicoFuncionario.historico[index].id) {
            selected = selectFuncaoHistorico.items.find(({ id, id_departamento }) =>
                id === historicoFuncionario.historico[index].organograma.funcao.id
                && id_departamento === selectDepartamentoHistorico.items.find(departamento => departamento.value === value).id
            );
        }

        if(!selected && index > 0 && selectFuncaoHistorico.selectItem[index-1] != null) {
            selected = selectFuncaoHistorico.items.find(({ id, id_departamento }) =>
                id === selectFuncaoHistorico.items.find(funcao => funcao.value === selectFuncaoHistorico.selectItem[index-1]).id
                && id_departamento === selectDepartamentoHistorico.items.find(departamento => departamento.value === value).id
            );
        }
        
        if(!selected && historicoFuncionario.funcionario.id) {
            selected = selectFuncaoHistorico.items.find(({ id, id_departamento }) =>
                id === historicoFuncionario.funcionario.funcao.id
                && id_departamento === selectDepartamentoHistorico.items.find(departamento => departamento.value === value).id
            );
        }

        setSelectDepartamentoHistorico(handleSelectMultipleValue(value, selectDepartamentoHistorico, index));
        setSelectFuncaoHistorico(handleSelectMultipleValue(selected ? selected.value : null, selectFuncaoHistorico, index));
    }

    function handleInputAtividade(value, index) {
        const obj = Object.assign([], inputAtividadeHistorico);
        const newValue = parseInt(onlyNumbers(value).toString().slice(0, 8));

        obj[index] = newValue >= 0 ? newValue : null;

        setInputAtividadeHistorico(obj);
    }

    function handleInputQuantidade(value, index, required) {
        const obj = Object.assign([], inputQuantidadeHistorico);
        const newValue = floatValue(value, false);

        obj[index] = required && newValue === 0 ? 1.00 : newValue;

        setInputQuantidadeHistorico(obj);
    }

    function handleInputSalario(value, index) {
        const obj = Object.assign([], inputSalarioHistorico);

        obj[index] = floatValue(value, historicoSalario.agrupamento.tipo);

        setInputSalarioHistorico(obj);
    }

    function handleCheckDissidio(index, deleteBlocked) {
        if(!deleteBlocked){
            const obj = Object.assign([], checkDissidioHistorico);

            obj[index] = !checkDissidioHistorico[index];

            setCheckDissidioHistorico(obj);
        }
    }

    function handleSelectValueFuncionarioTipo(value, enableChange, obj) {
        const objselected = Object.assign([], obj);

        if(value || value === 0) {
            objselected.selectItem = parseInt(value);
        } else {
            objselected.selectItem = value;
        }

        objselected.enableChange = enableChange;

        return objselected;
    }

    function handleShowDetails(id_departamento) {
        let escala = Object.assign([], previsaoEscala);
        let findedIndex = previsaoEscala.findIndex(({ departamento }) => departamento.id === id_departamento);

        escala[findedIndex].show_details = !escala[findedIndex].show_details;

        setPrevisaoEscala(escala);
    }

    const handleInputMaskDepartamento = (value, { action }) => {
        if(action === 'input-change') {
            return regexMaskDepartamento(value);
        } else {
            return value;
        }
    }

    function getOptions(options, inputValue, selectedOptions) {
        return options.filter(option => FilterOptions(option, inputValue) && !selectedOptions.some(selected => selected === option.value));
    }

    const SelectAllMenu = (selectedOptions) => (props) => {
        const filteredOptions = getOptions(props.options, props.selectProps.inputValue, selectedOptions);
        
        return (
            <components.Menu {...props}>
                <div style={{ padding: '2px 4px', fontSize: '10px', fontWeight: 'bold', color: '#001affff', cursor: 'pointer', borderBottom: '1px solid #ccc' }}
                    onClick={() => { props.setValue(filteredOptions); }}
                >
                    SELECIONAR TODOS ({filteredOptions.length})
                </div>
                {props.children}
            </components.Menu>
        );
    };

    const Option = ({children, ...props}) => {
        if(['select_status', 'select_tipo', 'select_tipo_inconsistencia'].includes(props.selectProps.inputId)) {
            return (
                <components.Option {...props}>
                    <div className={previsaostyles.filteroptions}>
                        <div className={previsaostyles.filteroptions}>
                            {props.data.label}
                        </div>
                        <div className={[previsaostyles.filteroptions, previsaostyles.filteroptionright].join(' ')}>
                            {props.data.icon}
                        </div>
                    </div>
                </components.Option>
            )
        } else if(['select_periodo', 'select_filter_contrato', 'select_filter_departamento_previsto', 'select_filter_departamento_contrato', 'select_filter_funcao_prevista', 'select_filter_funcao_contrato', 'select_novo_departamento', 'select_nova_funcao', 'select_historico_departamento', 'select_historico_funcao', 'select_historico_turno', 'select_historico_periodo', 'select_funcao_prevista_ajuste_em_massa', 'select_departamento_prevista_ajuste_em_massa', 'select_periodo_ajuste_em_massa', 'select_turno_ajuste_em_massa'].includes(props.selectProps.inputId)) {
            return (
                <components.Option {...props}>
                    <div className={previsaostyles.filteroptionstoedit}>
                        <div>{props.data.label}</div>
                    </div>
                </components.Option>
            )
        }
    }

    const ValueContainerWithMaxLabels = (maxLabelsToShow) => ({ children, ...props }) => {
        const currentValues = props.getValue();
        const overflow = currentValues.length > maxLabelsToShow;

        const childArray = React.Children.toArray(children);
        const inputChild = childArray.find((child) => child.type === components.Input);
        const valueChildren = childArray.filter((child) => child !== inputChild);

        const limitedValues = valueChildren.filter((child, i) => {
            if (child.type === components.MultiValue && i >= maxLabelsToShow) {
                return false;
            }
            return true;
        });

        return (
            <components.ValueContainer {...props}>
                {limitedValues}
                {overflow && (
                    <div style={{ fontSize: '11px', fontWeight: 700, backgroundColor: 'hsl(0, 0%, 90%)', padding: '2px 4px', borderRadius: '2px', margin: '2px' }}>
                        +{currentValues.length - maxLabelsToShow}
                    </div>
                )}
                {inputChild}
            </components.ValueContainer>
        );
    }

    // Memoized factory: returns the same ValueContainer instance per maxLabelsToShow
    const getValueContainerWithMaxLabels = useMemo(() => {
        const cache = {};

        return (maxLabelsToShow) => {
            if(!cache[maxLabelsToShow]) {
                cache[maxLabelsToShow] = ValueContainerWithMaxLabels(maxLabelsToShow);
            }
            return cache[maxLabelsToShow];
        };
    }, []);

    const SingleValue = ({children, ...props}) => {
        return (
            <components.SingleValue {...props}>
                <div className={previsaostyles.filteroptions}>
                    <div className={props.data.icon ? [previsaostyles.filteroptions, previsaostyles.filteroptionleft].join(' ') : previsaostyles.filteroptions}>
                        {props.data.icon}
                    </div>
                    <div className={[previsaostyles.filteroptions, previsaostyles.filteroptionright].join(' ')}>
                        {props.data.label}
                    </div>
                </div>
            </components.SingleValue>
        )
    }

    const MultiValueLabel = ({children, ...props}) => {
        return (
            <components.MultiValueLabel {...props}>
                <div title={props.data.label}
                    style={{ fontSize: '10px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    ...(props.data.value != null ? { maxWidth: '130px' } : undefined) }}
                >
                    {children}
                </div>
            </components.MultiValueLabel>
        )
    }

    function FilterOptions(candidate, input) {
        return candidate.label.toLowerCase().includes(input.toLowerCase());
    }

    function Theme(theme) {
        return ({
            ...theme,
            colors: {
                ...theme.colors,
                primary: '#d4d4d4', // CHOOSED
                primary50: '#e7e7e7', // CLICK
                primary25: '#f3f3f3', // HOVER
            }
        })
    }

    function renderPopupDetailsSalarioDiv(html, htmlClass) {
        if(html.length) {
            return (
                <div className={htmlClass}>
                    {html}
                </div>
            )
        }
    }

    function renderPopupDetailsSalario(title, values, quantidadesFuncionariosVagas) {
        let objValues = [];
        let objValuesAdd = [];
        let objValuesSub = [];

        values.forEach(({ text, value, awaysShow, add, sub }, index) => {
            if(value || awaysShow) {
                if(quantidadesFuncionariosVagas) {
                    if(quantidadesFuncionariosVagas.quantidade_funcionarios) {
                        objValues.push(
                            <div key={0}>
                                <div className={swalstyles.popupdetaislsalariobodytext}>
                                    <div className={swalstyles.popupdetaislsalariobodyhideplus}>+</div>
                                    {(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} x {Number.isInteger(quantidadesFuncionariosVagas.quantidade_funcionarios) ? quantidadesFuncionariosVagas.quantidade_funcionarios.toFixed(0) : quantidadesFuncionariosVagas.quantidade_funcionarios.toFixed(2)} {quantidadesFuncionariosVagas.quantidade_funcionarios === 1 ? 'funcionário' : 'funcionários'}
                                </div>
                            </div>
                        );
                    }
                    if(quantidadesFuncionariosVagas.quantidade_vagas) {
                        objValues.push(
                            <div key={1}>
                                <div className={swalstyles.popupdetaislsalariobodytext}>
                                    <div className={!objValues.length ? swalstyles.popupdetaislsalariobodyhideplus : null}>+</div>
                                    {(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} x {Number.isInteger(quantidadesFuncionariosVagas.quantidade_vagas) ? quantidadesFuncionariosVagas.quantidade_vagas.toFixed(0) : quantidadesFuncionariosVagas.quantidade_vagas.toFixed(2)} {quantidadesFuncionariosVagas.quantidade_vagas === 1 ? 'vaga' : 'vagas'}
                                </div>
                            </div>
                        );
                    }
                } else {
                    if(add) {
                        objValuesAdd.push(
                            <div key={index}>
                                <div className={swalstyles.popupdetaislsalariobodytext}>
                                    <div>+</div>
                                    <div>{text}</div>
                                </div>
                                <div className={swalstyles.popupdetaislsalariobodyvalue}>{(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                            </div>
                        );
                    } else if(sub) {
                        objValuesSub.push(
                            <div key={index}>
                                <div className={swalstyles.popupdetaislsalariobodytext}>
                                    <div>-</div>
                                    <div>{text}</div>
                                </div>
                                <div className={swalstyles.popupdetaislsalariobodyvalue}>{(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                            </div>
                        );
                    } else {
                        objValues.push(
                            <div key={index}>
                                <div className={swalstyles.popupdetaislsalariobodytext}>
                                    <div className={!objValues.length ? swalstyles.popupdetaislsalariobodyhideplus : ''}>+</div>
                                    <div>{text}</div>
                                </div>
                                <div className={swalstyles.popupdetaislsalariobodyvalue}>{(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                            </div>
                        );
                    }
                }
            }
        });

        return (
            <div className={swalstyles.popupdetaislsalario}>
                <div className={swalstyles.popupdetaislsalariotitle}>{title}</div>
                {renderPopupDetailsSalarioDiv(!objValues.length && !objValuesAdd.length && !objValuesSub.length ? 'Nada Informado!' : '', swalstyles.popupdetaislsalariobody)}
                {renderPopupDetailsSalarioDiv(objValues, swalstyles.popupdetaislsalariobody)}
                {renderPopupDetailsSalarioDiv(objValuesAdd, objValues.length && objValuesAdd.length ? [swalstyles.popupdetaislsalariobody, swalstyles.popupdetaislsalariobodyadd].join(' ') : '')}
                {renderPopupDetailsSalarioDiv(objValuesSub, (objValues.length || objValuesAdd.length) && objValuesSub.length ? [swalstyles.popupdetaislsalariobody, swalstyles.popupdetaislsalariobodyadd].join(' ') : '')}
            </div>
        )
    }

    function resetModalInconsistenciasDepartamentoFuncao() {
        setModalInconsistenciasDepartamentoFuncao(false);
        setInconsistenciasDepartamentoFuncao({});
        setInputModalFuncionarioDepartamento('');
        setInputModalFuncionarioFuncao('');
        setSelectModalInconsistenciaTipo(handleSelectValue(0, selectModalInconsistenciaTipo));
    }

    function closeModalInconsistenciasDepartamentoFuncao() {
        resetModalInconsistenciasDepartamentoFuncao();

        clearPreviousModal();
    }

    function nextModalInconsistenciasDepartamentoFuncao(funcionario) {
            pushPreviousModal({modalName: 'inconsistenciasDepartamentoFuncao', selectModalInconsistenciaTip: selectModalInconsistenciaTipo.selectItem, inputModalFuncionarioDpto: inputModalFuncionarioDepartamento, inputModalFuncionarioFun: inputModalFuncionarioFuncao});

            resetModalInconsistenciasDepartamentoFuncao();

            handleExibirFuncionarioToEdit(funcionario);
    }

    function renderFilterTipoInconsistenciaDepartamentoFuncao() {
        return (
            <Select
                inputId='select_tipo_inconsistencia'
                value={selectModalInconsistenciaTipo.items.find(({ value }) => value === selectModalInconsistenciaTipo.selectItem)}
                options={selectModalInconsistenciaTipo.items}
                components={{ Option, SingleValue }}
                filterOption={FilterOptions}
                onChange={(e) => setSelectModalInconsistenciaTipo(handleSelectValue(e.value, selectModalInconsistenciaTipo))}
                theme={Theme}
                noOptionsMessage={() => "Nenhuma Opção"}
                className={previsaostyles.filterselect}
                menuPosition='absolute'
            />
        )
    }

    function renderFilterInconsistenciasDepartamentoFuncao() {
        return (
            <div className={swalstyles.conteinerfilterlistfuncionarios}>
                <div className={swalstyles.filterlistfuncionarios}>
                    <div className={swalstyles.legendainconsistenciasdepartamentofuncao}>
                        <div className={swalstyles.legendainconsistenciasdepartamentofuncaoprevisto}>&#11044; Previsto</div>
                        <div className={swalstyles.legendainconsistenciasdepartamentofuncaocontratado}>&#11044; Contratado</div>
                    </div>
                    {renderFilterTipoInconsistenciaDepartamentoFuncao()}
                </div>
                <div className={swalstyles.filterlistfuncionarios}>
                    <input
                        className={swalstyles.inputfilterlistfuncionarios}
                        type='text'
                        placeholder='Digite o código ou descrição do departamento'
                        value={inputModalFuncionarioDepartamento}
                        onChange={(e) => setInputModalFuncionarioDepartamento(regexMaskDepartamento(e.target.value))}
                    />
                    <input
                        className={swalstyles.inputfilterlistfuncionarios}
                        type='text'
                        placeholder='Digite o código ou descrição da função'
                        value={inputModalFuncionarioFuncao}
                        onChange={(e) => setInputModalFuncionarioFuncao(e.target.value)}
                    />
                </div>
            </div>
        )
    }

    function renderInconsistenciaDepartamento(funcionario) {
        if(funcionario.organograma.departamento.id === funcionario.departamento.id || funcionario.id == null || funcionario.inconsistencia.inconsistencia_permitida) {
            return (
                <div className={swalstyles.bodylistfuncionariosdescricaoinconsistecias}>
                    <div className={swalstyles.bodylistfuncionariosdescricaodepartamento}>
                        {`${funcionario.organograma.departamento.codigo} - ${funcionario.organograma.departamento.descricao}`}
                    </div>
                </div>
            )
        } else {
            return (
                <div className={swalstyles.bodylistfuncionariosdescricaoinconsistecias}>
                    <div className={[swalstyles.bodylistfuncionariosdescricaodepartamento, swalstyles.legendainconsistenciasdepartamentofuncaoprevisto].join(' ')}>
                        {`${funcionario.organograma.departamento.codigo} - ${funcionario.organograma.departamento.descricao}`}
                    </div>
                    <div className={[swalstyles.bodylistfuncionariosdescricaodepartamento, swalstyles.legendainconsistenciasdepartamentofuncaocontratado].join(' ')}>
                        {`${funcionario.departamento.codigo} - ${funcionario.departamento.descricao}`}
                    </div>
                </div>
            )
        }
    }

    function renderInconsistenciaFuncao(funcionario) {
        if(funcionario.organograma.funcao.id === funcionario.funcao.id || funcionario.id == null || funcionario.inconsistencia.inconsistencia_permitida) {
            return (
                <div className={swalstyles.bodylistfuncionariosdescricaoinconsistecias}>
                    <div className={swalstyles.bodylistfuncionariosdescricaofuncao}>
                        {`${funcionario.organograma.funcao.codigo} - ${funcionario.organograma.funcao.descricao}`}
                    </div>
                </div>
            )
        } else {
            return (
                <div className={swalstyles.bodylistfuncionariosdescricaoinconsistecias}>
                    <div className={[swalstyles.bodylistfuncionariosdescricaofuncao, swalstyles.legendainconsistenciasdepartamentofuncaoprevisto].join(' ')}>
                        {`${funcionario.organograma.funcao.codigo} - ${funcionario.organograma.funcao.descricao}`}
                    </div>
                    <div className={[swalstyles.bodylistfuncionariosdescricaofuncao, swalstyles.legendainconsistenciasdepartamentofuncaocontratado].join(' ')}>
                        {`${funcionario.funcao.codigo} - ${funcionario.funcao.descricao}`}
                    </div>
                </div>
            )
        }
    }

    function handlePermitirNegarInconsistenciaDepartamentoFuncao(id_organograma_funcionario_historico, inconsistencia, index) {
        // Swal.fire({
        //     customClass: {
        //         container: swalstyles.swalcontainer,
        //         popup: swalstyles.swalbackground
        //     },
        //     text: `DESEJA REALMENTE ${inconsistencia.inconsistencia_permitida ? 'REVOGAR A PERMISSÃO DESSA' : 'PERMITIR ESSA'} INCONSISTÊNCIA?`,
        //     confirmButtonText: 'CONFIRMAR', 
        //     focusDeny: true,
        //     showDenyButton: true,
        //     denyButtonText: 'CANCELAR',
        //     allowOutsideClick: false,
        // }).then(result => {
        //     if(result.isConfirmed) {
                let newInconsistencias =  inconsistenciasDepartamentoFuncao.data;

                newInconsistencias[index].inconsistencia.update = true;

                setInconsistenciasDepartamentoFuncao({
                    imported: inconsistenciasDepartamentoFuncao.imported,
                    data: newInconsistencias,
                });

                const body = {
                    id_organograma_funcionario_historico: id_organograma_funcionario_historico,
                    id_inconsistencia: inconsistencia.id,
                    new_inconsistencia_permitida: inconsistencia.inconsistencia_permitida ? 0 : 1,
                    id_cenario_organograma: headerOrganograma.id_cenario_organograma,
                    id_empresa: headerOrganograma.id_empresa,
                    data_filtro: selectPeriodo.selectItem,
                }

                api.post(`/previsao/salvarInconsistenciaDptoFuncao`, body).then(function (response) {
                    if (response.data) {
                        if(response.data.error) {
                            console.log(`ERROR: ${response.data.error}`);
                        } else if(response.data.calc) {
                            setPrevisaoCalc(true);
                        } else {
                            if(response.data.inconsistenciasDptoFuncao) {
                                setInconsistenciasDepartamentoFuncao({
                                    imported: true,
                                    data: response.data.inconsistenciasDptoFuncao
                                });
                            }
                        }
                    }
                }).catch(function (error) {
                    // handle error
                    alert(error);
                    console.log(error);
                });
        //     }
        // });
    }

    function renderIconInconsistenciaDepartamentoFuncao(funcionario, index) {
        if(funcionario.inconsistencia.update) {
            return (
                <div className={swalstyles.conteinerpopup}>
                    <div className={[loadingstyles.divloading, loadingstyles.divloadingmargin0].join(' ')}>
                        <div className={[loadingstyles.loading, loadingstyles.loading20px].join(' ')}></div>
                    </div>
                </div>
            )
        } else if(funcionario.inconsistencia.inconsistencia_permitida) {
            return (
                <div className={swalstyles.conteinerpopup}>
                    <span className={[swalstyles.popup, swalstyles.index1].join(' ')}>Revogar</span>
                    <div className={[swalstyles.conteinericoninconsistenciadepartamentofuncao, swalstyles.conteinericoninconsistenciadepartamentofuncaotrue].join(' ')}
                        onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)} onClick={() => handlePermitirNegarInconsistenciaDepartamentoFuncao(funcionario.organograma_funcionario.id_historico_atual, funcionario.inconsistencia, index)}
                    >
                        <TiTickOutline className={[swalstyles.iconinconsistenciadepartamentofuncao, swalstyles.iconinconsistenciadepartamentofuncaotrue].join(' ')} />
                    </div>
                </div>
            )
        } else {
            return (
                <div className={swalstyles.conteinerpopup}>
                    <span className={[swalstyles.popup, swalstyles.index1].join(' ')}>Permitir</span>
                    <div className={[swalstyles.conteinericoninconsistenciadepartamentofuncao, swalstyles.conteinericoninconsistenciadepartamentofuncaofalse].join(' ')}
                        onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)} onClick={() => handlePermitirNegarInconsistenciaDepartamentoFuncao(funcionario.organograma_funcionario.id_historico_atual, funcionario.inconsistencia, index)}
                    >
                        <TiTickOutline className={[swalstyles.iconinconsistenciadepartamentofuncao, swalstyles.iconinconsistenciadepartamentofuncaofalse].join(' ')} />
                    </div>
                </div>
            )
        }
    }

    function renderFuncionariosModalInconsistenciasDepartamentoFuncao() {
        if(inconsistenciasDepartamentoFuncao.data.length) {
            return (
                inconsistenciasDepartamentoFuncao.data.map((funcionario, index) => {
                    if(
                        (
                            regexTextoAproximado((funcionario.organograma.departamento.codigo), inputModalFuncionarioDepartamento) ||
                            regexTextoAproximado((funcionario.departamento.codigo), inputModalFuncionarioDepartamento) ||
                            regexTextoAproximado((funcionario.organograma.departamento.descricao), inputModalFuncionarioDepartamento) ||
                            regexTextoAproximado((funcionario.departamento.descricao), inputModalFuncionarioDepartamento)
                        ) &&
                        (
                            regexTextoAproximado((funcionario.organograma.funcao.codigo), inputModalFuncionarioFuncao) ||
                            regexTextoAproximado((funcionario.funcao.codigo), inputModalFuncionarioFuncao) ||
                            regexTextoAproximado((funcionario.organograma.funcao.descricao), inputModalFuncionarioFuncao) ||
                            regexTextoAproximado((funcionario.funcao.descricao), inputModalFuncionarioFuncao)
                        ) &&
                        (
                            (selectModalInconsistenciaTipo.selectItem === 0 && !funcionario.inconsistencia.inconsistencia_permitida) ||
                            (selectModalInconsistenciaTipo.selectItem === 1 && !funcionario.inconsistencia.inconsistencia_permitida && (funcionario.organograma.departamento.codigo !== funcionario.departamento.codigo)) ||
                            (selectModalInconsistenciaTipo.selectItem === 2 && !funcionario.inconsistencia.inconsistencia_permitida && (funcionario.organograma.funcao.codigo !== funcionario.funcao.codigo)) ||
                            (selectModalInconsistenciaTipo.selectItem === 3 && funcionario.inconsistencia.inconsistencia_permitida)
                        )
                    ) {
                        return (
                            <div className={[swalstyles.bodylistfuncionarios, swalstyles.conteinerlistinconsistenciasdptofuncao].join(' ')} key={index}>
                                <div className={[swalstyles.listinconsistenciasdptofuncao, swalstyles.listinconsistenciasdptofuncaobody].join(' ')}
                                    onClick={() => nextModalInconsistenciasDepartamentoFuncao(funcionario)}
                                    >
                                    <div className={swalstyles.bodylistfuncionariosdescricaofuncionario}>
                                        {`${funcionario.matricula} - ${funcionario.nome}`}
                                    </div>
                                    {renderInconsistenciaDepartamento(funcionario)}
                                    {renderInconsistenciaFuncao(funcionario)}
                                </div>
                                    {renderIconInconsistenciaDepartamentoFuncao(funcionario, index)}
                            </div>
                        )
                    }
                })
            )
        } else {
            return (
                <div className={swalstyles.listfuncionariosfuncaonodata}>
                    Nenhum funcionário para listar nesta sessão
                </div>
            )
        }
    }

    function renderActionsModalInconsistenciasDepartamentoFuncao() {
        return (
            <div className={swalstyles.conteinerbuttons}>
                <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                    value='Fechar'
                    onClick={() => {
                        closeModalInconsistenciasDepartamentoFuncao();
                    }}
                />
            </div>
        )
    }

    function renderModalInconsistenciasDepartamentoFuncao() {
        if(modalInconsistenciasDepartamentoFuncao) {
            if(inconsistenciasDepartamentoFuncao.imported) {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modallargerwidth, swalstyles.modalmaxheight3rows].join(' ')}>
                            <div className={swalstyles.index2}>
                                <div className={swalstyles.titlemodalfuncionarios}>INCONSISTÊNCIAS DE CONTRATAÇÃO</div>
                                {renderFilterInconsistenciasDepartamentoFuncao()}
                            </div>
                            <div className={[swalstyles.conteinerbody, swalstyles.conteinerbodymaxheight, swalstyles.conteinerbodyenableoverflowx].join(' ')}>
                                <div className={[swalstyles.headlistfuncionarios, swalstyles.conteinerlistinconsistenciasdptofuncao, swalstyles.index1].join(' ')}>
                                    <div className={swalstyles.listinconsistenciasdptofuncao}>
                                        <div>FUNCIONÁRIO</div>
                                        <div>DEPARTAMENTO</div>
                                        <div>FUNÇÃO</div>
                                    </div>
                                </div>
                                {renderFuncionariosModalInconsistenciasDepartamentoFuncao()}
                            </div>
                            {renderActionsModalInconsistenciasDepartamentoFuncao()}
                        </div>
                    </div>
                )
            }
            else {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modallargerwidth, swalstyles.modalmaxheight3rows].join(' ')}>
                            <div></div>
                            <div className={swalstyles.conteinerbuttons}>
                                <div className={loadingstyles.divloading}>
                                    <div className={loadingstyles.loading}></div>
                                </div>
                            </div>
                            <div></div>
                        </div>
                    </div>
                )
            }
        }
    }

    function resetModalAjustarEmMassa() {
        setSearchingAjustarEmMassa(false);
        setAjustarEmMassa([]);
        setInputModalAjustarEmMassaFuncionario('');
        setInputModalAjustarEmMassaIncludeVagas(false);
        setSelectModalAjustarEmMassaDepartamentoPrevisto({ items: [], selectItem: null });
        setSelectModalAjustarEmMassaFuncaoPrevista({ items: [], selectItem: null });
        setSelectModalAjustarEmMassaDepartamentoContrato({ items: [], selectItem: null });
        setSelectModalAjustarEmMassaFuncaoContrato({ items: [], selectItem: null });
        setSelectModalAjustarEmMassaContrato({ items: [], selectItem: null });
        setInputDemissaoAjustarEmMassa('');
        setSelectCalculaRecisaoAjustarEmMassa(handleSelectValue(3, selectCalculaRecisaoAjustarEmMassa))
        setSelectDepartamentoAjustarEmMassa({ items: [], selectItem: null });
        setSelectFuncaoAjustarEmMassa({ items: [], selectItem: null });
        setSelectPeriodoAjustarEmMassa({ items: [], selectItem: null });
        setSelectTurnoAjustarEmMassa(handleSelectValue(null, selectTurnoAjustarEmMassa));
        setInputAtividadeAjustarEmMassa('');
    }

    function closeModalAjustarEmMassa() {
        resetModalAjustarEmMassa();
        setSelectInputValues(prevState => {
            const { select_filter_departamento_previsto, ...prev } = prevState;
            return { ...prev };
        });
        setModalAjustarEmMassa(false);
        setLoading(true);
    }

    function salvarAjustesEmMassa(event) {
        event.stopPropagation();

        if(!ajustarEmMassa.some(({ checked }) => checked)) {
            Swal.fire({
                customClass: {
                    container: swalstyles.swalcontainer,
                    popup: swalstyles.swalbackground
                },
                title: 'NENHUM REGISTRO RELECIONADO!',
                icon: 'warning',
            });
            return;
        }

        if(validaNewHistoricoEmMassa()) {
            Swal.fire({
                customClass: {
                    container: swalstyles.swalcontainer,
                    popup: swalstyles.swalbackground
                },
                title: 'INFORME TODOS OS CAMPOS OBRIGATÓRIOS PARA O HISTÓRICO!',
                text: 'Para adicionar um novo histórico, informe (Departamento, Função, Período e Turno).',
                icon: 'warning',
            });

            return;
        }

        if(inputAdmissaoAjustarEmMassa && !dataAdmDemIsValid(inputAdmissaoAjustarEmMassa).error) {
            Swal.fire({
                customClass: {
                    container: swalstyles.swalcontainer,
                    popup: swalstyles.swalbackground
                },
                title: 'INFORME UMA DATA DE ADMISSÃO PREVISTA VÁLIDA!',
                icon: 'warning',
            });

            return;
        }

        if(inputDemissaoAjustarEmMassa && (inputDemissaoAjustarEmMassa !== '0' && !dataAdmDemIsValid(inputDemissaoAjustarEmMassa).error)) {
            Swal.fire({
                customClass: {
                    container: swalstyles.swalcontainer,
                    popup: swalstyles.swalbackground
                },
                title: 'INFORME UMA DATA DE DEMISSÃO PREVISTA VÁLIDA!',
                text: "Digite '0' para remover a Demissão Prevista.",
                icon: 'warning',
            });

            return;
        }

        if(inputAdmissaoAjustarEmMassa && inputDemissaoAjustarEmMassa && inputDemissaoAjustarEmMassa !== '0' && !dataAdmDemIsValid(inputAdmissaoAjustarEmMassa, true, inputDemissaoAjustarEmMassa).error) {
            Swal.fire({
                customClass: {
                    container: swalstyles.swalcontainer,
                    popup: swalstyles.swalbackground
                },
                title: 'INFORME UMA DATA DE DEMISSÃO PREVISTA VÁLIDA!',
                text: "Data de Demissão Prevista deve ser maior que a Data de Admissão Prevista.",
                icon: 'warning',
            });

            return;
        }

        if(!inputAdmissaoAjustarEmMassa && !inputDemissaoAjustarEmMassa && selectCalculaRecisaoAjustarEmMassa.selectItem === 3 && !selectDepartamentoAjustarEmMassa.selectItem) {
            Swal.fire({
                customClass: {
                    container: swalstyles.swalcontainer,
                    popup: swalstyles.swalbackground
                },
                title: 'NENHUM CAMPO FOI PREENCHIDO PARA ALTERAÇÃO!',
                html: `<ul style="text-align: left; margin: 0;">
                        <li>Digite a nova Admissão Prevista</li>
                        <li>Digite a nova Demissão Prevista ou '0' para removê-la</li>
                        <li>Selecione 'Sim' ou 'Não' para alterar a regra de encerramento de atividade</li>
                        <li>Informe os dados para o Novo Histórico.</li>
                    </ul>`,
                icon: 'warning',
            });

            return;
        }

        if(selectDepartamentoAjustarEmMassa && selectDepartamentoAjustarEmMassa.selectItem != null) {
            if(inputAdmissaoAjustarEmMassa && moment(inputAdmissaoAjustarEmMassa, 'DD MM YYYY').isAfter(moment(selectPeriodoAjustarEmMassa.items.find(({ value }) => value === selectPeriodoAjustarEmMassa.selectItem).data))) {
                Swal.fire({
                    customClass: {
                        container: swalstyles.swalcontainer,
                        popup: swalstyles.swalbackground
                    },
                    title: 'DATA DO HISTÓRICO INVÁLIDA!',
                    text: `Data do Histórico não pode ser menor que a Data de Admissão Prevista.`,
                    icon: 'warning',
                });

                return;
            }

            if(inputDemissaoAjustarEmMassa && inputDemissaoAjustarEmMassa !== '0' && moment(inputDemissaoAjustarEmMassa, 'DD MM YYYY').isBefore(moment(selectPeriodoAjustarEmMassa.items.find(({ value }) => value === selectPeriodoAjustarEmMassa.selectItem).data))) {
                Swal.fire({
                    customClass: {
                        container: swalstyles.swalcontainer,
                        popup: swalstyles.swalbackground
                    },
                    title: 'DATA DO HISTÓRICO INVÁLIDA!',
                    text: `Data do Histórico não pode ser maior que a Data de Demissão Prevista.`,
                    icon: 'warning',
                });

                return;
            }
        }

        let selecteds = ajustarEmMassa.filter(({ checked }) => checked).map((funcionario) => { return funcionario });
        let ids_update_admissao_prevista = [];
        let ids_update_calcula_recisao = [];

        if(inputAdmissaoAjustarEmMassa) {
            ids_update_admissao_prevista = selecteds.filter(({ id }) => id == null).map(({ organograma_funcionario }) => { return organograma_funcionario.id });
        }

        if(selectCalculaRecisaoAjustarEmMassa.selectItem !== 3) {
            if(selectDepartamentoAjustarEmMassa.selectItem) {
                if([2, 3].includes(selectDepartamentoAjustarEmMassa.items.find(({ value }) => value === selectDepartamentoAjustarEmMassa.selectItem).tipo)) {
                    ids_update_calcula_recisao = selecteds.map(({ organograma_funcionario }) => { return organograma_funcionario.id });
                }
            } else {
                ids_update_calcula_recisao = selecteds.filter(({ organograma }) => [2, 3].includes(organograma.departamento.tipo)).map(({ organograma_funcionario }) => { return organograma_funcionario.id });
            }
        }

        if(ids_update_admissao_prevista.length !== selecteds.length) {
            Swal.fire({
                customClass: {
                    container: swalstyles.swalcontainer,
                    popup: swalstyles.swalbackground
                },
                title: (ids_update_calcula_recisao.length ? `SOMENTE ${ids_update_admissao_prevista.length}/${selecteds.length} REGISTROS SOFRERÃO ALTERAÇÃO NA DATA DE ADMISSÃO PREVISTA` : 'NENHUM REGISTRO SOFRERÁ ALTERAÇÃO NA DATA DE ADMISSÃO PREVISTA'),
                html: '<div>Somente vagas podem ter a data de admissão prevista alterada.</div><div style="margin-top: .8rem; font-size: 90%; font-weight: 700;">Se houverem, as outras alterações serão aplicadas normalmente.</div>',
                icon: 'info',
            });
        }

        if(selectCalculaRecisaoAjustarEmMassa.selectItem !== 3 && ids_update_calcula_recisao.length !== selecteds.length) {
            if(inputDemissaoAjustarEmMassa || selectDepartamentoAjustarEmMassa.selectItem) {
                Swal.fire({
                    customClass: {
                        container: swalstyles.swalcontainer,
                        popup: swalstyles.swalbackground
                    },
                    title: (ids_update_calcula_recisao.length ? `SOMENTE ${ids_update_calcula_recisao.length}/${selecteds.length} REGISTROS SOFRERÃO ALTERAÇÃO DE ENCERRAMENTO DE ATIVIDADE` : 'NENHUM REGISTRO SOFRERÁ ALTERAÇÃO DE ENCERRAMENTO DE ATIVIDADE'),
                    html: '<div>Somente registros que irão ou estão em um departamento de Motoristas/Operador/Rural podem ter a regra de encerramento de atividade alterada.</div><div style="margin-top: .8rem; font-size: 90%; font-weight: 700;">As demais alterações serão aplicadas normalmente.</div>',
                    icon: 'info',
                });
            } else {
                Swal.fire({
                    customClass: {
                        container: swalstyles.swalcontainer,
                        popup: swalstyles.swalbackground
                    },
                    title: (ids_update_calcula_recisao.length ? `SOMENTE ${ids_update_calcula_recisao.length}/${selecteds.length} REGISTROS SOFRERÃO ALTERAÇÃO DE ENCERRAMENTO DE ATIVIDADE` : 'OPERAÇÃO CANCELADA!'),
                    text: 'Somente registros que irão ou estão em um departamento de Motoristas/Operador/Rural podem ter a regra de encerramento de atividade alterada.',
                    icon: (ids_update_calcula_recisao.length ? 'info' : 'warning'),
                });

                if(!ids_update_calcula_recisao.length) {
                    return;
                }
            }
        }

        let body = {
            id_cenario_organograma: headerOrganograma.id_cenario_organograma,
            ids: selecteds.map(({ organograma_funcionario }) => { return organograma_funcionario.id }),
            updates: {
                ...(inputAdmissaoAjustarEmMassa ? { admissao_prevista: moment(inputAdmissaoAjustarEmMassa, 'DD MM YYYY').format('YYYY-MM-DD') } : null),
                ...(inputDemissaoAjustarEmMassa ? { demissao_prevista: (inputDemissaoAjustarEmMassa !== '0' ? moment(inputDemissaoAjustarEmMassa, 'DD MM YYYY').format('YYYY-MM-DD') : null) } : null),
            },
            update_calcula_recisao: ids_update_calcula_recisao.length ? {
                calcula_recisao: selectCalculaRecisaoAjustarEmMassa.selectItem,
                ids: ids_update_calcula_recisao,
            } : null,
            new_historico: selectDepartamentoAjustarEmMassa.selectItem ? {
                id_departamento: selectDepartamentoAjustarEmMassa.selectItem,
                id_funcao: selectFuncaoAjustarEmMassa.selectItem,
                data_inicial: selectPeriodoAjustarEmMassa.items.find(({ value }) => value === selectPeriodoAjustarEmMassa.selectItem).data,
                turno: selectTurnoAjustarEmMassa.items.find(({ value }) => value === selectTurnoAjustarEmMassa.selectItem).label,
                id_atividade: inputAtividadeAjustarEmMassa || null,
            } : null
        };

        api.post(`/previsao/salvarAjustesEmMassa`, body).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);

                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'UM ERRO INESPERADO ACONTECEU!',
                        text: 'POR FAVOR CONTATE UM ADMINISTRADOR DO SISTEMA',
                        icon: 'error',
                    });
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else if(response.data.alertMessage.length) {
                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'UM ERRO INESPERADO ACONTECEU!',
                        html: response.data.alertMessage.join('<br />'),
                        icon: 'warning',
                    });

                } else {
                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'PROCESSO DE AJUSTE EM MASSA CONCLUÍDO!',
                        icon: 'success',
                    });

                    handleFilterAjustarEmMassa();
                }
            }
            setSavingAjustarEmMassa(false);
        }).catch(error => {
            // handle error
            alert(error);
            console.log(error);
        });
    }

    function handleFilterAjustarEmMassa(event) {
        if(event) {
            event.stopPropagation();
        }

        if(!dataAdmDemIsValid(inputModalAjustarEmMassaAdmissaoPrevIni, (!!inputModalAjustarEmMassaAdmissaoPrevFin), inputModalAjustarEmMassaAdmissaoPrevFin).error || !dataAdmDemIsValid(inputModalAjustarEmMassaAdmissaoPrevFin, (!!inputModalAjustarEmMassaAdmissaoPrevIni)).error) {
            Swal.fire({
                customClass: {
                    container: swalstyles.swalcontainer,
                    popup: swalstyles.swalbackground
                },
                title: 'REVISE O PERÍODO DA ADMISSÃO PREVISTA!',
                icon: 'warning',
            });
            return;
        }

        if(!dataAdmDemIsValid(inputModalAjustarEmMassaDemissaoPrevIni, (!!inputModalAjustarEmMassaDemissaoPrevFin), inputModalAjustarEmMassaDemissaoPrevFin).error || !dataAdmDemIsValid(inputModalAjustarEmMassaDemissaoPrevFin, (!!inputModalAjustarEmMassaDemissaoPrevIni)).error) {
            Swal.fire({
                customClass: {
                    container: swalstyles.swalcontainer,
                    popup: swalstyles.swalbackground
                },
                title: 'REVISE O PERÍODO DA DEMISSÃO PREVISTA!',
                icon: 'warning',
            });
            return;
        }

        setSearchingAjustarEmMassa(true);
        setAjustarEmMassa([]);

        api.get(`/previsao/getFuncionariosAjustarEmMassa?id_cenario_organograma=${headerOrganograma.id_cenario_organograma}&data_filtro=${selectPeriodo.selectItem}&funcionario=${inputModalAjustarEmMassaFuncionario || ''}&include_vagas=${inputModalAjustarEmMassaIncludeVagas}&id_tipo_contrato=${selectModalAjustarEmMassaContrato.selectItem || ''}&id_departamento_previsto=${selectModalAjustarEmMassaDepartamentoPrevisto.selectItems.toString()}&id_funcao_prevista=${selectModalAjustarEmMassaFuncaoPrevista.selectItems.toString()}&id_departamento_contrato=${selectModalAjustarEmMassaDepartamentoContrato.selectItems.toString()}&id_funcao_contrato=${selectModalAjustarEmMassaFuncaoContrato.selectItems.toString()}&admissao_prevista_ini=${inputModalAjustarEmMassaAdmissaoPrevIni ? moment(inputModalAjustarEmMassaAdmissaoPrevIni, 'DD MM YYYY').format('YYYY-MM-DD') : ''}&admissao_prevista_fin=${inputModalAjustarEmMassaAdmissaoPrevFin ? moment(inputModalAjustarEmMassaAdmissaoPrevFin, 'DD MM YYYY').format('YYYY-MM-DD') : ''}&demissao_prevista_ini=${inputModalAjustarEmMassaDemissaoPrevIni ? moment(inputModalAjustarEmMassaDemissaoPrevIni, 'DD MM YYYY').format('YYYY-MM-DD') : ''}&demissao_prevista_fin=${inputModalAjustarEmMassaDemissaoPrevFin ? moment(inputModalAjustarEmMassaDemissaoPrevFin, 'DD MM YYYY').format('YYYY-MM-DD') : ''}`
        ).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else {
                    if(response.data.funcionarios) {
                        setAjustarEmMassa(response.data.funcionarios);
                    }
                    setSearchingAjustarEmMassa(false);
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        });
    }

    function handleSelectModalAjustarEmMassaDepartamentoPrevisto(list) {
        if(list.length && list[list.length - 1].value === null) {
            setSelectModalAjustarEmMassaDepartamentoPrevisto(handleSelectValue([], selectModalAjustarEmMassaDepartamentoPrevisto, true, true));
        } else {
            const filteredList = list.filter(({ value }) => value !== null);
            const newSelected = handleSelectValue(filteredList, selectModalAjustarEmMassaDepartamentoPrevisto, true, true);
            setSelectModalAjustarEmMassaDepartamentoPrevisto(newSelected);
        }
    }

    function handleSelectModalAjustarEmMassaFuncaoPrevista(list) {
        if(list.length && list[list.length - 1].value === null) {
            setSelectModalAjustarEmMassaFuncaoPrevista(handleSelectValue([], selectModalAjustarEmMassaFuncaoPrevista, true, true));
        } else {
            const filteredList = list.filter(({ value }) => value !== null);
            const newSelected = handleSelectValue(filteredList, selectModalAjustarEmMassaFuncaoPrevista, true, true);
            setSelectModalAjustarEmMassaFuncaoPrevista(newSelected);
        }
    }

    function handleSelectModalAjustarEmMassaDepartamentoContrato(list) {
        if(list.length && list[list.length - 1].value === null) {
            setSelectModalAjustarEmMassaDepartamentoContrato(handleSelectValue([], selectModalAjustarEmMassaDepartamentoContrato, true, true));
        } else {
            const filteredList = list.filter(({ value }) => value !== null);
            const newSelected = handleSelectValue(filteredList, selectModalAjustarEmMassaDepartamentoContrato, true, true);
            setSelectModalAjustarEmMassaDepartamentoContrato(newSelected);
        }
    }

    function handleSelectModalAjustarEmMassaFuncaoContrato(list) {
        if(list.length && list[list.length - 1].value === null) {
            setSelectModalAjustarEmMassaFuncaoContrato(handleSelectValue([], selectModalAjustarEmMassaFuncaoContrato, true, true));
        } else {
            const filteredList = list.filter(({ value }) => value !== null);
            const newSelected = handleSelectValue(filteredList, selectModalAjustarEmMassaFuncaoContrato, true, true);
            setSelectModalAjustarEmMassaFuncaoContrato(newSelected);
        }
    }

    function handleSelectDepartamentoAjustarEmMassa(value) {
        if(value && selectFuncaoAjustarEmMassa.selectItem && 
            !selectFuncaoAjustarEmMassa.items.find(({ value }) => value === selectFuncaoAjustarEmMassa.selectItem).ids_departamento.some(id => id === value)
        ) {
            setSelectFuncaoAjustarEmMassa(handleSelectValue(null, selectFuncaoAjustarEmMassa, true));
        }

        if(!value || selectDepartamentoAjustarEmMassa.items.find((departamento) => departamento.value === value).tipo !== 2) {
            setInputAtividadeAjustarEmMassa('');
        }
        
        setSelectDepartamentoAjustarEmMassa(handleSelectValue(value, selectDepartamentoAjustarEmMassa, true));
    }

    function completeInputAdmissaoIniAjustarEmMassa() {
        if(inputModalAjustarEmMassaAdmissaoPrevIni.length < 10 && moment(inputModalAjustarEmMassaAdmissaoPrevIni, 'DD MM YYYY').isValid()) {
            setInputModalAjustarEmMassaAdmissaoPrevIni(moment(inputModalAjustarEmMassaAdmissaoPrevIni, 'DD MM YYYY').format('DD/MM/YYYY'));
        }
    }

    function completeInputAdmissaoFinAjustarEmMassa() {
        if(inputModalAjustarEmMassaAdmissaoPrevFin.length < 10 && moment(inputModalAjustarEmMassaAdmissaoPrevFin, 'DD MM YYYY').isValid()) {
            setInputModalAjustarEmMassaAdmissaoPrevFin(moment(inputModalAjustarEmMassaAdmissaoPrevFin, 'DD MM YYYY').format('DD/MM/YYYY'));
        }
    }

    function completeInputDemissaoIniAjustarEmMassa() {
        if(inputModalAjustarEmMassaDemissaoPrevIni.length < 10 && moment(inputModalAjustarEmMassaDemissaoPrevIni, 'DD MM YYYY').isValid()) {
            setInputModalAjustarEmMassaDemissaoPrevIni(moment(inputModalAjustarEmMassaDemissaoPrevIni, 'DD MM YYYY').format('DD/MM/YYYY'));
        }
    }

    function completeInputDemissaoFinAjustarEmMassa() {
        if(inputModalAjustarEmMassaDemissaoPrevFin.length < 10 && moment(inputModalAjustarEmMassaDemissaoPrevFin, 'DD MM YYYY').isValid()) {
            setInputModalAjustarEmMassaDemissaoPrevFin(moment(inputModalAjustarEmMassaDemissaoPrevFin, 'DD MM YYYY').format('DD/MM/YYYY'));
        }
    }

    function renderFilterAjustarEmMassa() {
        let admissaoIniIsValid = dataAdmDemIsValid(inputModalAjustarEmMassaAdmissaoPrevIni, (!!inputModalAjustarEmMassaAdmissaoPrevFin), inputModalAjustarEmMassaAdmissaoPrevFin);
        let admissaoFinIsValid = dataAdmDemIsValid(inputModalAjustarEmMassaAdmissaoPrevFin, (!!inputModalAjustarEmMassaAdmissaoPrevIni));
        let classesAdmissaoIni = [swalstyles.inputdata];
        let classesAdmissaoFin = [swalstyles.inputdata];

        let demissaoIniIsValid = dataAdmDemIsValid(inputModalAjustarEmMassaDemissaoPrevIni, (!!inputModalAjustarEmMassaDemissaoPrevFin), inputModalAjustarEmMassaDemissaoPrevFin);
        let demissaoFinIsValid = dataAdmDemIsValid(inputModalAjustarEmMassaDemissaoPrevFin, (!!inputModalAjustarEmMassaDemissaoPrevIni));
        let classesDemissaoIni = [swalstyles.inputdata];
        let classesDemissaoFin = [swalstyles.inputdata];
        
        if(!admissaoIniIsValid.error) {
            classesAdmissaoIni.push(swalstyles.inputdatainvalid);

            if(admissaoIniIsValid.type === 1) {
                classesAdmissaoIni.push(swalstyles.inputdatainvalidnull);
            } else if(admissaoIniIsValid.type === 2) {
                classesAdmissaoIni.push(swalstyles.inputdatainvalidnot);
            } else if(admissaoIniIsValid.type === 4) {
                classesAdmissaoIni.push(swalstyles.inputdatainvalidmaxdatafin);
            }
        }
        if(!admissaoFinIsValid.error) {
            classesAdmissaoFin.push(swalstyles.inputdatainvalid);

            if(admissaoFinIsValid.type === 1) {
                classesAdmissaoFin.push(swalstyles.inputdatainvalidnull);
            } else if(admissaoFinIsValid.type === 2) {
                classesAdmissaoFin.push(swalstyles.inputdatainvalidnot);
            }
        }

        if(!demissaoIniIsValid.error) {
            classesDemissaoIni.push(swalstyles.inputdatainvalid);

            if(demissaoIniIsValid.type === 1) {
                classesDemissaoIni.push(swalstyles.inputdatainvalidnull);
            } else if(demissaoIniIsValid.type === 2) {
                classesDemissaoIni.push(swalstyles.inputdatainvalidnot);
            } else if(demissaoIniIsValid.type === 4) {
                classesDemissaoIni.push(swalstyles.inputdatainvalidmaxdatafin);
            }
        }
        if(!demissaoFinIsValid.error) {
            classesDemissaoFin.push(swalstyles.inputdatainvalid);

            if(demissaoFinIsValid.type === 1) {
                classesDemissaoFin.push(swalstyles.inputdatainvalidnull);
            } else if(demissaoFinIsValid.type === 2) {
                classesDemissaoFin.push(swalstyles.inputdatainvalidnot);
            }
        }

        return (
            <div className={swalstyles.conteinerbuttonfilter}>
                <div className={swalstyles.conteinerfilterlistfuncionarios}>
                    <div className={swalstyles.filterlistfuncionarios} style={{ gridTemplateColumns: 'auto max-content auto'}}>
                        <input
                            className={swalstyles.inputfilterlistfuncionarios}
                            type='text'
                            placeholder='Digite a matrícula ou nome do funcionário (0 - Somente Vagas)'
                            value={inputModalAjustarEmMassaFuncionario}
                            onChange={(e) => setInputModalAjustarEmMassaFuncionario(e.target.value)}
                        />
                        <div className={!searchingAjustarEmMassa ? swalstyles.conteinercheckdissidio : swalstyles.conteinercheckdissidioblocked} onClick={() => setInputModalAjustarEmMassaIncludeVagas(!inputModalAjustarEmMassaIncludeVagas)} style={{ alignItems: 'center' }}>
                            <div className={swalstyles.checkconteiner}>
                                <TiTick className={inputModalAjustarEmMassaIncludeVagas ? swalstyles.checkicon : [swalstyles.checkicon, swalstyles.checkiconnone].join(' ')}/>
                            </div>
                            <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                                Incluir Vagas
                            </div>
                        </div>
                        <Select
                            inputId='select_filter_contrato'
                            value={selectModalAjustarEmMassaContrato.items.find(({ value }) => value === selectModalAjustarEmMassaContrato.selectItem)}
                            options={selectModalAjustarEmMassaContrato.items}
                            components={{ Option }}
                            filterOption={FilterOptions}
                            onChange={(e) => setSelectModalAjustarEmMassaContrato(handleSelectValue(e.value, selectModalAjustarEmMassaContrato))}
                            theme={Theme}
                            noOptionsMessage={() => "Nenhuma Opção"}
                            placeholder='Selecione um Tipo de Contrato'
                            className={previsaostyles.filterselect}
                            styles={{ container: baseStyles => ({ ...baseStyles, zIndex: 4 }) }}
                            menuPosition='absolute'
                        />
                    </div>
                    <div className={swalstyles.filterlistfuncionarios} style={{ gridTemplateColumns: '50% 50%' }}>
                        <Select
                            inputId='select_filter_departamento_previsto'
                            value={selectModalAjustarEmMassaDepartamentoPrevisto.items.filter(({ value }) => selectModalAjustarEmMassaDepartamentoPrevisto.selectItems.includes(value))}
                            options={selectModalAjustarEmMassaDepartamentoPrevisto.items}
                            components={{ Menu: SelectAllMenu(selectModalAjustarEmMassaDepartamentoPrevisto.selectItems), Option, ValueContainer: getValueContainerWithMaxLabels(4), MultiValueLabel }}
                            inputValue={selectInputValues.select_filter_departamento_previsto || ''}
                            onInputChange={keepInputOnSelect('select_filter_departamento_previsto', handleInputMaskDepartamento)}
                            filterOption={FilterOptions}
                            onChange={(e) => handleSelectModalAjustarEmMassaDepartamentoPrevisto(e)}
                            theme={Theme}
                            noOptionsMessage={() => "Nenhuma Opção"}
                            placeholder='Selecione o Departamento Previsto'
                            className={previsaostyles.filterselect}
                            styles={{ container: baseStyles => ({ ...baseStyles, zIndex: 3, height: 'max-content' }) }}
                            menuPosition='absolute'
                            isMulti
                            backspaceRemovesValue={false}
                            blurInputOnSelect={false}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                        />
                        <Select
                            inputId='select_filter_funcao_prevista'
                            value={selectModalAjustarEmMassaFuncaoPrevista.items.filter(({ value }) => selectModalAjustarEmMassaFuncaoPrevista.selectItems.includes(value))}
                            options={selectModalAjustarEmMassaFuncaoPrevista.items}
                            components={{ Menu: SelectAllMenu(selectModalAjustarEmMassaFuncaoPrevista.selectItems), Option, ValueContainer: getValueContainerWithMaxLabels(4), MultiValueLabel }}
                            inputValue={selectInputValues.select_filter_funcao_prevista || ''}
                            onInputChange={keepInputOnSelect('select_filter_funcao_prevista', handleInputMaskDepartamento)}
                            filterOption={FilterOptions}
                            onChange={(e) => handleSelectModalAjustarEmMassaFuncaoPrevista(e)}
                            theme={Theme}
                            noOptionsMessage={() => "Nenhuma Opção"}
                            placeholder='Selecione a Função Prevista'
                            className={previsaostyles.filterselect}
                            styles={{ container: baseStyles => ({ ...baseStyles, zIndex: 3, height: 'max-content' }) }}
                            menuPosition='absolute'
                            isMulti
                            backspaceRemovesValue={false}
                            blurInputOnSelect={false}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                        />
                    </div>
                    <div className={swalstyles.filterlistfuncionarios} style={{ gridTemplateColumns: '50% 50%' }}>
                        <Select
                            inputId='select_filter_departamento_contrato'
                            value={selectModalAjustarEmMassaDepartamentoContrato.items.filter(({ value }) => selectModalAjustarEmMassaDepartamentoContrato.selectItems.includes(value))}
                            options={selectModalAjustarEmMassaDepartamentoContrato.items}
                            components={{ Menu: SelectAllMenu(selectModalAjustarEmMassaDepartamentoContrato.selectItems), Option, ValueContainer: getValueContainerWithMaxLabels(4), MultiValueLabel }}
                            inputValue={selectInputValues.select_filter_departamento_contrato || ''}
                            onInputChange={keepInputOnSelect('select_filter_departamento_contrato', handleInputMaskDepartamento)}
                            filterOption={FilterOptions}
                            onChange={(e) => handleSelectModalAjustarEmMassaDepartamentoContrato(e)}
                            theme={Theme}
                            noOptionsMessage={() => "Nenhuma Opção"}
                            placeholder='Selecione o Departamento de Contrato'
                            className={previsaostyles.filterselect}
                            styles={{ container: baseStyles => ({ ...baseStyles, zIndex: 2, height: 'max-content' }) }}
                            menuPosition='absolute'
                            isMulti
                            backspaceRemovesValue={false}
                            blurInputOnSelect={false}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                        />
                        <Select
                            inputId='select_filter_funcao_contrato'
                            value={selectModalAjustarEmMassaFuncaoContrato.items.filter(({ value }) => selectModalAjustarEmMassaFuncaoContrato.selectItems.includes(value))}
                            options={selectModalAjustarEmMassaFuncaoContrato.items}
                            components={{ Menu: SelectAllMenu(selectModalAjustarEmMassaFuncaoContrato.selectItems), Option, ValueContainer: getValueContainerWithMaxLabels(4), MultiValueLabel }}
                            inputValue={selectInputValues.select_filter_funcao_contrato || ''}
                            onInputChange={keepInputOnSelect('select_filter_funcao_contrato', handleInputMaskDepartamento)}
                            filterOption={FilterOptions}
                            onChange={(e) => handleSelectModalAjustarEmMassaFuncaoContrato(e)}
                            theme={Theme}
                            noOptionsMessage={() => "Nenhuma Opção"}
                            placeholder='Selecione a Função de Contrato'
                            className={previsaostyles.filterselect}
                            styles={{ container: baseStyles => ({ ...baseStyles, zIndex: 2, height: 'max-content' }) }}
                            menuPosition='absolute'
                            isMulti
                            backspaceRemovesValue={false}
                            blurInputOnSelect={false}
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                        />
                    </div>
                    <div className={swalstyles.filterlistfuncionarios} style={{ gridTemplateColumns: '50% 50%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '.4rem' }}>
                            <div style={{ fontWeight: 600 }}>Admissão Prevista:</div>
                            <div className={classesAdmissaoIni.join(' ')} style={{ width: '130px' }}>
                                <input
                                    className={swalstyles.inputfilterlistfuncionarios}
                                    type='text'
                                    placeholder='dd/mm/aaaa'
                                    value={inputModalAjustarEmMassaAdmissaoPrevIni}
                                    onBlur={() => completeInputAdmissaoIniAjustarEmMassa()}
                                    onChange={e => setInputModalAjustarEmMassaAdmissaoPrevIni(regexMaskData(e))}/>
                                <span />
                            </div>
                            <div style={{ fontWeight: 600}}>até:</div>
                            <div className={classesAdmissaoFin.join(' ')} style={{ width: '130px' }}>
                                <input
                                    className={swalstyles.inputfilterlistfuncionarios}
                                    type='text'
                                    placeholder='dd/mm/aaaa'
                                    value={inputModalAjustarEmMassaAdmissaoPrevFin}
                                    onBlur={() => completeInputAdmissaoFinAjustarEmMassa()}
                                    onChange={e => setInputModalAjustarEmMassaAdmissaoPrevFin(regexMaskData(e))}/>
                                <span />
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '.4rem' }}>
                            <div style={{ fontWeight: 600 }}>Demissão Prevista:</div>
                            <div className={classesDemissaoIni.join(' ')} style={{ width: '130px' }}>
                                <input
                                    className={swalstyles.inputfilterlistfuncionarios}
                                    type='text'
                                    placeholder='dd/mm/aaaa'
                                    value={inputModalAjustarEmMassaDemissaoPrevIni}
                                    onBlur={() => completeInputDemissaoIniAjustarEmMassa()}
                                    onChange={e => setInputModalAjustarEmMassaDemissaoPrevIni(regexMaskData(e))}/>
                                <span />
                            </div>
                            <div style={{ fontWeight: 600}}>até:</div>
                            <div className={classesDemissaoFin.join(' ')} style={{ width: '130px' }}>
                                <input
                                    className={swalstyles.inputfilterlistfuncionarios}
                                    type='text'
                                    placeholder='dd/mm/aaaa'
                                    value={inputModalAjustarEmMassaDemissaoPrevFin}
                                    onBlur={() => completeInputDemissaoFinAjustarEmMassa()}
                                    onChange={e => setInputModalAjustarEmMassaDemissaoPrevFin(regexMaskData(e))}/>
                                <span />
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{height: '100%', display: 'grid', alignContent: 'space-between', justifyItems: 'center'}}>
                    <div style={{textAlign: 'left', fontSize: '80%', fontWeight: 600, lineHeight: 1, marginLeft: '.4rem'}}>
                        <div className={swalstyles.legendainconsistenciasdepartamentofuncaoprevisto}>&#11044; Previsto</div>
                        <div className={swalstyles.legendainconsistenciasdepartamentofuncaocontratado}>&#11044; Contratado</div>
                    </div>
                    <input type='button' className={[swalstyles.buttons, swalstyles.filterbutton].join(' ')}
                        value='Filtar' disabled={searchingAjustarEmMassa || savingAjustarEmMassa} onClick={(e) => { handleFilterAjustarEmMassa(e); }}
                    />
                </div>
            </div>
        )
    }

    function handleCheckAjustarEmMassa(index) {
        if(!savingAjustarEmMassa && !searchingAjustarEmMassa && ajustarEmMassa.length) {
            const newAjustarEmMassa = Object.assign([], ajustarEmMassa);

            if(index != null) {
                newAjustarEmMassa[index].checked = !newAjustarEmMassa[index].checked;
            } else {
                let checkAll = newAjustarEmMassa.some(({ checked }) => !checked);
                newAjustarEmMassa.forEach(item => {
                    item.checked = checkAll;
                });
            }

            setAjustarEmMassa(newAjustarEmMassa);
        }
    }

    function renderFuncionariosModalAjustarEmMassa() {
        if(searchingAjustarEmMassa) {
            return (
                <div className={loadingstyles.divloading}>
                    <div className={loadingstyles.loading}></div>
                </div>
            )
        } else if(ajustarEmMassa.length) {
            return (
                ajustarEmMassa.map((funcionario, index) => {
                    return (
                        <div className={[swalstyles.listfuncionarios, swalstyles.listfuncionariosajusteemmassa, swalstyles.bodylistfuncionarios].join(' ')} key={index}>
                            <div className={!savingAjustarEmMassa ? swalstyles.conteinercheckdissidio : swalstyles.conteinercheckdissidioblocked} onClick={() => handleCheckAjustarEmMassa(index)} style={{justifySelf: 'center'}}>
                                <div className={swalstyles.checkconteiner}>
                                    <TiTick className={funcionario.checked ? swalstyles.checkicon : [swalstyles.checkicon, swalstyles.checkiconnone].join(' ')}/>
                                </div>
                            </div>
                            <div className={swalstyles.bodylistfuncionariosdescricaofuncionario}>
                                {renderModalFuncionariosFuncaoBodyFuncionario(funcionario)}
                            </div>
                            {/* <div className={swalstyles.bodylistfuncionariosdescricaodepartamento}>
                                {`${funcionario.organograma.departamento.codigo} - ${funcionario.organograma.departamento.descricao}`}
                            </div>
                            <div className={[swalstyles.bodylistfuncionariosdescricaofuncao].join(' ')}>
                                {`${funcionario.organograma.funcao.codigo} - ${funcionario.organograma.funcao.descricao}`}
                            </div> */}
                            {renderInconsistenciaDepartamento(funcionario)}
                            {renderInconsistenciaFuncao(funcionario)}
                            <div style={{justifySelf: 'center', display: funcionario.organograma_funcionario.observacao ? 'none' : ''}}>-</div>
                            <div className={swalstyles.conteinerpopup} style={{justifySelf: 'center', fontSize: '120%', display: !funcionario.organograma_funcionario.observacao ? 'none' : ''}}>
                                <span className={swalstyles.popup}>{funcionario.organograma_funcionario.observacao}</span>
                                <BsInfoCircleFill className={swalstyles.bodylistfuncionariosinfoobservacao}
                                onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}/>
                            </div>
                            <div className={[swalstyles.bodylistfuncionariosdescricaodata].join(' ')}>
                                {funcionario.organograma_funcionario.demissao_prevista || '-'}
                            </div>
                        </div>
                    )
                })
            )
        } else {
            return (
                <div className={swalstyles.listfuncionariosfuncaonodata}>
                    Nenhum funcionário para listar nesta sessão
                </div>
            )
        }
    }

    function completeInputAdmissaoAjustarEmMassa() {
        if(inputAdmissaoAjustarEmMassa.length < 10 && moment(inputAdmissaoAjustarEmMassa, 'DD MM YYYY').isValid()) {
            setInputAdmissaoAjustarEmMassa(moment(inputAdmissaoAjustarEmMassa, 'DD MM YYYY').format('DD/MM/YYYY'));
        }
    }

    function completeInputDemissaoAjustarEmMassa() {
        if(inputDemissaoAjustarEmMassa.length < 10 && moment(inputDemissaoAjustarEmMassa, 'DD MM YYYY').isValid()) {
            setInputDemissaoAjustarEmMassa(moment(inputDemissaoAjustarEmMassa, 'DD MM YYYY').format('DD/MM/YYYY'));
        }
    }

    function validaNewHistoricoEmMassa() {
        return (
            Boolean(selectDepartamentoAjustarEmMassa.selectItem || selectFuncaoAjustarEmMassa.selectItem || selectPeriodoAjustarEmMassa.selectItem != null || selectTurnoAjustarEmMassa.selectItem != null || inputAtividadeAjustarEmMassa) &&
            Boolean(!selectDepartamentoAjustarEmMassa.selectItem || !selectFuncaoAjustarEmMassa.selectItem || selectPeriodoAjustarEmMassa.selectItem == null || selectTurnoAjustarEmMassa.selectItem == null)
        );
    }

    function renderInputsModalAjustarEmMassa() {
        let isValidAdmissao = dataAdmDemIsValid(inputAdmissaoAjustarEmMassa);
        let isValidDemissao = dataAdmDemIsValid(inputDemissaoAjustarEmMassa);
        let classesAdmissao = [swalstyles.inputdata];
        let classesDemissao = [swalstyles.inputdata];

        if(inputAdmissaoAjustarEmMassa === '0') {
            classesAdmissao.push(swalstyles.inputdatavalidclear);
        } else if(!isValidAdmissao.error) {
            classesAdmissao.push(swalstyles.inputdatainvalid);

            if(isValidAdmissao.type === 2) {
                classesAdmissao.push(swalstyles.inputdatainvalidnot);
            }
        }

        if(inputDemissaoAjustarEmMassa === '0') {
            classesDemissao.push(swalstyles.inputdatavalidclear);
        } else if(!isValidDemissao.error) {
            classesDemissao.push(swalstyles.inputdatainvalid);

            if(isValidDemissao.type === 2) {
                classesDemissao.push(swalstyles.inputdatainvalidnot);
            }
        }

        return (
            <div style={{margin: '0 .2rem', display: 'flex', flexWrap: 'wrap', columnGap: '.4rem', rowGap: '.8rem'}}>
                <div style={{width: '110px'}}>
                    <div style={{fontSize: '60%', fontWeight: 600, textAlign: 'left', marginLeft: '.5rem'}}>ADMISSÃO PREVISTA:</div>
                    <div className={classesAdmissao.join(' ')} style={{width: '100%'}}>
                        <input
                            className={swalstyles.inputfilterlistfuncionarios}
                            type='text'
                            placeholder='dd/mm/aaaa'
                            value={inputAdmissaoAjustarEmMassa}
                            onBlur={() => completeInputAdmissaoAjustarEmMassa()}
                            onChange={e => setInputAdmissaoAjustarEmMassa(regexMaskData(e))}/>
                        <span />
                    </div>
                </div>
                <div style={{width: '110px'}}>
                    <div style={{fontSize: '60%', fontWeight: 600, textAlign: 'left', marginLeft: '.5rem'}}>DEMISSÃO PREVISTA:</div>
                    <div className={classesDemissao.join(' ')} style={{width: '100%'}}>
                        <input
                            className={swalstyles.inputfilterlistfuncionarios}
                            type='text'
                            placeholder='dd/mm/aaaa'
                            value={inputDemissaoAjustarEmMassa}
                            onBlur={() => completeInputDemissaoAjustarEmMassa()}
                            onChange={e => setInputDemissaoAjustarEmMassa(regexMaskData(e))}/>
                        <span />
                    </div>
                </div>
                <div style={{width: '125px'}}>
                    <div style={{fontSize: '60%', fontWeight: 600, textAlign: 'left', marginLeft: '.2rem'}}>ENCERRAMENTO DE ATIV.:</div>
                    {selectCalculaRecisaoAjustarEmMassa.items.map(item => {
                        return (
                            <div className={swalstyles.radio} key={item.id} style={{fontSize: '60%', fontWeight: 600, lineHeight: 1.25, userSelect: 'none'}}>
                                <input type='radio' id={item.id} name='radio_calcula_recisao' value={item.value} style={{width: '.65rem', height: '.65rem'}}
                                    checked={item.value === selectCalculaRecisaoAjustarEmMassa.selectItem}
                                    onChange={() => setSelectCalculaRecisaoAjustarEmMassa(handleSelectValue(item.value, selectCalculaRecisaoAjustarEmMassa))}
                                />
                                <label htmlFor={item.id}>{item.text}</label>
                            </div>
                        )
                    })}
                    {selectCalculaRecisaoAjustarEmMassa.selectItem !== 3 ? (
                        <span className={swalstyles.calcularecisaoobs}/>
                    ) : null}
                </div>
                <div style={{display: 'flex', columnGap: '.4rem', border: '1px solid', borderRadius: '.2rem', padding: '.2rem', paddingTop: '.4rem', marginTop: '.4rem', position: 'relative',
                    borderColor: (validaNewHistoricoEmMassa() ? '#DD3030' : '#ccc')
                }}>
                    <div style={{fontSize: '60%', fontWeight: 600, textAlign: 'left', padding: '0 .2rem', marginLeft: '.5rem', marginTop: '-.85rem', backgroundColor: '#FCFFE0', position: 'absolute'}}>NOVO HISTÓRICO:</div>
                    <div style={{width: '230px'}}>
                        <Select
                            inputId='select_departamento_prevista_ajuste_em_massa'
                            value={selectDepartamentoAjustarEmMassa.items.find(({ value }) => value === selectDepartamentoAjustarEmMassa.selectItem)}
                            options={selectDepartamentoAjustarEmMassa.items}
                            components={{ Option }}
                            onInputChange={handleInputMaskDepartamento}
                            filterOption={FilterOptions}
                            onChange={(e) => handleSelectDepartamentoAjustarEmMassa((e ? e.value : null))}
                            theme={Theme}
                            noOptionsMessage={() => "Nenhuma Opção"}
                            isClearable={true}
                            placeholder='Novo Departamento'
                            className={previsaostyles.filterselect}
                            styles={{ container: baseStyles => ({ ...baseStyles, zIndex: 3 }) }}
                            menuPosition='absolute'
                            menuPlacement='top'
                        />
                    </div>
                    <div style={{width: '200px'}}>
                        <Select
                            inputId='select_funcao_prevista_ajuste_em_massa'
                            value={selectFuncaoAjustarEmMassa.selectItem ? selectFuncaoAjustarEmMassa.items.find(({ value, }) => value === selectFuncaoAjustarEmMassa.selectItem) : null}
                            options={selectFuncaoAjustarEmMassa.items.filter(({ ids_departamento }) => selectDepartamentoAjustarEmMassa.selectItem == null || !ids_departamento || ids_departamento.some(id => id === selectDepartamentoAjustarEmMassa.selectItem))}
                            components={{ Option }}
                            filterOption={FilterOptions}
                            onChange={(e) => setSelectFuncaoAjustarEmMassa(handleSelectValue((e ? e.value : null), selectFuncaoAjustarEmMassa, true))}
                            theme={Theme}
                            noOptionsMessage={() => "Nenhuma Opção"}
                            isClearable={true}
                            placeholder='Nova Função'
                            className={previsaostyles.filterselect}
                            styles={{ container: baseStyles => ({ ...baseStyles, zIndex: 3 }) }}
                            menuPosition='absolute'
                            menuPlacement='top'
                        />
                    </div>
                    <div style={{width: '130px'}}>
                        <Select
                            inputId='select_periodo_ajuste_em_massa'
                            value={selectPeriodoAjustarEmMassa.items.find(({ value, }) => value === selectPeriodoAjustarEmMassa.selectItem)}
                            options={selectPeriodoAjustarEmMassa.items}
                            components={{ Option }}
                            filterOption={FilterOptions}
                            onChange={(e) => setSelectPeriodoAjustarEmMassa(handleSelectValue((e ? e.value : null), selectPeriodoAjustarEmMassa))}
                            theme={Theme}
                            noOptionsMessage={() => "Nenhuma Opção"}
                            isClearable={true}
                            placeholder='Período'
                            className={previsaostyles.filterselect}
                            styles={{ container: baseStyles => ({ ...baseStyles, zIndex: 3 }) }}
                            menuPosition='absolute'
                            menuPlacement='top'
                        />
                    </div>
                    <div style={{width: '93px'}}>
                        <Select
                            inputId='select_turno_ajuste_em_massa'
                            value={selectTurnoAjustarEmMassa.items.find(({ value, }) => value === selectTurnoAjustarEmMassa.selectItem)}
                            options={selectTurnoAjustarEmMassa.items}
                            components={{ Option }}
                            filterOption={FilterOptions}
                            onChange={(e) => setSelectTurnoAjustarEmMassa(handleSelectValue((e ? e.value : null), selectTurnoAjustarEmMassa))}
                            theme={Theme}
                            noOptionsMessage={() => "Nenhuma Opção"}
                            isClearable={true}
                            placeholder='Turno'
                            className={previsaostyles.filterselect}
                            styles={{ container: baseStyles => ({ ...baseStyles, zIndex: 3 }) }}
                            menuPosition='absolute'
                            menuPlacement='top'
                        />
                    </div>
                    {selectDepartamentoAjustarEmMassa.items.find(({ value, tipo }) => value === selectDepartamentoAjustarEmMassa.selectItem && tipo >= 2) ? (
                        <div style={{width: '100px'}}>
                            <input type='text' className={swalstyles.inputfilterlistfuncionarios}
                                value={inputAtividadeAjustarEmMassa} placeholder='Atividade'
                                onChange={e => setInputAtividadeAjustarEmMassa(onlyNumbers(e.target.value).slice(0, 8))}
                            />
                        </div>
                    ) : null}
                </div>
            </div>
        )
    }

    function renderActionsModalAjustarEmMassa() {
        if(!savingAjustarEmMassa) {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    <input type='button' className={[swalstyles.buttons, swalstyles.confirmbutton].join(' ')}
                        value='Ajustar' disabled={searchingAjustarEmMassa} onClick={(e) => { salvarAjustesEmMassa(e); }}
                    />
                    <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                        value='Fechar' onClick={() => { closeModalAjustarEmMassa(); }}
                    />
                </div>
            )
        } else {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    function renderCheckModalAjustarEmMassa() {
        return (
            <div className={!searchingAjustarEmMassa && !savingAjustarEmMassa && ajustarEmMassa.length ? swalstyles.conteinercheckdissidio : swalstyles.conteinercheckdissidioblocked} onClick={() => handleCheckAjustarEmMassa()}>
                <div className={swalstyles.checkconteiner}>
                    <TiTick className={ajustarEmMassa.length && ajustarEmMassa.every(({ checked }) => checked) ? swalstyles.checkicon : [swalstyles.checkicon, swalstyles.checkiconnone].join(' ')}/>
                </div>
            </div>
        )
    }

    function renderModalAjustarEmMassa() {
        if(modalAjustarEmMassa) {
            return (
                <div className={swalstyles.conteiner}>
                    <div className={[swalstyles.modal, swalstyles.modallargerwidth, swalstyles.modalmaxheight4rows].join(' ')}>
                        <div className={swalstyles.index2}>
                            <div className={swalstyles.titlemodalfuncionarios}>AJUSTAR EM MASSA</div>
                            {renderFilterAjustarEmMassa()}
                        </div>
                        <div className={[swalstyles.conteinerbody, swalstyles.conteinerbodymaxheight].join(' ')}>
                            <div className={[swalstyles.listfuncionarios, swalstyles.listfuncionariosajusteemmassa, swalstyles.headlistfuncionarios].join(' ')}>
                                { renderCheckModalAjustarEmMassa() }
                                <div>FUNCIONÁRIO</div>
                                <div>DEPARTAMENTO</div>
                                <div>FUNÇÃO</div>
                                <div>OBS</div>
                                <div>DEMISSÃO PREV.</div>
                            </div>
                            {renderFuncionariosModalAjustarEmMassa()}
                        </div>
                        {renderInputsModalAjustarEmMassa()}
                        {renderActionsModalAjustarEmMassa()}
                    </div>
                </div>
            )
        }
    }

    function resetDataModalFilters() {
        setModalFilter(false);
        setFuncionariosModal({});
        setInputModalFuncionarioFuncionario('');
        setInputModalFuncionarioDepartamento('');
        setInputModalFuncionarioFuncao('');
        setSelectModalFuncionarioTipo(handleSelectValueFuncionarioTipo(null, false, selectModalFuncionarioTipo));
    }

    function closeModalFilters() {
        resetDataModalFilters();

        if(previousModal.length && previousModal[previousModal.length - 1].modalName === 'funcionarioToEdit') {
            handleExibirFuncionarioToEdit(
                previousModal[previousModal.length - 1].funcionarioToEdit,
                previousModal[previousModal.length - 1].observacaoToEdit,
                previousModal[previousModal.length - 1].dataAdmToEdit,
                previousModal[previousModal.length - 1].dataDemToEdit,
                previousModal[previousModal.length - 1].calculaRecisaoToEdit,
            );
            popPreviousModal();
        } else {
            clearPreviousModal();
        }
    }

    function nextModalFilters(funcionario) {
        if(previousModal.length && previousModal[previousModal.length - 1].modalName === 'funcionarioToEdit') {
            resetDataModalFilters();
            handleExibirFuncionarioToEdit(
                previousModal[previousModal.length - 1].funcionarioToEdit,
                previousModal[previousModal.length - 1].observacaoToEdit,
                previousModal[previousModal.length - 1].dataAdmToEdit,
                previousModal[previousModal.length - 1].dataDemToEdit,
                previousModal[previousModal.length - 1].calculaRecisaoToEdit,
                {
                    id: funcionario.id,
                    matricula: funcionario.matricula,
                    nome: funcionario.nome,
                    data_admissao: funcionario.data_admissao,
                    ativo: funcionario.ativo,
                    departamento: funcionario.departamento,
                    funcao: funcionario.funcao,
                }
            );
            popPreviousModal();
        } else if(!funcionario.organograma_funcionario.id && funcionario.ativo) {
            pushPreviousModal({modalName: 'pesquisarFuncionarios', selectModalFuncionarioTip: selectModalFuncionarioTipo.selectItem, enableChange: selectModalFuncionarioTipo.enableChange, inputModalFuncionarioFunc: inputModalFuncionarioFuncionario, inputModalFuncionarioDpto: inputModalFuncionarioDepartamento, inputModalFuncionarioFun: inputModalFuncionarioFuncao});

            resetDataModalFilters();

            handleExibirSelectVaga(funcionario);
        } else {
            pushPreviousModal({modalName: 'pesquisarFuncionarios', selectModalFuncionarioTip: selectModalFuncionarioTipo.selectItem, enableChange: selectModalFuncionarioTipo.enableChange, inputModalFuncionarioFunc: inputModalFuncionarioFuncionario, inputModalFuncionarioDpto: inputModalFuncionarioDepartamento, inputModalFuncionarioFun: inputModalFuncionarioFuncao});

            resetDataModalFilters();

            handleExibirFuncionarioToEdit(funcionario);
        }
    }

    function AjustaDemitidosNaoCadastrados(event) {
        event.stopPropagation();
        setSaving(true);

        let body = {
            id_cenario_organograma: headerOrganograma.id_cenario_organograma,
            id_empresa: headerOrganograma.id_empresa,
            data_inicial: headerOrganograma.data_inicial,
        };

        api.post(`/previsao/salvarOrganogramaFuncionarioDemitidos`, body).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);

                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'UM ERRO INESPERADO ACONTECEU!',
                        text: 'POR FAVOR CONTATE UM ADMINISTRADOR DO SISTEMA',
                        icon: 'error',
                    });
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else {
                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'PROCESSO DE AJUSTE AUTOMÁTICO CONCLUÍDO!',
                        text: `SE AINDA HOUVEREM FUNCIONÁRIOS 'DEMITIDOS/NÃO CADASTRADOS', VERIFIQUE A EXISTÊNCIA DE DEPARTAMENTO E FUNÇÃO COMPATÍVEIS`,
                        icon: 'success',
                    });

                    pesquisarFuncionarios(selectModalFuncionarioTipo.selectItem);
                }
            }
            setSaving(false);
        }).catch(error => {
            // handle error
            alert(error);
            console.log(error);
        });
    }

    function renderActionsModalFiltersAjustaDemitidosNaoCadastrados() {
        if(selectModalFuncionarioTipo.selectItem === 3 && funcionariosModal.data && funcionariosModal.data.some(funcionario => !funcionario.ativo && !funcionario.organograma_funcionario.id)) {
            return (
                <input type='button' className={[swalstyles.buttons, swalstyles.confirmbutton].join(' ')}
                    value='Ajustar não cadastrados' onClick={e => AjustaDemitidosNaoCadastrados(e)}
                />
            )
        }
    }

    function renderActionsModalFiltersCancel() {
        return (
            <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                value='Fechar' onClick={() => { closeModalFilters(); }}
            />
        )
    }

    function renderActionsModalFilters() {
        if(!saving) {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    {renderActionsModalFiltersAjustaDemitidosNaoCadastrados()}
                    {renderActionsModalFiltersCancel()}
                </div>
            )
        } else {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    function renderFuncionariosModalFilter() {
        if(funcionariosModal.data.length) {
            return (
                funcionariosModal.data.map((funcionario, index) => {
                    if(
                        (
                            regexTextoAproximado(funcionario.matricula, inputModalFuncionarioFuncionario) ||
                            regexTextoAproximado(funcionario.nome, inputModalFuncionarioFuncionario)
                        ) &&
                        (
                            regexTextoAproximado((funcionario.organograma.departamento.codigo || funcionario.departamento.codigo), inputModalFuncionarioDepartamento) ||
                            regexTextoAproximado((funcionario.organograma.departamento.descricao || funcionario.departamento.descricao), inputModalFuncionarioDepartamento)
                        ) &&
                        (
                            regexTextoAproximado((funcionario.organograma.funcao.codigo || funcionario.funcao.codigo), inputModalFuncionarioFuncao) ||
                            regexTextoAproximado((funcionario.organograma.funcao.descricao || funcionario.funcao.descricao), inputModalFuncionarioFuncao)
                        )
                    ) {
                        let styletipo;

                        if(funcionario.organograma_funcionario.status === 2) {
                            styletipo = swalstyles.listfuncionariosfuncaodemissaoconfirmada;
                        } else if(funcionario.organograma_funcionario.id && !funcionario.id && !selectModalFuncionarioTipo.selectItem) {
                            styletipo = swalstyles.listfuncionariosfuncaovagaaberta;
                        } else if(!funcionario.ativo && !funcionario.organograma_funcionario.id) {
                            styletipo = swalstyles.listfuncionariosfuncaodemitidonaoescalado;
                        } else if(!funcionario.ativo && !selectModalFuncionarioTipo.selectItem) {
                            styletipo = swalstyles.listfuncionariosfuncaodemitido;
                        } else if(!funcionario.organograma_funcionario.id && !selectModalFuncionarioTipo.selectItem) {
                            styletipo = swalstyles.listfuncionariosfuncaonaoescalado;
                        }

                        return (
                            <div className={[swalstyles.listfuncionarios, swalstyles.bodylistfuncionarios, styletipo].join(' ')} key={index}
                                onClick={() => nextModalFilters(funcionario)}
                            >
                                <div className={swalstyles.bodylistfuncionariosdescricaofuncionario}>
                                    {renderModalFuncionariosFuncaoBodyFuncionario(funcionario)}
                                </div>
                                <div className={swalstyles.bodylistfuncionariosdescricaodepartamento}>
                                    {`${funcionario.organograma.departamento.codigo || funcionario.departamento.codigo} - ${funcionario.organograma.departamento.descricao || funcionario.departamento.descricao}`}
                                </div>
                                <div className={[swalstyles.bodylistfuncionariosdescricaofuncao].join(' ')}>
                                    {`${funcionario.organograma.funcao.codigo || funcionario.funcao.codigo} - ${funcionario.organograma.funcao.descricao || funcionario.funcao.descricao}`}
                                </div>
                                <div style={{justifySelf: 'center', display: funcionario.organograma_funcionario.observacao ? 'none' : ''}}>-</div>
                                <div className={swalstyles.conteinerpopup} style={{justifySelf: 'center', fontSize: '120%', display: !funcionario.organograma_funcionario.observacao ? 'none' : ''}}>
                                    <span className={swalstyles.popup}>{funcionario.organograma_funcionario.observacao}</span>
                                    <BsInfoCircleFill className={swalstyles.bodylistfuncionariosinfoobservacao}
                                    onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}/>
                                </div>
                                <div className={[swalstyles.bodylistfuncionariosdescricaodata].join(' ')}>
                                    {funcionario.data_admissao || funcionario.organograma_funcionario.admissao_prevista || '-'}
                                </div>
                                <div className={[swalstyles.bodylistfuncionariosdescricaodata].join(' ')}>
                                    {funcionario.data_demissao || funcionario.organograma_funcionario.demissao_prevista || '-'}
                                </div>
                            </div>
                        )
                    }
                })
            )
        } else {
            return (
                <div className={swalstyles.listfuncionariosfuncaonodata}>
                    Nenhum funcionário para listar nesta sessão
                </div>
            )
        }
    }

    function renderModalTitleFuncionarios() {
        return (
            <div className={swalstyles.titlemodalfuncionarios}>
                {selectModalFuncionarioTipo.selectItem === 0 ? 'TODOS OS FUNCIONÁRIOS E VAGAS' : `${selectModalFuncionarioTipo.selectItem !== 6 ? 'FUNCIONÁRIOS ' : '' }${selectModalFuncionarioTipo.items.find(({ value }) => value === selectModalFuncionarioTipo.selectItem).label}`}
            </div>
        )
    }

    function changeSelectModalFuncionarioTipo(value) {
        if(value !== selectModalFuncionarioTipo.selectItem) {
            setSelectModalFuncionarioTipo(handleSelectValueFuncionarioTipo(value, selectModalFuncionarioTipo.enableChange, selectModalFuncionarioTipo));
            pesquisarFuncionarios(value);
        }
    }

    function renderFilterTipoFuncionarios() {
        if(selectModalFuncionarioTipo.enableChange) {
            return (
                <Select
                    inputId='select_tipo'
                    value={selectModalFuncionarioTipo.items.find(({ value }) => value === selectModalFuncionarioTipo.selectItem)}
                    options={selectModalFuncionarioTipo.items.filter(({ notSelected }) => !notSelected)}
                    components={{ Option, SingleValue }}
                    filterOption={FilterOptions}
                    onChange={(e) => changeSelectModalFuncionarioTipo(e.value)}
                    theme={Theme}
                    noOptionsMessage={() => "Nenhuma Opção"}
                    className={previsaostyles.filterselect}
                    styles={{ container: baseStyles => ({ ...baseStyles, zIndex: 2 }) }}
                    menuPosition='absolute'
                />
            )
        }
    }

    function renderFilterFuncionarios() {
        return (
            <div className={swalstyles.conteinerfilterlistfuncionarios}>
                <div className={swalstyles.filterlistfuncionarios}>
                    <input
                        className={swalstyles.inputfilterlistfuncionarios}
                        type='text'
                        placeholder='Digite a matrícula ou nome do funcionário'
                        value={inputModalFuncionarioFuncionario}
                        onChange={(e) => setInputModalFuncionarioFuncionario(e.target.value)}
                    />
                    {renderFilterTipoFuncionarios()}
                </div>
                <div className={swalstyles.filterlistfuncionarios}>
                    <input
                        className={swalstyles.inputfilterlistfuncionarios}
                        type='text'
                        placeholder='Digite o código ou descrição do departamento'
                        value={inputModalFuncionarioDepartamento}
                        onChange={(e) => setInputModalFuncionarioDepartamento(regexMaskDepartamento(e.target.value))}
                    />
                    <input
                        className={swalstyles.inputfilterlistfuncionarios}
                        type='text'
                        placeholder='Digite o código ou descrição da função'
                        value={inputModalFuncionarioFuncao}
                        onChange={(e) => setInputModalFuncionarioFuncao(e.target.value)}
                    />
                </div>
            </div>
        )
    }

    function renderQuantidadeFuncionarios() {
        var subtotal = 0;
        var previstos = 0;
        var vagas = 0;
        var nao_escalados = 0;
        var demitidos_nao_escalados = 0;
        var demissao_nao_confirm = 0;
        var demissao_confirm = 0;

        funcionariosModal.data.forEach(funcionario => {
            if(
                (
                    regexTextoAproximado(funcionario.matricula, inputModalFuncionarioFuncionario) ||
                    regexTextoAproximado(funcionario.nome, inputModalFuncionarioFuncionario)
                ) &&
                (
                    regexTextoAproximado((funcionario.organograma.departamento.codigo || funcionario.departamento.codigo), inputModalFuncionarioDepartamento) ||
                    regexTextoAproximado((funcionario.organograma.departamento.descricao || funcionario.departamento.descricao), inputModalFuncionarioDepartamento)
                ) &&
                (
                    regexTextoAproximado((funcionario.organograma.funcao.codigo || funcionario.funcao.codigo), inputModalFuncionarioFuncao) ||
                    regexTextoAproximado((funcionario.organograma.funcao.descricao || funcionario.funcao.descricao), inputModalFuncionarioFuncao)
                )
            ) {
                subtotal++;

                if(funcionario.id && funcionario.ativo && funcionario.organograma_funcionario.id) {
                    previstos++;
                }
                if(!funcionario.id && funcionario.organograma_funcionario.id) {
                    vagas++;
                }
                if(funcionario.id && funcionario.ativo && !funcionario.organograma_funcionario.id) {
                    nao_escalados++;
                }
                if(funcionario.id && !funcionario.ativo && !funcionario.organograma_funcionario.id) {
                    demitidos_nao_escalados++;
                }
                if(funcionario.id && !funcionario.ativo && funcionario.organograma_funcionario.id && funcionario.organograma_funcionario.status === 1) {
                    demissao_nao_confirm++;
                }
                if(funcionario.id && !funcionario.ativo && funcionario.organograma_funcionario.id && funcionario.organograma_funcionario.status === 2) {
                    demissao_confirm++;
                }
            }
        });

        return (
            <div className={swalstyles.salariofuncionariosfuncao}>
                <div className={swalstyles.conteinersalariototalatual}>
                    <div>
                        SUBTOTAL:
                    </div>
                    <div className={swalstyles.conteinerpopup}>
                        <span className={swalstyles.popup}>
                            <div className={swalstyles.popupquantidadefuncionarios}>
                                <div>Vagas: {vagas}</div>
                                <div>Previstos: {previstos}</div>
                                <div>Não Escalados: {nao_escalados}</div>
                                <div>Demitidos/Não Escalados: {demitidos_nao_escalados}</div>
                                <div>Demissão não Confirm.: {demissao_nao_confirm}</div>
                                <div>Demissão Confirm.: {demissao_confirm}</div>
                            </div>
                        </span>
                        <div className={[swalstyles.conteinersalarioatual, swalstyles.conteinerpopupdetailssalario].join(' ')}
                            onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}
                            onClick={() => handleToastShowHtml(
                                <div>
                                    <div>Vagas: {vagas}</div>
                                    <div>Previstos: {previstos}</div>
                                    <div>Não Escalados: {nao_escalados}</div>
                                    <div>Demitidos/Não Escalados: {demitidos_nao_escalados}</div>
                                    <div>Demissão não Confirm.: {demissao_nao_confirm}</div>
                                    <div>Demissão Confirm.: {demissao_confirm}</div>
                                </div>
                            )}
                        >
                            {subtotal}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function renderModalFilters() {
        if(modalFilter) {
            if(funcionariosModal.imported) {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modallargerwidth, swalstyles.modalmaxheight4rows].join(' ')}>
                            <div>
                                {renderModalTitleFuncionarios()}
                                {renderFilterFuncionarios()}
                            </div>
                            <div className={[swalstyles.conteinerbody, swalstyles.conteinerbodymaxheight].join(' ')}>
                                <div className={[swalstyles.listfuncionarios, swalstyles.headlistfuncionarios].join(' ')}>
                                    <div>FUNCIONÁRIO</div>
                                    <div>DEPARTAMENTO</div>
                                    <div>FUNÇÃO</div>
                                    <div>OBS</div>
                                    <div>ADMISSÃO</div>
                                    <div>DEMISSÃO</div>
                                </div>
                                {renderFuncionariosModalFilter()}
                            </div>
                            <div className={swalstyles.conteinerlegendafuncionariosfuncao}>
                                {renderQuantidadeFuncionarios()}
                            </div>
                            {renderActionsModalFilters()}
                        </div>
                    </div>
                )
            }
            else {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modallargerwidth, swalstyles.modalmaxheight3rows].join(' ')}>
                            <div></div>
                            <div className={swalstyles.conteinerbuttons}>
                                <div className={loadingstyles.divloading}>
                                    <div className={loadingstyles.loading}></div>
                                </div>
                            </div>
                            <div></div>
                        </div>
                    </div>
                )
            }
        }
    }

    function calcStatus(funcao) {
        const filteredFuncao = funcao.filter(funcao =>
            (regexTextoAproximado(funcao.codigo, inputFuncao) || regexTextoAproximado(funcao.descricao, inputFuncao)) &&
            funcao.organograma_funcionario.some(({ tipo_demissao, vaga_aberta }) => (vaga_aberta === vagasAberto || !vagasAberto) && (tipo_demissao === tipoDemissao || tipoDemissao === null))
        );

        let status = 4;

        if(filteredFuncao.find(({ salario_base }) => !salario_base)) {
            status = 1;
        } else if(subFuncaoPrevistaPadrao(filteredFuncao).number !== 0) {
            status = 2;
        } else if(filteredFuncao.find(funcao => (
            funcao.organograma_funcionario.reduce((accumulator, currentValue) => {
                if((currentValue.vaga_aberta === vagasAberto || !vagasAberto) && (currentValue.tipo_demissao === tipoDemissao || tipoDemissao === null)){
                    return accumulator + currentValue.quantidade_prevista
                } else {
                    return accumulator
                }
            }, 0) - funcao.quantidade_padrao
        ) !== 0)) {
            status = 3;
        }

        return status;
    }

    function renderStatus(status) {
        if(status === 1) {
            return (
                <MdOutlineMoneyOff className={[previsaostyles.escalaiconsalert, previsaostyles.iconerror].join(' ')} />
            )
        } else if(status === 2) {
            return (
                <BsFillXCircleFill className={[previsaostyles.escalaiconsalert, previsaostyles.iconerror].join(' ')} />
            )
        } else if(status === 3) {
            return (
                <BsFillExclamationCircleFill className={[previsaostyles.escalaiconsalert, previsaostyles.iconalert].join(' ')} />
            )
        } else if(status === 4) {
            return (
                <BsFillCheckCircleFill className={[previsaostyles.escalaiconsalert, previsaostyles.iconok].join(' ')} />
            )
        }
    }

    function renderEscalaOpenClose(show_details) {
        if(!show_details) {
            return (
                <IoIosArrowDown className={previsaostyles.escalaiconsdropdown} />
            )
        } else {
            return (
                <IoIosArrowUp className={previsaostyles.escalaiconsdropdown} />
            )
        }
    }

    function resetFuncionariosFuncao() {
        setModalFuncionariosFuncao(false);
        setFuncionariosFuncao({});
        setVerLancamentosFuturos(false);
        setVerLancamentosAnteriores(false);
    }

    function closeFuncionariosFuncao() {
        resetFuncionariosFuncao();
        clearPreviousModal();
    }

    function nextFuncionariosFuncao(redirectTo, data) {
        pushPreviousModal({modalName: 'funcionariosFuncao', departamento: funcionariosFuncao.head.departamento, funcao: funcionariosFuncao.head.funcao});
        
        resetFuncionariosFuncao();

        if(redirectTo === 'funcionarioToEdit') {
            handleExibirFuncionarioToEdit(data);
        } else if(redirectTo === 'editSalarioFuncao') {
            handleExibirEditSalarioFuncao(data);
        } else if(redirectTo === 'selectVaga') {
            handleExibirSelectVaga(data);
        }
    }

    function handleExibirFuncionariosFuncao(departamento, funcao) {
        setFuncionariosFuncao({
            head: {
                departamento: {
                    id: departamento.id,
                    codigo: departamento.codigo,
                    descricao: departamento.descricao,
                    tipo: departamento.tipo,
                },
                funcao: {
                    id: funcao.id,
                    codigo: funcao.codigo,
                    descricao: funcao.descricao,
                },
            },
        });
        setModalFuncionariosFuncao(true);

        api.get(`/previsao/getFuncionariosByFuncao?id_departamento=${departamento.id}&id_funcao=${funcao.id}&id_organograma=${funcao.id_organograma}&id_empresa=${headerOrganograma.id_empresa}&id_cenario_organograma=${headerOrganograma.id_cenario_organograma}&data_filtro=${selectPeriodo.selectItem}`).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else {
                    if(response.data.funcionariosByFuncao) {
                        setFuncionariosFuncao({
                            imported: true,
                            head: {
                                departamento: {
                                    id: departamento.id,
                                    codigo: departamento.codigo,
                                    descricao: departamento.descricao,
                                    tipo: departamento.tipo,
                                },
                                funcao: {
                                    id: funcao.id,
                                    codigo: funcao.codigo,
                                    descricao: funcao.descricao,
                                    id_organograma: funcao.id_organograma,
                                },
                            },
                            data: response.data.funcionariosByFuncao,
                            info_salario: response.data.info_salario,
                        });
                    }
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        });
    }

    function handleCriarNovaVaga() {
        nextFuncionariosFuncao(
            'funcionarioToEdit',
            {
                id: null,
                departamento: {},
                funcao: {},
                inconsistencia: {},
                organograma: {
                    id: funcionariosFuncao.head.funcao.id_organograma,
                    departamento: {
                        id: funcionariosFuncao.head.departamento.id,
                        codigo: funcionariosFuncao.head.departamento.codigo,
                        descricao: funcionariosFuncao.head.departamento.descricao,
                        tipo: funcionariosFuncao.head.departamento.tipo,
                    },
                    funcao: {
                        id: funcionariosFuncao.head.funcao.id,
                        codigo: funcionariosFuncao.head.funcao.codigo,
                        descricao: funcionariosFuncao.head.funcao.descricao,
                    }
                },
                organograma_funcionario: {
                    id: null,
                    insercao_lote: funcionariosFuncao.head.departamento.tipo >= 2 ? 1 : 0,
                    admissao_prevista: null,
                    demissao_prevista: null,
                    calcula_recisao: 1,
                    turno: 'A',
                    quantidade: 1,
                    status: 1,
                },
            }
        );
    }

    function renderActionsModalFuncionariosFuncao() {
        return (
            <div className={swalstyles.conteinerbuttons}>
                <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                    value='Fechar'
                    onClick={() => {
                        closeFuncionariosFuncao();
                    }}
                />
            </div>
        )
    }

    function renderModalFuncionariosFuncaoBodyFuncionario(funcionario) {
        if(funcionario.id) {
            return (
                <div className={[swalstyles.listfuncionariosfuncaodescricao, swalstyles.listfuncionariosfuncaodescricaofuncionario].join(' ')}>{`${funcionario.matricula} - ${funcionario.nome}`}</div>
            )
        } else if(funcionario.organograma_funcionario.insercao_lote) {
            return (
                <div className={[swalstyles.listfuncionariosfuncaodescricao, swalstyles.listfuncionariosfuncaodescricaofuncionario].join(' ')}>LOTE DE ESCALA: {Number.isInteger(funcionario.organograma_funcionario.quantidade) ? funcionario.organograma_funcionario.quantidade.toFixed(0) : funcionario.organograma_funcionario.quantidade.toFixed(2)} {funcionario.organograma_funcionario.quantidade === 1 ? 'FUNCIONÁRIO' : 'FUNCIONÁRIOS'}{funcionario.organograma_funcionario.id_atividade ? ` (${funcionario.organograma_funcionario.id_atividade})` : ''}</div>
            )
        } else {
            return (
                <div>[ A CONTRATAR ]</div>
            )
        }
    }

    function renderModalFuncionariosFuncaoBodyDate(data_padrao, data_prevista) {
        if(data_padrao) {
            return moment(data_padrao, 'YYYY MM DD').format('DD/MM/YYYY');
        } else if(data_prevista) {
            return moment(data_prevista, 'YYYY MM DD').format('DD/MM/YYYY');
        } else {
            return '-';
        }
    }

    function handleReplicarComoVaga(event, funcionario) {
        event.stopPropagation();
        setSaving(true);

        let body = {
            nome_funcionario: funcionario.nome,
            id_cenario_organograma: headerOrganograma.id_cenario_organograma,
            organograma_funcionario: {
                id_organograma_funcionario_replicacao: funcionario.organograma_funcionario.id,
                calcula_recisao: funcionario.organograma_funcionario.calcula_recisao,
            },
            organograma_funcionario_historico: {
                id_organograma: funcionario.organograma.id,
                id_atividade: funcionario.organograma_funcionario.id_atividade,
                turno: funcionario.organograma_funcionario.turno,
            }
        };

        api.post(`/previsao/replicarVagaOrganogramaFuncionario`, body).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);

                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'UM ERRO INESPERADO ACONTECEU!',
                        text: 'POR FAVOR CONTATE UM ADMINISTRADOR DO SISTEMA',
                        icon: 'error',
                    });
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else {
                    handleExibirFuncionariosFuncao(funcionariosFuncao.head.departamento, funcionariosFuncao.head.funcao)
                }
            }
            setSaving(false);
        }).catch(error => {
            // handle error
            alert(error);
            console.log(error);
        });
    }

    function renderModalFuncionariosFuncaoBody() {
        if(funcionariosFuncao.data.length) {
            return (
                funcionariosFuncao.data.filter(funcionario =>
                    (funcionario.organograma_funcionario.lancamento_futuro === verLancamentosFuturos || verLancamentosFuturos) &&
                    (funcionario.organograma_funcionario.lancamento_anterior === verLancamentosAnteriores || verLancamentosAnteriores)
                ).map((funcionario, index) => {
                    let styletipofuncionarios;

                    if(funcionario.organograma_funcionario.status === 2) {
                        styletipofuncionarios = swalstyles.listfuncionariosfuncaodemissaoconfirmada;
                    } else if(funcionario.organograma_funcionario.lancamento_futuro || funcionario.organograma_funcionario.lancamento_anterior) {
                        styletipofuncionarios = swalstyles.listfuncionariosfuncaolancamentofuturo;
                    } else if(!funcionario.id) {
                        styletipofuncionarios = swalstyles.listfuncionariosfuncaovagaaberta;
                    } else if(!funcionario.ativo) {
                        styletipofuncionarios = swalstyles.listfuncionariosfuncaodemitido;
                    } else if(!funcionario.organograma_funcionario.id) {
                        styletipofuncionarios = swalstyles.listfuncionariosfuncaonaoescalado;
                    }

                    return (
                        <div className={[swalstyles.listfuncionariosfuncao, swalstyles.bodylistfuncionariosfuncao, styletipofuncionarios].join(' ')} key={index}
                            onClick={() => nextFuncionariosFuncao((funcionario.organograma_funcionario.id ? 'funcionarioToEdit' : 'selectVaga' ), funcionario)}
                        >
                            <div className={[swalstyles.buttonreplicar, (funcionario.id && funcionario.organograma_funcionario.id && funcionario.organograma_funcionario.insercao_lote === 0 ? swalstyles.buttonreplicaractive : '')].join(' ')} onClick={e => {handleReplicarComoVaga(e, funcionario)}}>
                                <FaRegCopy className={swalstyles.iconreplicar}/>
                            </div>
                            {renderModalFuncionariosFuncaoBodyFuncionario(funcionario)}
                            <div className={swalstyles.listfuncionariosfuncaoobservacao}>{funcionario.organograma_funcionario.observacao || ''}</div>
                            <div className={swalstyles.listfuncionariosfuncaodescricao}>{funcionario.organograma_funcionario.turno || '-'}</div>
                            <div className={swalstyles.listfuncionariosfuncaodescricao}>{renderModalFuncionariosFuncaoBodyDate(funcionario.data_admissao, funcionario.organograma_funcionario.admissao_prevista)}</div>
                            <div className={swalstyles.listfuncionariosfuncaodescricao}>{renderModalFuncionariosFuncaoBodyDate(funcionario.data_demissao, funcionario.organograma_funcionario.demissao_prevista)}</div>
                        </div>
                    )
                })
            )
        } else {
            return (
                <div className={swalstyles.listfuncionariosfuncaonodata}>
                    Nenhum funcionário escalado nesta função
                </div>
            )
        }
    }

    function renderCriarNovaVaga() {
        return (
            <div className={[previsaostyles.conteinercriar, previsaostyles.conteinercriarremovemargintop, swalstyles.conteinerpopup].join(' ')}>
                <span className={swalstyles.popup}>Adicionar Vaga</span>
                <div className={previsaostyles.buttoncriar} onClick={() => {handleCriarNovaVaga()}}
                    onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}
                >
                    <IoMdAdd className={previsaostyles.iconcriar}/>
                </div>
            </div>
        )
    }

    function renderTotalSalarioFuncionarioFuncao() {
        return (
            <div className={swalstyles.salariofuncionariosfuncao}>
                <div className={swalstyles.conteinersalariototalatual}>
                    <div>
                        TOTAL:
                    </div>
                    <div className={swalstyles.conteinerpopup}>
                        <span className={swalstyles.popup}>
                            {renderPopupDetailsSalario('Salário Mensal Médio da Previsão',
                                [
                                    {text: 'Salário', value: funcionariosFuncao.info_salario.salario_total, awaysShow: true},
                                ], funcionariosFuncao.info_salario.quantidades
                            )}
                        </span>
                        <div className={[swalstyles.conteinersalarioatual, swalstyles.conteinerpopupdetailssalario].join(' ')}
                            onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}
                            onClick={() => handleToastShowHtml(
                                renderPopupDetailsSalario('Salário Mensal Médio da Previsão',
                                    [
                                        {text: 'Salário', value: funcionariosFuncao.info_salario.salario_total, awaysShow: true}
                                    ], funcionariosFuncao.info_salario.quantidades
                                )
                            )}
                        >
                            {(funcionariosFuncao.info_salario.salario_total * (funcionariosFuncao.info_salario.quantidades.quantidade_funcionarios + funcionariosFuncao.info_salario.quantidades.quantidade_vagas)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </div>
                    </div>
                </div>
                {renderInfoSalario('funcionariosFuncao', {funcao: funcionariosFuncao.head.funcao})}
            </div>
        )
    }

    function renderModalFuncionariosFuncaoCheckVerLancamentos() {
        return (
            <div className={swalstyles.conteinerchecklancamentos}>
                <div className={swalstyles.conteinercheckdissidio} onClick={() => setVerLancamentosAnteriores(!verLancamentosAnteriores)}>
                    <div className={swalstyles.checkconteiner}>
                        <TiTick className={verLancamentosAnteriores ? swalstyles.checkicon : [swalstyles.checkicon, swalstyles.checkiconnone].join(' ')}/>
                    </div>
                    <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                        Visualizar Lançamentos Anteriores
                    </div>
                </div>
                <div className={swalstyles.conteinercheckdissidio} onClick={() => setVerLancamentosFuturos(!verLancamentosFuturos)}>
                    <div className={swalstyles.checkconteiner}>
                        <TiTick className={verLancamentosFuturos ? swalstyles.checkicon : [swalstyles.checkicon, swalstyles.checkiconnone].join(' ')}/>
                    </div>
                    <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                        Visualizar Lançamentos Futuros
                    </div>
                </div>
            </div>
        )
    }

    function renderModalFuncionariosFuncao() {
        if(modalFuncionariosFuncao) {
            if(funcionariosFuncao.imported) {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modallargerwidth, swalstyles.modalmaxheight4rows].join(' ')}>
                            <div>
                                <div className={swalstyles.titlemodalfuncionarios}>
                                    {`${funcionariosFuncao.head.departamento.codigo} - ${funcionariosFuncao.head.departamento.descricao}`}
                                </div>
                                {renderModalFuncionariosFuncaoCheckVerLancamentos()}
                                <div className={swalstyles.conteinersubtitlemodalfuncionariosfuncao}>
                                    <div className={swalstyles.subtitlemodalfuncionariosfuncao}>
                                        {`${funcionariosFuncao.head.funcao.codigo} - ${funcionariosFuncao.head.funcao.descricao}`}
                                    </div>
                                    {renderCriarNovaVaga()}
                                    <div className={swalstyles.conteinerlegendafuncionariosfuncao}>
                                        <div className={swalstyles.legendafuncionariosfuncao}>
                                            <div className={swalstyles.legendatitle}>NÃO CONFIRMADOS</div>
                                            <div className={swalstyles.legendadescricao}>
                                                <BsFillSquareFill className={swalstyles.legendaicondem}/> Demissão Emitida
                                            </div>
                                            <div className={swalstyles.legendadescricao}>
                                                <BsFillSquareFill className={swalstyles.legendaiconadm}/> Admissão Emitida
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={[swalstyles.conteinerbody, swalstyles.conteinerbodymaxheight].join(' ')}>
                                <div className={[swalstyles.listfuncionariosfuncao, swalstyles.headlistfuncionariosfuncao].join(' ')}>
                                    <div>FUNCIONÁRIO</div>
                                    <div>OBSERVAÇÃO</div>
                                    <div>TURNO</div>
                                    <div>ADMISSÃO</div>
                                    <div>DEMISSÃO</div>
                                </div>
                                {renderModalFuncionariosFuncaoBody()}
                            </div>
                            <div className={swalstyles.conteinerlegendafuncionariosfuncao}>
                                {renderTotalSalarioFuncionarioFuncao()}
                            </div>
                            {renderActionsModalFuncionariosFuncao()}
                        </div>
                    </div>
                )
            }
            else {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modallargerwidth, swalstyles.modalmaxheight3rows].join(' ')}>
                            <div className={swalstyles.titlemodalfuncionarios}>
                                {`${funcionariosFuncao.head.departamento.codigo} - ${funcionariosFuncao.head.departamento.descricao}`}
                            </div>
                            <div className={swalstyles.conteinerbuttons}>
                                <div className={loadingstyles.divloading}>
                                    <div className={loadingstyles.loading}></div>
                                </div>
                            </div>
                            <div></div>
                        </div>
                    </div>
                )
            }
        }
    }

    function handleExibirSelectVaga(funcionarioVaga, inputDepartamento, inputFuncao) {
        setModalSelectVaga(true);
        setFuncionarioVaga(funcionarioVaga);
        setInputModalFuncionarioDepartamento(inputDepartamento || funcionarioVaga.departamento.codigo.slice(0, 8));
        if(inputFuncao) {
            setInputModalFuncionarioFuncao(inputFuncao);
        }

        api.get(`/previsao/getVagasAberto?id_cenario_organograma=${headerOrganograma.id_cenario_organograma}&data_filtro=${selectPeriodo.selectItem}`).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else {
                    if(response.data.vagas) {
                        setSelectVagas({
                            imported: true,
                            vagas: response.data.vagas,
                        });
                    }
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        });
    }

    function resetSelectVaga() {
        setModalSelectVaga(false);
        setSelectVagasCheckPeriodo(true);
        setFuncionarioVaga({});
        setSelectVagas({});
        setInputModalFuncionarioDepartamento('');
        setInputModalFuncionarioFuncao('');
    }

    function closeSelectVaga() {
        resetSelectVaga();

        if(previousModal[previousModal.length - 1].modalName === 'pesquisarFuncionarios') {
            handlePesquisarFuncionarios(previousModal[previousModal.length - 1].selectModalFuncionarioTip, previousModal[previousModal.length - 1].enableChange, previousModal[previousModal.length - 1].inputModalFuncionarioFunc, previousModal[previousModal.length - 1].inputModalFuncionarioDpto, previousModal[previousModal.length - 1].inputModalFuncionarioFun);
        } else if(previousModal[previousModal.length - 1].modalName === 'funcionariosFuncao') {
            handleExibirFuncionariosFuncao(previousModal[previousModal.length - 1].departamento, previousModal[previousModal.length - 1].funcao);
        }

        popPreviousModal();
    }

    function nextSelectVaga(vaga, funcionarioVaga) {
        pushPreviousModal({
            modalName: 'selectVaga',
            funcionarioVaga: funcionarioVaga,
            inputDepartamento: inputModalFuncionarioDepartamento,
            inputFuncao: inputModalFuncionarioFuncao,
        });
        
        resetSelectVaga();

        if(!vaga) {
            handleExibirFuncionarioToEdit(funcionarioVaga);
        } else {
            handleExibirFuncionarioToEdit(vaga, null, null, null, null,
                {
                    id: funcionarioVaga.id,
                    matricula: funcionarioVaga.matricula,
                    nome: funcionarioVaga.nome,
                    data_admissao: funcionarioVaga.data_admissao,
                    ativo: funcionarioVaga.ativo,
                    departamento: funcionarioVaga.departamento,
                    funcao: funcionarioVaga.funcao,
                    removeBlocked: true,
                }
            );
        }
    }

    function renderActionsModalSelectVagaCancel() {
        return (
            <div className={swalstyles.conteinerbuttons}>
                <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                    value='CANCELAR' onClick={() => {closeSelectVaga()}}
                />
            </div>
        )
    }

    function renderModalSelectVagaListVagasAtividade(atividade, tipo_departamento) {
        if(tipo_departamento >= 2) {
            return (
                <>
                    <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                        ATIVIDADE
                    </div>
                    <div className={swalstyles.conteinerfuncionariotoeditdesc}>
                        <div>{atividade != null ? atividade : '-'}</div>
                    </div>
                </>
            )
        }
    }

    function renderModalSelectVagaListVagas() {
        return (
            selectVagas.vagas.map((vaga, index) => {
                if((
                    regexTextoAproximado((vaga.organograma.departamento.codigo), inputModalFuncionarioDepartamento) ||
                    regexTextoAproximado((vaga.organograma.departamento.descricao), inputModalFuncionarioDepartamento)
                ) &&
                (
                    regexTextoAproximado((vaga.organograma.funcao.codigo), inputModalFuncionarioFuncao) ||
                    regexTextoAproximado((vaga.organograma.funcao.descricao), inputModalFuncionarioFuncao)
                ) &&
                ((selectVagasCheckPeriodo && (!vaga.organograma_funcionario.demissao_prevista || moment(vaga.organograma_funcionario.demissao_prevista, 'YYYY MM DD').isSameOrAfter(moment(funcionarioVaga.data_admissao, 'YYYY MM DD')))) || !selectVagasCheckPeriodo)
                ) {
                    return (
                        <div className={swalstyles.listselectvagas} key={index} onClick={() => nextSelectVaga(vaga, funcionarioVaga)}>
                            <div>
                                <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                                    DEPARTAMENTO
                                </div>
                                <div className={[swalstyles.conteinerfuncionariotoeditdescgrid, swalstyles.conteinerfuncionariotoeditdesc].join(' ')}>
                                    <div>{vaga.organograma.departamento.codigo}</div>
                                    <div>{vaga.organograma.departamento.descricao}</div>
                                </div>
                                <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                                    FUNCAO
                                </div>
                                <div className={[swalstyles.conteinerfuncionariotoeditdescgrid, swalstyles.conteinerfuncionariotoeditdesc].join(' ')}>
                                    <div>{vaga.organograma.funcao.codigo}</div>
                                    <div>{vaga.organograma.funcao.descricao}</div>
                                </div>
                            </div>
                            <div>
                                <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                                    TURNO
                                </div>
                                <div className={swalstyles.conteinerfuncionariotoeditdesc}>
                                    <div>{vaga.organograma_funcionario.turno}</div>
                                </div>
                                {renderModalSelectVagaListVagasAtividade(vaga.organograma_funcionario.id_atividade, vaga.organograma.departamento.tipo)}
                            </div>
                            <div>
                                <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                                    ADMISSÃO
                                </div>
                                <div className={swalstyles.conteinerfuncionariotoeditdesc}>
                                    <div>{vaga.organograma_funcionario.admissao_prevista ? moment(vaga.organograma_funcionario.admissao_prevista, 'YYYY MM DD').format('DD/MM/YYYY') : 'Não Informado'}</div>
                                </div>
                                <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                                    DEMISSÃO
                                </div>
                                <div className={[swalstyles.conteinerfuncionariotoeditdesc, moment(vaga.organograma_funcionario.demissao_prevista, 'YYYY MM DD').isBefore(moment(funcionarioVaga.data_admissao, 'YYYY MM DD')) ? swalstyles.redalert : ''].join(' ')}>
                                    <div>{vaga.organograma_funcionario.demissao_prevista ? moment(vaga.organograma_funcionario.demissao_prevista, 'YYYY MM DD').format('DD/MM/YYYY') : 'Não Informado'}</div>
                                </div>
                            </div>
                        </div>
                    )
                }
            })
        )
    }

    function renderModalSelectVagaCheckPeriodo() {
        return (
            <div className={swalstyles.conteinercheckdissidio} style={{justifyContent: 'flex-end'}} onClick={() => setSelectVagasCheckPeriodo(!selectVagasCheckPeriodo)}>
                <div className={swalstyles.checkconteiner}>
                    <TiTick className={selectVagasCheckPeriodo ? swalstyles.checkicon : [swalstyles.checkicon, swalstyles.checkiconnone].join(' ')}/>
                </div>
                <div className={swalstyles.conteinerhistoricofuncionariolabel} style={{width: 'unset', fontSize: '100%'}}>
                    Não exibir vagas anteriores à admissão
                </div>
            </div>
        )
    }

    function renderModalSelectVaga() {
        if(modalSelectVaga) {
            if(selectVagas.imported) {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modallargerwidth, swalstyles.modalmaxheight4rows].join(' ')}>
                            <div>
                                <div className={swalstyles.titlemodalfuncionarios}>
                                    <div>{funcionarioVaga.matricula} - {funcionarioVaga.nome}</div>
                                </div>
                                <div className={swalstyles.conteinertitlehistoricofuncionario}>
                                    <div className={swalstyles.conteinertitlehistoricofuncionarioL}>
                                        <div>{funcionarioVaga.departamento.codigo} - {funcionarioVaga.departamento.descricao}</div>
                                        <div>{funcionarioVaga.funcao.codigo} - {funcionarioVaga.funcao.descricao}</div>
                                    </div>
                                    <div className={swalstyles.conteinertitlehistoricofuncionarioR}>
                                        <div>
                                            Admissão: {moment(funcionarioVaga.data_admissao, 'YYYY MM DD').format('DD/MM/YYYY')}
                                        </div>
                                        {renderModalSelectVagaCheckPeriodo()}
                                    </div>
                                </div>
                                <div className={swalstyles.conteinerfilterlistfuncionarios}>
                                    <div className={swalstyles.filterlistfuncionarios}>
                                        <input
                                            className={swalstyles.inputfilterlistfuncionarios}
                                            type='text'
                                            placeholder='Digite o código ou descrição do departamento'
                                            value={inputModalFuncionarioDepartamento}
                                            onChange={(e) => setInputModalFuncionarioDepartamento(regexMaskDepartamento(e.target.value))}
                                        />
                                        <input
                                            className={swalstyles.inputfilterlistfuncionarios}
                                            type='text'
                                            placeholder='Digite o código ou descrição da função'
                                            value={inputModalFuncionarioFuncao}
                                            onChange={(e) => setInputModalFuncionarioFuncao(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={[swalstyles.conteinerbody, swalstyles.conteinerbodymaxheight].join(' ')}>
                                <div className={swalstyles.headlistselectvagas}>
                                    Selecione uma Vaga:
                                    <div className={swalstyles.buttoninserirsemvaga} onClick={() => nextSelectVaga(null, funcionarioVaga)}>
                                        FORÇAR INSERÇÃO SEM UMA VAGA
                                    </div>
                                </div>
                                {renderModalSelectVagaListVagas()}
                            </div>
                            {renderActionsModalSelectVagaCancel()}
                        </div>
                    </div>
                )
            }
            else {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modallargerwidth, swalstyles.modalmaxheight3rows].join(' ')}>
                            <div className={swalstyles.titlemodalfuncionarios}>
                                <div>{funcionarioVaga.matricula} - {funcionarioVaga.nome}</div>
                            </div>
                            <div className={swalstyles.conteinerbuttons}>
                                <div className={loadingstyles.divloading}>
                                    <div className={loadingstyles.loading}></div>
                                </div>
                            </div>
                            <div></div>
                        </div>
                    </div>
                )
            }
        }
    }

    function handleExibirFuncionarioToEdit(funcionario, observacao, dataAdm, dataDem, calcRecisao, newFuncionario) {
        setModalFuncionarioToEdit(true);

        if(dataAdm != null) {
            setDataAdmToEdit(dataAdm);
        } else if(funcionario.organograma_funcionario.admissao_prevista) {
            setDataAdmToEdit(moment(funcionario.organograma_funcionario.admissao_prevista, 'YYYY MM DD').format('DD/MM/YYYY'));
        } else if(!funcionario.id && !newFuncionario) {
            setDataAdmToEdit(moment(headerOrganograma.data_inicial, 'YYYY MM DD').format('DD/MM/YYYY'))
        }

        if(dataDem != null) {
            setDataDemToEdit(dataDem);
        } else if(funcionario.organograma_funcionario.demissao_prevista) {
            setDataDemToEdit(moment(funcionario.organograma_funcionario.demissao_prevista, 'YYYY MM DD').format('DD/MM/YYYY'));
        }

        if(newFuncionario && newFuncionario.id) {
            setNewFuncionarioToEdit(newFuncionario);
            setInputNewFuncionarioToEdit(newFuncionario.matricula);
        }

        setInputObservacaoToEdit(validaObservacaoToEdit(observacao || funcionario.organograma_funcionario.observacao || '', false));
        setCalculaRecisao(calcRecisao != null ? calcRecisao : funcionario.organograma_funcionario.calcula_recisao);
        setFuncionarioToEdit(funcionario);
    }

    function resetFuncionarioToEdit() {
        setModalFuncionarioToEdit(false);
        setDataAdmToEdit('');
        setDataDemToEdit('');
        setCalculaRecisao(null);
        setFuncionarioToEdit({});
        setNewFuncionarioToEdit({});
        setInputNewFuncionarioToEdit('');
    }

    function closeFuncionarioToEdit(jumpSelectVaga, funcionarioToReload) {
        resetFuncionarioToEdit();

        if(funcionarioToReload) {
            handleExibirFuncionarioToEdit(funcionarioToReload);

            return;
        } else if(previousModal[previousModal.length - 1].modalName === 'funcionariosFuncao') {
            handleExibirFuncionariosFuncao(previousModal[previousModal.length - 1].departamento, previousModal[previousModal.length - 1].funcao);
        } else if(previousModal[previousModal.length - 1].modalName === 'inconsistenciasDepartamentoFuncao') {
            handleInconsistenciasDepartamentoFuncao(previousModal[previousModal.length - 1].selectModalInconsistenciaTip, previousModal[previousModal.length - 1].inputModalFuncionarioDpto, previousModal[previousModal.length - 1].inputModalFuncionarioFun);
        } else if(previousModal[previousModal.length - 1].modalName === 'pesquisarFuncionarios') {
            handlePesquisarFuncionarios(previousModal[previousModal.length - 1].selectModalFuncionarioTip, previousModal[previousModal.length - 1].enableChange, previousModal[previousModal.length - 1].inputModalFuncionarioFunc, previousModal[previousModal.length - 1].inputModalFuncionarioDpto, previousModal[previousModal.length - 1].inputModalFuncionarioFun);
        } else if(previousModal[previousModal.length - 1].modalName === 'funcionarioToEdit') {
            handleExibirFuncionarioToEdit(previousModal[previousModal.length - 1].funcionarioToEdit);
        } else if(previousModal[previousModal.length - 1].modalName === 'selectVaga' && previousModal[previousModal.length - 2].modalName === 'pesquisarFuncionarios' && jumpSelectVaga) {
            handlePesquisarFuncionarios(previousModal[previousModal.length - 2].selectModalFuncionarioTip, previousModal[previousModal.length - 2].enableChange, previousModal[previousModal.length - 2].inputModalFuncionarioFunc, previousModal[previousModal.length - 2].inputModalFuncionarioDpto, previousModal[previousModal.length - 2].inputModalFuncionarioFun);
        } else if(previousModal[previousModal.length - 1].modalName === 'selectVaga' && previousModal[previousModal.length - 2].modalName === 'funcionariosFuncao' && jumpSelectVaga) {
            handleExibirFuncionariosFuncao(previousModal[previousModal.length - 2].departamento, previousModal[previousModal.length - 2].funcao);
        } else if(previousModal[previousModal.length - 1].modalName === 'selectVaga' && !jumpSelectVaga) {
            handleExibirSelectVaga(previousModal[previousModal.length - 1].funcionarioVaga, previousModal[previousModal.length - 1].inputDepartamento, previousModal[previousModal.length - 1].inputFuncao);
        }

        popPreviousModal();
    }

    function nextFuncionarioToEdit(redirectTo, data) {
        pushPreviousModal({
            modalName: 'funcionarioToEdit',
            funcionarioToEdit: funcionarioToEdit,
            observacaoToEdit: inputObservacaoToEdit,
            dataAdmToEdit: dataAdmToEdit,
            dataDemToEdit: dataDemToEdit,
            calculaRecisaoToEdit: calculaRecisao,
            newFuncionarioToEdit: newFuncionarioToEdit,
        });

        resetFuncionarioToEdit();

        if(redirectTo === 'pesquisarFuncionarios') {
            handlePesquisarFuncionarios(245, false);
        } else if(redirectTo === 'historicoFuncionario') {
            handleHistoricoFuncionario(data);
        } else if(redirectTo === 'editSalarioFuncao') {
            handleExibirEditSalarioFuncao(data);
        }
    }

    function handleGetNewFuncionario() {
        nextFuncionarioToEdit('pesquisarFuncionarios');
    }

    function validaMatriculaFuncionarioToEdit(e) {
        setInputNewFuncionarioToEdit(onlyNumbers(e.target.value).slice(0, 8));

        if(newFuncionarioToEdit.id || newFuncionarioToEdit.notFound) {
            setNewFuncionarioToEdit({});
        }
    }

    function dataAdmDemIsValid(data, isRequired, dataMax) {
        let maxDate;

        if((/\d{2}\/\d{2}\/\d{4}/g).test(dataMax)) {
            if(moment(dataMax, 'DD MM YYYY').isValid()) {
                maxDate = moment(dataMax, 'DD MM YYYY');
            }
        } else if((/\d{4}-\d{2}-\d{2}/g).test(dataMax)) {
            if(moment(dataMax, 'YYYY MM DD').isValid()) {
                maxDate = moment(dataMax, 'YYYY MM DD');
            }
        }

        if(isRequired && (data == null || !data.length)) {
            return { error: false, type: 1 };
        } else if((!(/\d{2}\/\d{2}\/\d{4}/g).test(data) || !moment(data, 'DD MM YYYY').isValid()) && data.length) {
            return { error: false, type: 2 };
        } else if(!isRequired && maxDate && maxDate.isAfter(moment(data, 'DD MM YYYY'))) {
            return { error: false, type: 3 };
        } else if(isRequired && maxDate && maxDate.isBefore(moment(data, 'DD MM YYYY'))) {
            return { error: false, type: 4 };
        } else {
            return { error: true };
        }
    }

    function handleManterVagaFuncionarioOrganograma(funcionario) {
        setSaving(true);

        Swal.fire({
            customClass: {
                container: swalstyles.swalcontainer,
                popup: swalstyles.swalbackground
            },
            title: `CONFIRME A PERMANÊNCIA DA VAGA!`,
            text: `DESEJA REALMENTE MANTER A VAGA?`,
            confirmButtonText: 'CONFIRMAR', 
            focusDeny: true,
            showDenyButton: true,
            denyButtonText: 'CANCELAR',
            allowOutsideClick: false,
        }).then(result => {
            if(result.isConfirmed) {
                salvarFuncionarioOrganograma({
                    removerVaga: {
                        id_organograma_funcionario: funcionario.organograma_funcionario.id,
                        id_funcionario: funcionario.id
                    },
                    historicoNew: [{
                        id_organograma_funcionario: null,
                        id_organograma: funcionario.organograma.id,
                        id_atividade: funcionario.organograma_funcionario.id_atividade,
                        turno: funcionario.organograma_funcionario.turno,
                        quantidade: funcionario.organograma_funcionario.quantidade,
                        data_inicial: headerOrganograma.data_inicial,
                    }],
                    funcionarioOrganograma: {
                        id: null,
                        id_cenario_organograma: headerOrganograma.id_cenario_organograma,
                        id_funcionario_old: funcionario.id,
                        id_funcionario: null,
                        insercao_lote: funcionario.organograma_funcionario.insercao_lote,
                        observacao: null,
                        admissao_prevista: moment(funcionario.data_demissao, 'YYYY MM DD').add(1, 'day').format('YYYY-MM-DD'),
                        demissao_prevista: null,
                        calcula_recisao: 1,
                    },
                    data_filtro: selectPeriodo.selectItem,
                });
            } else {
                setSaving(false);
            }
        });
    }

    function handleDeleteFuncionarioOrganograma() {
        setSaving(true);

        Swal.fire({
            customClass: {
                container: swalstyles.swalcontainer,
                popup: swalstyles.swalbackground
            },
            title: `CONFIRME A EXCLUSÃO DA ${funcionarioToEdit.id ? 'VAGA' : 'PREVISÃO'}!`,
            text: `DESEJA REALMENTE EXCLUIR A ${funcionarioToEdit.id ? 'VAGA' : 'PREVISÃO DE CONTRATAÇÃO'}?`,
            confirmButtonText: 'CONFIRMAR', 
            focusDeny: true,
            showDenyButton: true,
            denyButtonText: 'CANCELAR',
            allowOutsideClick: false,
        }).then(result => {
            if(result.isConfirmed) {
                salvarFuncionarioOrganograma({
                    removerVaga: {id_organograma_funcionario: funcionarioToEdit.organograma_funcionario.id, id_funcionario: funcionarioToEdit.id},
                    data_filtro: selectPeriodo.selectItem,
                });
            } else {
                setSaving(false);
            }
        });
    }

    function handleSalvarFuncionarioOrganograma(autoCorrecao, bodyInconsistencia) {
        if(!(funcionarioToEdit.data_admissao || newFuncionarioToEdit.data_admissao || dataAdmDemIsValid(dataAdmToEdit, true, headerOrganograma.data_final).error)
            || !dataAdmDemIsValid(dataDemToEdit, false, funcionarioToEdit.data_admissao || newFuncionarioToEdit.data_admissao || dataAdmToEdit).error
        ) {
            handleToastShow('Por Favor, Preencha Todos os Campos Corretamente!');
        } else if(!funcionarioToEdit.organograma.id) {
            handleToastShow('Por Favor, Cadastre uma Previsão para esse Funcionário!');
        } else {
            setSaving(true);

            if(
                (funcionarioToEdit.organograma_funcionario.observacao || '') !== inputObservacaoToEdit || newFuncionarioToEdit.id ||
                funcionarioToEdit.organograma_funcionario.calcula_recisao !== calculaRecisao ||
                (dataAdmToEdit === '' ? null : moment(dataAdmToEdit, 'DD MM YYYY').format('YYYY-MM-DD')) !== funcionarioToEdit.organograma_funcionario.admissao_prevista ||
                (dataDemToEdit === '' ? null : moment(dataDemToEdit, 'DD MM YYYY').format('YYYY-MM-DD')) !== funcionarioToEdit.organograma_funcionario.demissao_prevista
            ) {

                const edit = {
                    funcionarioOrganograma: {
                        id: funcionarioToEdit.organograma_funcionario.id,
                        id_cenario_organograma: headerOrganograma.id_cenario_organograma,
                        id_funcionario_old: funcionarioToEdit.id,
                        id_funcionario: newFuncionarioToEdit.id || funcionarioToEdit.id,
                        insercao_lote: funcionarioToEdit.organograma_funcionario.insercao_lote,
                        observacao: inputObservacaoToEdit,
                        admissao_prevista: dataAdmToEdit && dataAdmToEdit !== '' ? moment(dataAdmToEdit, 'DD MM YYYY').format('YYYY-MM-DD') : funcionarioToEdit.organograma_funcionario.admissao_prevista || newFuncionarioToEdit.data_admissao,
                        demissao_prevista: dataDemToEdit && dataDemToEdit !== '' ? moment(dataDemToEdit, 'DD MM YYYY').format('YYYY-MM-DD') : null,
                        calcula_recisao: calculaRecisao,
                    },
                    data_filtro: selectPeriodo.selectItem,
                    autoCorrecao: autoCorrecao || false,
                }

                if(autoCorrecao) {
                    edit.correcaoHistorico = {
                        new_departamento: newFuncionarioToEdit.departamento.id,
                        new_funcao: newFuncionarioToEdit.funcao.id,
                        id_cenario_organograma: headerOrganograma.id_cenario_organograma,
                        id_organograma_funcionario_historico: funcionarioToEdit.organograma_funcionario.id_historico_atual,
                        data_inicial_corrigida: newFuncionarioToEdit.data_admissao ? moment(newFuncionarioToEdit.data_admissao, 'YYYY MM DD').startOf('month').format('YYYY-MM-DD') : moment(dataAdmToEdit, 'DD MM YYYY').isBefore((moment(headerOrganograma.data_inicial, 'YYYY MM DD'))) ? headerOrganograma.data_inicial : moment(dataAdmToEdit, 'DD MM YYYY').startOf('month').format('YYYY-MM-DD'),
                    }
                }

                if(!funcionarioToEdit.organograma_funcionario.id) {
                    edit.historicoNew = [{
                        id_organograma_funcionario: funcionarioToEdit.organograma_funcionario.id,
                        id_organograma: funcionarioToEdit.organograma.id,
                        id_atividade: null,
                        turno: funcionarioToEdit.organograma_funcionario.turno,
                        quantidade: funcionarioToEdit.organograma_funcionario.quantidade,
                        data_inicial: newFuncionarioToEdit.data_admissao ? moment(newFuncionarioToEdit.data_admissao, 'YYYY MM DD').startOf('month').format('YYYY-MM-DD') : moment(dataAdmToEdit, 'DD MM YYYY').isBefore((moment(headerOrganograma.data_inicial, 'YYYY MM DD'))) ? headerOrganograma.data_inicial : moment(dataAdmToEdit, 'DD MM YYYY').startOf('month').format('YYYY-MM-DD'),
                    }];
                }

                salvarFuncionarioOrganograma(edit, bodyInconsistencia);
            } else {
                setSaving(false);
                if(previousModal[previousModal.length - 1].modalName === 'selectVaga') {
                    closeFuncionarioToEdit(true);
                } else {
                    closeFuncionarioToEdit();
                }
            }
        }
    }

    function handleChangeHistoricoFuncionarioOrganograma() {
        if(!(funcionarioToEdit.data_admissao || newFuncionarioToEdit.data_admissao || dataAdmDemIsValid(dataAdmToEdit, true, headerOrganograma.data_final).error)
            || !dataAdmDemIsValid(dataDemToEdit, false, funcionarioToEdit.data_admissao || newFuncionarioToEdit.data_admissao || dataAdmToEdit).error
        ) {
            handleToastShow('Por Favor, Preencha Todos os Campos Corretamente!');
        } else if(!funcionarioToEdit.organograma.id) {
            handleToastShow('Por Favor, Cadastre uma Previsão para esse Funcionário!');
        } else {
            Swal.fire({
                customClass: {
                    container: swalstyles.swalcontainer,
                    popup: swalstyles.swalbackground,
                    actions: swalstyles.swalactionswrap,
                    confirmButton: [swalstyles.buttons, swalstyles.confirmbutton].join(' '),
                    cancelButton: [swalstyles.buttons, swalstyles.denybutton].join(' '),
                    denyButton: [swalstyles.buttons, swalstyles.denybutton].join(' '),
                },
                title: 'ALGUMAS INCONSISTÊNCIAS FORAM DETECTADAS!',
                text: 'É NECESSÁRIO CORRIGIR PARA PROSSEGUIR. SELECIONE A OPÇÃO QUE MELHOR LHE ATENDE.',
                confirmButtonText: 'CORRIGIR MANUALMENTE (recomendado)',
                showDenyButton: true,
                denyButtonText: 'CONFIRMAR E PERMITIR INCONSISTÊNCIAS',
                showCancelButton: true,
                cancelButtonText: 'EXECUTAR AS CORREÇÕES AUTOMÁTICAS',
                showCloseButton: true,
                buttonsStyling: false,
                allowOutsideClick: false,
            }).then(result => {
                if(result.isDenied) {
                    const bodyInconsistencia = {
                        id_organograma_funcionario_historico: funcionarioToEdit.organograma_funcionario.id_historico_atual,
                        id_inconsistencia: funcionarioToEdit.inconsistencia.id,
                        new_inconsistencia_permitida: 1,
                        id_cenario_organograma: headerOrganograma.id_cenario_organograma,
                        id_empresa: headerOrganograma.id_empresa,
                        data_filtro: selectPeriodo.selectItem,
                    }

                    handleSalvarFuncionarioOrganograma(false, bodyInconsistencia);
                } else if(result.isConfirmed) {
                    nextFuncionarioToEdit('historicoFuncionario', {
                        id: funcionarioToEdit.id || newFuncionarioToEdit.id,
                        matricula: funcionarioToEdit.matricula || newFuncionarioToEdit.matricula,
                        nome: funcionarioToEdit.nome || newFuncionarioToEdit.nome,
                        ativo: funcionarioToEdit.id ? funcionarioToEdit.ativo : newFuncionarioToEdit.ativo,
                        data_admissao: funcionarioToEdit.data_admissao || newFuncionarioToEdit.data_admissao || moment(dataAdmToEdit, 'DD MM YYYY').format('YYYY-MM-DD'),
                        data_demissao: funcionarioToEdit.ativo === 0 ? funcionarioToEdit.data_demissao : dataAdmDemIsValid(dataDemToEdit, true, funcionarioToEdit.data_admissao || newFuncionarioToEdit.data_admissao || dataAdmToEdit).error ? moment(dataDemToEdit, 'DD MM YYYY').format('YYYY-MM-DD') : null,
                        departamento: funcionarioToEdit.id ? funcionarioToEdit.departamento : newFuncionarioToEdit.departamento,
                        funcao: funcionarioToEdit.id ? funcionarioToEdit.funcao : newFuncionarioToEdit.funcao,
                        id_departamento_organograma: funcionarioToEdit.organograma.departamento.id,
                        id_funcao_organograma: funcionarioToEdit.organograma.funcao.id,
                        id_organograma_funcionario: funcionarioToEdit.organograma_funcionario.id,
                        status: funcionarioToEdit.organograma_funcionario.id ? funcionarioToEdit.organograma_funcionario.status : 1,
                        insercao_lote: funcionarioToEdit.organograma_funcionario.insercao_lote,
                    })
                } else if(result.isDismissed && result.dismiss === 'cancel') {
                    handleSalvarFuncionarioOrganograma(true);
                }
            });
        }
    }

    function salvarFuncionarioOrganograma(body, bodyInconsistencia) {
        body.id_cenario_organograma = headerOrganograma.id_cenario_organograma;

        api.post(`/previsao/salvarVagaOrganogramaFuncionario`, body).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);

                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'UM ERRO INESPERADO ACONTECEU!',
                        text: 'POR FAVOR CONTATE UM ADMINISTRADOR DO SISTEMA',
                        icon: 'error',
                    });
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else if(response.data.alertMessage.length) {
                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'UM ERRO INESPERADO ACONTECEU!',
                        html: response.data.alertMessage.join('<br />'),
                        icon: 'warning',
                    });

                    setSaving(false);

                    if(previousModal[previousModal.length - 1].modalName === 'funcionarioToEdit') {
                        resetHistoricoFuncionario();
                        handleExibirFuncionarioToEdit(previousModal[previousModal.length - 2].funcionarioToEdit, previousModal[previousModal.length - 2].observacaoToEdit, previousModal[previousModal.length - 2].dataAdmToEdit, previousModal[previousModal.length - 2].dataDemToEdit, previousModal[previousModal.length - 2].calculaRecisaoToEdit, previousModal[previousModal.length - 2].newFuncionarioToEdit);
                        popPreviousModal(true);
                    }
                } else {
                    if(bodyInconsistencia) {
                        api.post(`/previsao/salvarInconsistenciaDptoFuncao`, bodyInconsistencia).then(function (response) {
                            if (response.data) {
                                if(response.data.error) {
                                    console.log(`ERROR: ${response.data.error}`);
                                } else if(response.data.calc) {
                                    setPrevisaoCalc(true);
                                }
                            }
                        }).catch(function (error) {
                            // handle error
                            alert(error);
                            console.log(error);
                        });
                    }

                    setLoading(true);
                    setSaving(false);

                    if(body.addDemitido) {
                        closeHistoricoFuncionario(true, false, true);
                    } else if(!response.data.funcionario || response.data.funcionario.organograma_funcionario.status !== 1) {
                        closeFuncionarioToEdit();
                    } else if(previousModal[previousModal.length - 1].modalName === 'funcionarioToEdit' && previousModal[previousModal.length - 2].modalName === 'selectVaga') {
                        closeHistoricoFuncionario(true, response.data.funcionario);
                    } else if(previousModal[previousModal.length - 1].modalName === 'funcionarioToEdit') {
                        closeHistoricoFuncionario(false, response.data.funcionario);
                    } else if(previousModal[previousModal.length - 1].modalName === 'selectVaga') {
                        closeFuncionarioToEdit(true);
                    } else if(body.removerVaga && body.funcionarioOrganograma) {
                        closeFuncionarioToEdit(false, response.data.funcionario);
                    } else {
                        closeFuncionarioToEdit();
                    }
                }
            }
        }).catch(error => {
            // handle error
            alert(error);
            console.log(error);
        });
    }

    function renderModalFuncionarioToEditNewFuncionario() {
        if(searchingNewFuncionarioToEdit) {
            return (
                <div className={[swalstyles.funcionariotoeditdescfuncionario, swalstyles.bluealert, swalstyles.boldalert].join(' ')}>
                    Buscando...
                </div>
            )
        } else if(newFuncionarioToEdit.id) {
            return (
                <div className={swalstyles.funcionariotoeditdescfuncionario}>
                    {newFuncionarioToEdit.nome}
                </div>
            )
        } else if(newFuncionarioToEdit.notFound) {
            return (
                <div className={[swalstyles.funcionariotoeditdescfuncionario, swalstyles.redalert, swalstyles.boldalert].join(' ')}>
                    Funcionário não encontrado ou já previsto!
                </div>
            )
        } else {
            return (
                <div className={[swalstyles.funcionariotoeditdescfuncionario, swalstyles.redalert, swalstyles.boldalert].join(' ')}>
                    Nenhum funcionário selecionado!
                </div>
            )
        }
    }

    function renderModalFuncionarioToEditId() {
        if(funcionarioToEdit.organograma_funcionario.id) {
            return(
                <div className={swalstyles.conteinerfuncionariotoeditid}>
                    id: {funcionarioToEdit.organograma_funcionario.id}
                </div>
            )
        }
    }

    function validaObservacaoToEdit(value, validaObservacao) {
        if(validaObservacao) {
            return value.slice(0, 200);
        } else {
            return value.replace(/\r/g, '');
        }
    }

    function renderModalFuncionarioToEditInputObservacao() {
        if(funcionarioToEdit.id && !funcionarioToEdit.ativo) {
            return (
                <div className={swalstyles.conteinerfuncionariotoeditinputobservacao}>
                    <div className={swalstyles.funcionariotoeditinputobservacaolength}>
                        {inputObservacaoToEdit.length}/200
                    </div>
                    <textarea className={[swalstyles.funcionariotoeditinput, swalstyles.funcionariotoeditinputobservacao, swalstyles.funcionariotoeditinputdisabled].join(' ')}
                        rows={6} value={inputObservacaoToEdit} readOnly={true}
                    />
                </div>
            )
        } else {
            return (
                <div className={swalstyles.conteinerfuncionariotoeditinputobservacao}>
                    <div className={swalstyles.funcionariotoeditinputobservacaolength}>
                        {inputObservacaoToEdit.length}/200
                    </div>
                    <textarea className={[swalstyles.funcionariotoeditinput, swalstyles.funcionariotoeditinputobservacao].join(' ')}
                        rows={6} value={inputObservacaoToEdit}
                        onChange={e => setInputObservacaoToEdit(validaObservacaoToEdit(e.target.value, true))}
                    />
                </div>
            )
        }
    }

    function renderModalFuncionarioToEditInputFuncionario() {
        if(funcionarioToEdit.id) {
            return (
                <div className={[swalstyles.conteinerfuncionariotoeditdesc, swalstyles.conteinerfuncionariotoeditdescgrid].join(' ')}>
                    <div>{funcionarioToEdit.matricula}</div>
                    <div>{funcionarioToEdit.nome}</div>
                </div>
            )
        } else if(newFuncionarioToEdit.removeBlocked) {
            return (
                <div className={swalstyles.conteinerfuncionariotoeditfuncionario}>
                    <div className={swalstyles.conteinerfuncionariotoeditinputfuncionario}>
                        <input className={[swalstyles.funcionariotoeditinput, swalstyles.funcionariotoeditinputmatricula].join(' ')}
                            value={inputNewFuncionarioToEdit} readOnly={true}
                        />
                    </div>
                    {renderModalFuncionarioToEditNewFuncionario()}
                </div>
            )
        } else {
            return (
                <div className={swalstyles.conteinerfuncionariotoeditfuncionario}>
                    <div className={swalstyles.conteinerfuncionariotoeditinputfuncionario}>
                        <input className={[swalstyles.funcionariotoeditinput, swalstyles.funcionariotoeditinputmatricula].join(' ')}
                            value={inputNewFuncionarioToEdit}
                            placeholder='Digite a Matrícula do Colaborador' onChange={e => validaMatriculaFuncionarioToEdit(e)}
                            onKeyDown={e => setBlurOnKeyDown(e)} onBlur={e => searchFuncionarioByMatricula(inputNewFuncionarioToEdit)}
                        />
                        <div className={[swalstyles.conteinerpopup, swalstyles.conteinerfuncionariotoeditsearchicon].join(' ')}>
                            <span className={swalstyles.popup}>Pesquisar Funcionário</span>
                            <RiSearchLine className={swalstyles.funcionariotoeditsearchicon} onClick={() => handleGetNewFuncionario()}
                                onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}
                            />
                        </div>
                    </div>
                    {renderModalFuncionarioToEditNewFuncionario()}
                </div>
            )
        }
    }

    function handleHabilitarInsercaoPorFuncionario() {
        const newFuncionarioToEdit = Object.assign([], funcionarioToEdit);

        newFuncionarioToEdit.organograma_funcionario.insercao_lote = 0;
        newFuncionarioToEdit.organograma_funcionario.calcula_recisao = 1;
        setCalculaRecisao(1);

        setFuncionarioToEdit(newFuncionarioToEdit);
    }

    function renderModalFuncionarioToEditFuncionario() {
        if(!funcionarioToEdit.organograma_funcionario.id && !funcionarioToEdit.id && funcionarioToEdit.organograma_funcionario.insercao_lote) {
            return (
                <>
                    <div className={swalstyles.conteinerfuncionariotoeditbuttonhabilitar} onClick={() => handleHabilitarInsercaoPorFuncionario()}>
                        HABILITAR INSERÇÃO POR FUNCIONÁRIO
                    </div>
                </>
            )
        } else if(!funcionarioToEdit.organograma_funcionario.insercao_lote || funcionarioToEdit.organograma.departamento.tipo <= 1) {
            if(funcionarioToEdit.id && funcionarioToEdit.organograma_funcionario.id) {
                return (
                    <div className={swalstyles.conteinerfuncionariotoeditremovervaga}>
                        <div>
                            <div className={[swalstyles.conteinerfuncionariotoeditlabel, swalstyles.conteinerfuncionariotoeditlabelalert].join(' ')}>
                                FUNCIONÁRIO
                                {renderInfoSalario(
                                    'funcionarioToEdit',
                                    {
                                        funcionario: {
                                            id: funcionarioToEdit.id,
                                            matricula: funcionarioToEdit.matricula,
                                            nome: funcionarioToEdit.nome,
                                            status: funcionarioToEdit.organograma_funcionario.status,
                                        }
                                    }
                                )}
                            </div>
                            {renderModalFuncionarioToEditInputFuncionario()}
                        </div>
                        {renderReiniciarFuncionariosVaga((funcionarioToEdit.organograma_funcionario.id && funcionarioToEdit.ativo && funcionarioToEdit.id), null, funcionarioToEdit.organograma_funcionario.id)}
                    </div>
                )
            } else {
                return (
                    <div className={swalstyles.conteinerfuncionariotoeditremovervaga}>
                        <div>
                            <div className={swalstyles.conteinerfuncionariotoeditlabel}>
                                FUNCIONÁRIO
                            </div>
                            {renderModalFuncionarioToEditInputFuncionario()}
                        </div>
                        {renderReiniciarFuncionariosVaga((funcionarioToEdit.organograma_funcionario.id && funcionarioToEdit.ativo && funcionarioToEdit.id), null, funcionarioToEdit.organograma_funcionario.id)}
                    </div>
                )
            }
        }
    }

    function renderModalFuncionarioToEditAtividade() {
        if(funcionarioToEdit.organograma.departamento.tipo >= 2) {
            return (
                <>
                    <div className={swalstyles.conteinerfuncionariotoeditlabel}>
                        ATIVIDADE
                    </div>
                    <div className={swalstyles.conteinerfuncionariotoeditdesc}>
                        {funcionarioToEdit.organograma_funcionario.id_atividade || '-'}
                    </div>
                </>
            )
        }
    }

    function renderModalFuncionarioToEditQuantidade() {
        if(funcionarioToEdit.organograma_funcionario.insercao_lote) {
            return (
                <>
                    <div className={swalstyles.conteinerfuncionariotoeditlabel}>
                        QUANTIDADE
                    </div>
                    <div className={swalstyles.conteinerfuncionariotoeditdesc}>
                        {Number.isInteger(funcionarioToEdit.organograma_funcionario.quantidade) ? funcionarioToEdit.organograma_funcionario.quantidade.toFixed(0) : funcionarioToEdit.organograma_funcionario.quantidade.toFixed(2)} {funcionarioToEdit.organograma_funcionario.quantidade === 1 ? 'funcionário' : 'funcionários'}
                    </div>
                </>
            )
        }
    }

    function renderModalFuncionarioToEditButtonHistorico() {
        if(
            (funcionarioToEdit.data_admissao || newFuncionarioToEdit.data_admissao || dataAdmDemIsValid(dataAdmToEdit, true, headerOrganograma.data_final).error)
            && dataAdmDemIsValid(dataDemToEdit, false, funcionarioToEdit.data_admissao || newFuncionarioToEdit.data_admissao || dataAdmToEdit).error
        ) {
            return (
                <div className={swalstyles.conteinerfuncionariotoeditbuttonhistorico}
                    onClick={() => {nextFuncionarioToEdit('historicoFuncionario', {
                        id: funcionarioToEdit.id || newFuncionarioToEdit.id,
                        matricula: funcionarioToEdit.matricula || newFuncionarioToEdit.matricula,
                        nome: funcionarioToEdit.nome || newFuncionarioToEdit.nome,
                        ativo: funcionarioToEdit.id ? funcionarioToEdit.ativo : newFuncionarioToEdit.ativo,
                        data_admissao: funcionarioToEdit.data_admissao || newFuncionarioToEdit.data_admissao || moment(dataAdmToEdit, 'DD MM YYYY').format('YYYY-MM-DD'),
                        data_demissao: funcionarioToEdit.ativo === 0 ? funcionarioToEdit.data_demissao : dataAdmDemIsValid(dataDemToEdit, true, funcionarioToEdit.data_admissao || newFuncionarioToEdit.data_admissao || dataAdmToEdit).error ? moment(dataDemToEdit, 'DD MM YYYY').format('YYYY-MM-DD') : null,
                        departamento: funcionarioToEdit.id ? funcionarioToEdit.departamento : newFuncionarioToEdit.departamento,
                        funcao: funcionarioToEdit.id ? funcionarioToEdit.funcao : newFuncionarioToEdit.funcao,
                        id_departamento_organograma: funcionarioToEdit.organograma.departamento.id,
                        id_funcao_organograma: funcionarioToEdit.organograma.funcao.id,
                        id_organograma_funcionario: funcionarioToEdit.organograma_funcionario.id,
                        status: funcionarioToEdit.organograma_funcionario.id ? funcionarioToEdit.organograma_funcionario.status : 1,
                        insercao_lote: funcionarioToEdit.organograma_funcionario.insercao_lote,
                    })}}
                >
                    HISTÓRICO
                </div>
            )
        } else {
            return (
                <div className={[swalstyles.conteinerfuncionariotoeditbuttonhistorico, swalstyles.conteinerfuncionariotoeditbuttonhistoricoblock, swalstyles.redalert].join(' ')}
                    onClick={() => handleToastShow('Valide as Datas Antes de Prosseguir!')}
                >
                    HISTÓRICO
                </div>
            )
        }
    }

    function renderModalFuncionarioToEditConteinerHistorico() {
        if(funcionarioToEdit.organograma.id) {
            return (
                <div className={swalstyles.conteinerfuncionariotoeditconteinerhistorico}>
                    <div className={[swalstyles.conteinerfuncionariotoeditlabel, swalstyles.conteinerfuncionariotoeditlabelalert].join(' ')}>
                        DEPARTAMENTO
                        {renderAlertInconsistenciaDepartamento((funcionarioToEdit.id || newFuncionarioToEdit.id), (funcionarioToEdit.ativo || newFuncionarioToEdit.ativo),
                            funcionarioToEdit.organograma.departamento.id, (funcionarioToEdit.departamento.id || (newFuncionarioToEdit.id ? newFuncionarioToEdit.departamento.id : null)),
                            funcionarioToEdit.inconsistencia.inconsistencia_permitida, true)}
                    </div>
                    <div className={[swalstyles.conteinerfuncionariotoeditdesc, swalstyles.conteinerfuncionariotoeditdescgrid].join(' ')}>
                        <div>{funcionarioToEdit.organograma.departamento.codigo}</div>
                        <div>{funcionarioToEdit.organograma.departamento.descricao}</div>
                    </div>
                    <div className={[swalstyles.conteinerfuncionariotoeditlabel, swalstyles.conteinerfuncionariotoeditlabelalert].join(' ')}>
                        FUNÇÃO
                        {renderAlertInconsistenciaFuncao((funcionarioToEdit.id || newFuncionarioToEdit.id), (funcionarioToEdit.ativo || newFuncionarioToEdit.ativo),
                            funcionarioToEdit.organograma.funcao.id, (funcionarioToEdit.funcao.id || (newFuncionarioToEdit.id ? newFuncionarioToEdit.funcao.id : null)),
                            funcionarioToEdit.inconsistencia.inconsistencia_permitida, true)}
                    </div>
                    <div className={[swalstyles.conteinerfuncionariotoeditdesc, swalstyles.conteinerfuncionariotoeditdescgrid].join(' ')}>
                        <div>{funcionarioToEdit.organograma.funcao.codigo}</div>
                        <div>{funcionarioToEdit.organograma.funcao.descricao}</div>
                    </div>
                    <div className={swalstyles.conteinerfuncionariotoeditturnoatvqtd}>
                        <div>
                            <div className={swalstyles.conteinerfuncionariotoeditlabel}>
                                TURNO
                            </div>
                            <div className={swalstyles.conteinerfuncionariotoeditdesc}>
                                {funcionarioToEdit.organograma_funcionario.turno}
                            </div>
                        </div>
                        <div>
                            {renderModalFuncionarioToEditAtividade()}
                        </div>
                        <div>
                            {renderModalFuncionarioToEditQuantidade()}
                        </div>
                    </div>
                    {renderModalFuncionarioToEditButtonHistorico()}
                </div>
            )
        } else {
            return (
                <div className={swalstyles.conteinerfuncionariotoeditconteinerhistorico}>
                    <div className={swalstyles.conteinerfuncionariotoeditconteinernothistorico}>
                        Nenhuma Previsão foi Cadastrada para esse Funcionário.
                    </div>
                    {renderModalFuncionarioToEditButtonHistorico()}
                </div>
            )
        }
    }

    function validainconsistenciaperiodohistorico(tipo, first_data_inicial, data, format) {
        if(!tipo && data && first_data_inicial && moment(first_data_inicial, 'YYYY MM DD').isBefore(moment(data, format || 'YYYY MM DD').startOf('month'))) {
            return true;
        } else if(tipo && data && first_data_inicial && moment(first_data_inicial, 'YYYY MM DD').isAfter(moment(data, format || 'YYYY MM DD').startOf('month'))) {
            return true;
        } else if(!tipo && data && first_data_inicial && moment(first_data_inicial, 'YYYY MM DD').isAfter(moment(data, format || 'YYYY MM DD').startOf('month')) && moment(first_data_inicial, 'YYYY MM DD').isAfter(moment(headerOrganograma.data_inicial, 'YYYY MM DD'))) {
            return true;
        } else {
            return false;
        }
    }

    function renderAlertAdmDemPrevista(data_prevista, tipo, first_data_inicial, data, format) {
        var inconsistenciaPeriodo = validainconsistenciaperiodohistorico(tipo, first_data_inicial, data, format);

        if(data_prevista || inconsistenciaPeriodo) {
            return (
                <div className={swalstyles.conteinerpopup} onClick={() => handleToastShowHtml(
                    <>
                        {data_prevista ? `${tipo ? 'DEMISSÃO' : 'ADMISSÃO'} PREVISTA: ${moment(data_prevista, 'YYYY MM DD').format('DD/MM/YYYY')}` : ''}
                        {data_prevista && inconsistenciaPeriodo ? <><br /><br /></> : <></>}
                        {inconsistenciaPeriodo ? 'INCONSISTÊNCIA DE PERÍODO NO HISTÓRICO' : ''}
                    </>
                )}>
                    <span className={swalstyles.popup}>
                        {data_prevista ? `${tipo ? 'DEMISSÃO' : 'ADMISSÃO'} PREVISTA: ${moment(data_prevista, 'YYYY MM DD').format('DD/MM/YYYY')}` : ''}
                        {data_prevista && inconsistenciaPeriodo ? <><br /><br /></> : <></>}
                        {inconsistenciaPeriodo ? 'INCONSISTÊNCIA DE PERÍODO NO HISTÓRICO' : ''}
                    </span>
                    <div className={[swalstyles.conteinericoninconsistenciadepartamentofuncaoalert, !inconsistenciaPeriodo ? swalstyles.iconinconsistenciadepartamentofuncaonotalert : ''].join(' ')} onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)} >
                        <IoAlert className={[swalstyles.iconinconsistenciadepartamentofuncao, inconsistenciaPeriodo ? swalstyles.iconinconsistenciadepartamentofuncaoalert : ''].join(' ')}
                        />
                    </div>
                </div>
            )
        }
    }

    function renderModalFuncionarioToEditInputDataAdm() {
        if(funcionarioToEdit.id || newFuncionarioToEdit.id) {
            return (
                <div>
                    <div className={[swalstyles.conteinerfuncionariotoeditlabel, swalstyles.conteinerfuncionariotoeditlabelalert].join(' ')}>
                        ADMISSÃO
                        {renderAlertAdmDemPrevista(funcionarioToEdit.organograma_funcionario.admissao_prevista, 0, funcionarioToEdit.organograma_funcionario.first_data_inicial, (newFuncionarioToEdit.data_admissao || funcionarioToEdit.data_admissao))}
                    </div>
                    <div className={swalstyles.conteinerfuncionariotoeditdesc}>
                        {moment(funcionarioToEdit.data_admissao || newFuncionarioToEdit.data_admissao, 'YYYY MM DD').format('DD/MM/YYYY')}
                    </div>
                </div>
            )
        } else {
            const isValid = dataAdmDemIsValid(dataAdmToEdit, true, headerOrganograma.data_final);
            const classes = [swalstyles.inputdata];
            if(!isValid.error) {
                classes.push(swalstyles.inputdatainvalid);

                if(isValid.type === 1) {
                    classes.push(swalstyles.inputdatainvalidnull);
                } else if(isValid.type === 2) {
                    classes.push(swalstyles.inputdatainvalidnot);
                } else if(isValid.type === 4) {
                    classes.push(swalstyles.inputdatainvalidmax);
                }
            }

            return (
                <div>
                    <div className={swalstyles.conteinerfuncionariotoeditlabelalert}>
                        <div className={swalstyles.conteinerlabelinputrequired}>
                            <div className={swalstyles.conteinerfuncionariotoeditlabel}>
                                ADMISSÃO PREVISTA
                            </div>
                            <div className={swalstyles.conteinerpopup}>
                                <span className={swalstyles.popup}>Obrigatório</span>
                                <div className={[swalstyles.labelinputrequired, swalstyles.conteinerfuncionariotoeditlabel].join(' ')}
                                    onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}
                                >
                                    *
                                </div>
                            </div>
                        </div>
                        {renderAlertAdmDemPrevista(null, 0, funcionarioToEdit.organograma_funcionario.first_data_inicial, dataAdmToEdit, 'DD MM YYYY')}
                    </div>
                    <div className={classes.join(' ')}>
                        <input type='text' placeholder='dd/mm/aaaa' required value={dataAdmToEdit} onBlur={() => completeDataAdm()} onChange={e => setDataAdmToEdit(regexMaskData(e))}/>
                        <span />
                    </div>
                </div>
            )
        }
    }

    function handleCheckRecisao() {
        if(calculaRecisao) {
            setCalculaRecisao(0);
        } else {
            setCalculaRecisao(1);
        }
    }

    function renderModalFuncionarioToEditCheckCalculaRecisao() {
        if(funcionarioToEdit.organograma.departamento.tipo >= 2) {
            return (
                <div className={[swalstyles.conteinercheckdissidio, swalstyles.conteinercheckcalcularecisao].join(' ')} onClick={() => handleCheckRecisao()}>
                    <div className={swalstyles.checkconteiner}>
                        <TiTick className={!calculaRecisao ? swalstyles.checkicon : [swalstyles.checkicon, swalstyles.checkiconnone].join(' ')}/>
                    </div>
                    <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                        Encerramento da Atividade?
                    </div>
                </div>
            )
        }
    }

    function renderModalFuncionarioToEditInputDataDem() {
        if(!funcionarioToEdit.ativo && funcionarioToEdit.id) {
            return (
                <div>
                    <div className={[swalstyles.conteinerfuncionariotoeditlabel, swalstyles.conteinerfuncionariotoeditlabelalert].join(' ')}>
                        DEMISSÃO
                        {renderAlertAdmDemPrevista(funcionarioToEdit.organograma_funcionario.demissao_prevista, 1, funcionarioToEdit.organograma_funcionario.first_data_inicial, (newFuncionarioToEdit.data_demissao || funcionarioToEdit.data_demissao))}
                    </div>
                    <div className={swalstyles.conteinerfuncionariotoeditdesc}>
                        {moment(funcionarioToEdit.data_demissao, 'YYYY MM DD').format('DD/MM/YYYY')}
                    </div>
                </div>
            )
        } else {
            const isValid = dataAdmDemIsValid(dataDemToEdit, false, funcionarioToEdit.data_admissao || newFuncionarioToEdit.data_admissao || dataAdmToEdit);
            const classes = [swalstyles.inputdata];
            if(!isValid.error) {
                classes.push(swalstyles.inputdatainvalid);

                if(isValid.type === 1) {
                    classes.push(swalstyles.inputdatainvalidnull);
                } else if(isValid.type === 2) {
                    classes.push(swalstyles.inputdatainvalidnot);
                } else if(isValid.type === 3) {
                    classes.push(swalstyles.inputdatainvalidmin);
                }
            }

            return (
                <div>
                    <div className={[swalstyles.conteinerfuncionariotoeditlabel, swalstyles.conteinerfuncionariotoeditlabelalert].join(' ')}>
                        {calculaRecisao ? 'DEMISSÃO PREVISTA' : 'DATA ENCERRAMENTO'}
                        {renderAlertAdmDemPrevista(null, 1, funcionarioToEdit.organograma_funcionario.first_data_inicial, dataDemToEdit, 'DD MM YYYY')}
                    </div>
                    <div className={classes.join(' ')}>
                        <input type='text' placeholder='dd/mm/aaaa' value={dataDemToEdit} onBlur={() => completeDataDem()} onChange={e => setDataDemToEdit(regexMaskData(e))}/>
                        <span />
                    </div>
                    {renderModalFuncionarioToEditCheckCalculaRecisao()}
                </div>
            )
        }
    }

    function renderActionsModalFuncionarioToEditConfirm() {
        if(!funcionarioToEdit.id || funcionarioToEdit.ativo || (!funcionarioToEdit.organograma_funcionario.id && !funcionarioToEdit.ativo)) {
            return (
                <input type='button' className={[swalstyles.buttons, swalstyles.confirmbutton].join(' ')}
                    value='CONFIRMAR'
                    disabled={!(funcionarioToEdit.data_admissao || newFuncionarioToEdit.data_admissao || dataAdmDemIsValid(dataAdmToEdit, true, headerOrganograma.data_final).error)
                            || !dataAdmDemIsValid(dataDemToEdit, false, funcionarioToEdit.data_admissao || newFuncionarioToEdit.data_admissao || dataAdmToEdit).error
                            || !funcionarioToEdit.organograma.id
                        }
                    onClick={() => newFuncionarioToEdit.id && funcionarioToEdit.organograma_funcionario.id && (
                        validainconsistenciaperiodohistorico(0, funcionarioToEdit.organograma_funcionario.first_data_inicial, newFuncionarioToEdit.data_admissao) ||
                        validaAlertInconsistenciaDepartamento(newFuncionarioToEdit.id, newFuncionarioToEdit.ativo, funcionarioToEdit.organograma.departamento.id,
                            newFuncionarioToEdit.id ? newFuncionarioToEdit.departamento.id : null, funcionarioToEdit.inconsistencia.inconsistencia_permitida, true) ||
                        validaAlertInconsistenciaFuncao(newFuncionarioToEdit.id, newFuncionarioToEdit.ativo, funcionarioToEdit.organograma.funcao.id,
                            newFuncionarioToEdit.id ? newFuncionarioToEdit.funcao.id : null, funcionarioToEdit.inconsistencia.inconsistencia_permitida, true)
                    ) ? handleChangeHistoricoFuncionarioOrganograma() : handleSalvarFuncionarioOrganograma()}
                />
            )
        }
    }

    function renderActionsModalFuncionarioToEditCancel() {
        return (
            <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                value='CANCELAR'
                onClick={() => {closeFuncionarioToEdit()}}
            />
        )
    }

    function renderActionsModalFuncionarioToEditExcluirPrevisao() {
        if(!funcionarioToEdit.id && funcionarioToEdit.organograma_funcionario.id && !newFuncionarioToEdit.id) {
            return (
                <input type='button' className={[swalstyles.buttons, swalstyles.denybutton].join(' ')}
                    value='EXCLUIR PREVISÃO'
                    onClick={() => handleDeleteFuncionarioOrganograma()}
                />
            )
        }
    }

    function renderActionsModalFuncionarioToEditManterVaga() {
        if(funcionarioToEdit.id && !funcionarioToEdit.ativo && funcionarioToEdit.organograma_funcionario.status === 1) {
            return (
                <input type='button' className={[swalstyles.buttons, swalstyles.confirmbutton].join(' ')}
                    value='MANTER VAGA'
                    onClick={() => handleManterVagaFuncionarioOrganograma(funcionarioToEdit)}
                />
            )
        }
    }

    function renderActionsModalFuncionarioToEditRemoverVaga() {
        if(funcionarioToEdit.id && !funcionarioToEdit.ativo && funcionarioToEdit.organograma_funcionario.status === 1) {
            return (
                <input type='button' className={[swalstyles.buttons, swalstyles.denybutton].join(' ')}
                    value='REMOVER VAGA'
                    onClick={() => handleDeleteFuncionarioOrganograma()}
                />
            )
        }
    }

    function renderActionsModalFuncionarioToEdit() {
        if(!saving) {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    {renderActionsModalFuncionarioToEditExcluirPrevisao()}
                    {renderActionsModalFuncionarioToEditRemoverVaga()}
                    {renderActionsModalFuncionarioToEditManterVaga()}
                    {renderActionsModalFuncionarioToEditConfirm()}
                    {renderActionsModalFuncionarioToEditCancel()}
                </div>
            )
        } else {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    function validaAlertInconsistenciaDepartamento(id_funcionario, ativo, id_departamento_organograma, id_departamento, inconsistencia_permitida, historico_atual) {
        if(historico_atual && !inconsistencia_permitida && (!id_funcionario || ativo) && (id_funcionario && id_departamento_organograma !== id_departamento)) {
            return true;
        } else {
            return false;
        }
    }

    function renderAlertInconsistenciaDepartamento(id_funcionario, ativo, id_departamento_organograma, id_departamento, inconsistencia_permitida, historico_atual) {
        if(validaAlertInconsistenciaDepartamento(id_funcionario, ativo, id_departamento_organograma, id_departamento, inconsistencia_permitida, historico_atual)) {
            return (
                <div className={swalstyles.conteinerpopup}>
                    <span className={[swalstyles.popup, swalstyles.popupright].join(' ')}>Departamento Atual e<br />Previsto são Diferentes</span>
                    <div className={swalstyles.conteinericoninconsistenciadepartamentofuncaoalert}
                        onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)} onClick={() => handleToastShow(`Departamento Atual e Previsto são Diferentes!`)}>
                        <IoAlert className={[swalstyles.iconinconsistenciadepartamentofuncao, swalstyles.iconinconsistenciadepartamentofuncaoalert].join(' ')} />
                    </div>
                </div>
            )
        }
    }

    function validaAlertInconsistenciaFuncao(id_funcionario, ativo, id_funcao_organograma, id_funcao, inconsistencia_permitida, historico_atual) {
        if(historico_atual && !inconsistencia_permitida && (!id_funcionario || ativo) && (id_funcionario && id_funcao_organograma !== id_funcao)) {
            return true;
        } else {
            return false;
        }
    }

    function renderAlertInconsistenciaFuncao(id_funcionario, ativo, id_funcao_organograma, id_funcao, inconsistencia_permitida, historico_atual) {
        if(validaAlertInconsistenciaFuncao(id_funcionario, ativo, id_funcao_organograma, id_funcao, inconsistencia_permitida, historico_atual)) {
            return (
                <div className={swalstyles.conteinerpopup}>
                    <span className={swalstyles.popup}>Função Atual e<br />Prevista são Diferentes</span>
                    <div className={[swalstyles.conteinericoninconsistenciadepartamentofuncao, swalstyles.conteinericoninconsistenciadepartamentofuncaoalert].join(' ')}
                        onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)} onClick={() => handleToastShow(`Função Atual e Prevista são Diferentes!`)}>
                        <IoAlert className={[swalstyles.iconinconsistenciadepartamentofuncao, swalstyles.iconinconsistenciadepartamentofuncaoalert].join(' ')} />
                    </div>
                </div>
            )
        }
    }

    function renderModalFuncionarioToEdit() {
        if(modalFuncionarioToEdit) {
            if(Object.keys(funcionarioToEdit).includes('id')) {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={swalstyles.modal}>
                                {renderModalFuncionarioToEditId()}
                            <div className={swalstyles.conteinerbody}>
                                {renderModalFuncionarioToEditFuncionario()}
                                {renderModalFuncionarioToEditConteinerHistorico()}
                                <div className={swalstyles.conteinerfuncionariotoeditinputsdata}>
                                    {renderModalFuncionarioToEditInputDataAdm()}
                                    {renderModalFuncionarioToEditInputDataDem()}
                                </div>
                                <div className={swalstyles.conteinerfuncionariotoeditlabel}>
                                    OBSERVAÇÃO
                                </div>
                                {renderModalFuncionarioToEditInputObservacao()}
                            </div>
                                {renderActionsModalFuncionarioToEdit()}
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={swalstyles.modal}>
                            <div className={swalstyles.conteinerbuttons}>
                                <div className={loadingstyles.divloading}>
                                    <div className={loadingstyles.loading}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }

    function handleHistoricoFuncionario(funcionario, selectItemDepartamento, selectItemFuncao, selectItemTurno, selectItemPeriodo, inputAtividade, inputQuantidade) {
        setHistoricoFuncionario({
            funcionario: funcionario.historico ? funcionario.funcionario : funcionario,
        });

        setModalHistoricoFuncionario(true);

        api.get(`/previsao/getDepartamentoFuncaoHistorico?id_cenario_organograma=${headerOrganograma.id_cenario_organograma}&data_filtro=${selectPeriodo.selectItem}&id_organograma_funcionario=${funcionario.id_organograma_funcionario}`).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else {
                    if(selectItemDepartamento) {
                        setSelectDepartamentoHistorico({
                            items: response.data.itemsDepartamento,
                            selectItem: selectItemDepartamento.map(id => {return id != null ? response.data.itemsDepartamento.find(dpto => dpto.id === id).value : null}),
                        });
                    } else {
                        setSelectDepartamentoHistorico({
                            items: response.data.itemsDepartamento,
                            selectItem: response.data.selectItemDepartamento,
                        });
                    }
                    if(selectItemFuncao) {
                        setSelectFuncaoHistorico({
                            items: response.data.itemsFuncao,
                            selectItem: selectItemFuncao.map(id_organograma => {return id_organograma != null ? response.data.itemsFuncao.find(funcao => funcao.id_organograma === id_organograma).value : null}),
                        });
                    } else {
                        setSelectFuncaoHistorico({
                            items: response.data.itemsFuncao,
                            selectItem: response.data.selectItemFuncao,
                        });
                    }
                    setSelectTurnoHistorico({
                        items: [
                            { value: 0, label: "A" },
                            { value: 1, label: "B" },
                            { value: 2, label: "C" },
                        ],
                        selectItem: selectItemTurno || response.data.selectItemTurno,
                    });
                    if(selectItemPeriodo) {
                        setSelectPeriodoHistorico({
                            items: response.data.itemsPeriodo,
                            selectItem: selectItemPeriodo.map(data => {return response.data.itemsPeriodo.find(periodo => periodo.data === data).value}),
                        });
                    } else {
                        setSelectPeriodoHistorico({
                            items: response.data.itemsPeriodo,
                            selectItem: response.data.selectItemPeriodo,
                        });
                    }
                    setInputAtividadeHistorico(inputAtividade || response.data.inputIdAtividade.length ? response.data.inputIdAtividade : [null]);
                    setInputQuantidadeHistorico(inputQuantidade || response.data.inputQuantidade.length ? response.data.inputQuantidade : [1]);

                    if(funcionario.historico) {
                        setHistoricoFuncionario(funcionario);
                    } else {
                        setHistoricoFuncionario({
                            funcionario: funcionario,
                            historico: response.data.historico,
                            historicoDeleted: [],
                        });
                    }
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        });
    }

    function resetHistoricoFuncionario() {
        setModalHistoricoFuncionario(false);
        setHistoricoFuncionario({});
        setSelectDepartamentoHistorico({
            items: [],
            selectItem: [],
        });
        setSelectFuncaoHistorico({
            items: [],
            selectItem: [],
        });
        setSelectTurnoHistorico({
            items: [
                { value: 0, label: "A" },
                { value: 1, label: "B" },
                { value: 2, label: "C" },
            ],
            selectItem: [],
        });
        setSelectPeriodoHistorico({
            items: [],
            selectItem: [],
        });
        setInputAtividadeHistorico([]);
        setInputQuantidadeHistorico([]);
    }

    function closeHistoricoFuncionario(doublePop, funcionario, addDemitido) {
        resetHistoricoFuncionario();
        
        if(addDemitido) {
            handlePesquisarFuncionarios(previousModal[previousModal.length - 2].selectModalFuncionarioTip, previousModal[previousModal.length - 2].enableChange, previousModal[previousModal.length - 2].inputModalFuncionarioFunc, previousModal[previousModal.length - 2].inputModalFuncionarioDpto, previousModal[previousModal.length - 2].inputModalFuncionarioFun);
        } else if(funcionario) {
            handleExibirFuncionarioToEdit(funcionario);
        } else if(previousModal[previousModal.length - 1].modalName === 'funcionariosFuncao') {
            handleExibirFuncionariosFuncao(previousModal[previousModal.length - 1].departamento, previousModal[previousModal.length - 1].funcao);
        } else if(previousModal[previousModal.length - 1].modalName === 'inconsistenciasDepartamentoFuncao') {
            handleInconsistenciasDepartamentoFuncao(previousModal[previousModal.length - 1].selectModalInconsistenciaTip, previousModal[previousModal.length - 1].inputModalFuncionarioDpto, previousModal[previousModal.length - 1].inputModalFuncionarioFun);
        } else if(previousModal[previousModal.length - 1].modalName === 'pesquisarFuncionarios') {
            handlePesquisarFuncionarios(previousModal[previousModal.length - 1].selectModalFuncionarioTip, previousModal[previousModal.length - 1].enableChange, previousModal[previousModal.length - 1].inputModalFuncionarioFunc, previousModal[previousModal.length - 1].inputModalFuncionarioDpto, previousModal[previousModal.length - 1].inputModalFuncionarioFun);
        } else if(previousModal[previousModal.length - 1].modalName === 'funcionarioToEdit') {
            handleExibirFuncionarioToEdit(previousModal[previousModal.length - 1].funcionarioToEdit, previousModal[previousModal.length - 1].observacaoToEdit, previousModal[previousModal.length - 1].dataAdmToEdit, previousModal[previousModal.length - 1].dataDemToEdit, previousModal[previousModal.length - 1].calculaRecisaoToEdit, previousModal[previousModal.length - 1].newFuncionarioToEdit);
        }

        popPreviousModal(doublePop)
    }

    function nextHistoricoFuncionario(data) {
        pushPreviousModal({
            modalName: 'historicoFuncionario',
            funcionario: historicoFuncionario,
            selectItemDepartamento: selectDepartamentoHistorico.selectItem.map(selectedValue => {return selectedValue != null ? selectDepartamentoHistorico.items.find(dpto => dpto.value === selectedValue).id : null}),
            selectItemFuncao: selectFuncaoHistorico.selectItem.map(selectedFuncao => {return selectedFuncao != null ? selectFuncaoHistorico.items.find(funcao => funcao.value === selectedFuncao).id_organograma : null}),
            selectItemTurno: selectTurnoHistorico.selectItem,
            selectItemPeriodo: selectPeriodoHistorico.selectItem.map(selectedPeriodo => {return selectPeriodoHistorico.items.find(periodo => periodo.value === selectedPeriodo).data}),
            inputAtividade: inputAtividadeHistorico,
            inputQuantidade: inputQuantidadeHistorico,
        });

        resetHistoricoFuncionario();

        handleNovoDepartamentoFuncao({departamento: data});
    }

    function handleSalvarHistoricoFuncionario() {
        if(selectFuncaoHistorico.selectItem.includes(null)) {
            handleToastShow('Existe um ou mais Históricos sem Função Selecionada!');
        } else if(inputQuantidadeHistorico.includes(null)) {
            handleToastShow('Existe um ou mais Históricos com Quantidade Inválida!');
        } else if(!historicoFuncionario.historico.length) {
            handleToastShow('Não é Possível Salvar sem Cadastrar ao menos um Histórico!');
        } else if(
            selectPeriodoHistorico.selectItem.find(periodo =>
                (
                    historicoFuncionario.funcionario.data_demissao !== null &&
                    moment(selectPeriodoHistorico.items.find(({ value }) => value === periodo).data, 'YYYY MM DD').isAfter(moment(historicoFuncionario.funcionario.data_demissao, 'YYYY MM'))
                ) || (
                    historicoFuncionario.funcionario.data_admissao !== null &&
                    moment(selectPeriodoHistorico.items.find(({ value }) => value === periodo).data, 'YYYY MM DD').isBefore(moment(historicoFuncionario.funcionario.data_admissao, 'YYYY MM'))
                )
            ) != null
        ) {
            handleToastShow('Existe uma ou mais Inconsistência de Período!');
        } else {
            const edit = { historicoDelete: [], historicoNew: [], historicoEdit: [] };
            setSaving(true);

            historicoFuncionario.historicoDeleted.forEach(id_historico => {
                edit.historicoDelete.push(id_historico);
            });

            historicoFuncionario.historico.forEach((historico, index) => {
                if(!historico.id) {
                    edit.historicoNew.push({
                        id_organograma_funcionario: historicoFuncionario.funcionario.id_organograma_funcionario,
                        id_organograma: selectFuncaoHistorico.items.find(({ value }) => value === selectFuncaoHistorico.selectItem[index]).id_organograma,
                        id_atividade: inputAtividadeHistorico[index],
                        turno: selectTurnoHistorico.items.find(({ value }) => value === selectTurnoHistorico.selectItem[index]).label,
                        quantidade: inputQuantidadeHistorico[index],
                        data_inicial: selectPeriodoHistorico.items.find(({ value }) => value === selectPeriodoHistorico.selectItem[index]).data,
                    });
                } else if(
                    ((historico.data_inicial !== selectPeriodoHistorico.items.find(({ value }) => value === selectPeriodoHistorico.selectItem[index]).data) ||
                    (historico.id_atividade !== inputAtividadeHistorico[index]) ||
                    (historico.quantidade !== inputQuantidadeHistorico[index]) ||
                    (historico.turno !== selectTurnoHistorico.items.find(({ value }) => value === selectTurnoHistorico.selectItem[index]).label) ||
                    (historico.organograma.id !== selectFuncaoHistorico.items.find(({ value }) => value === selectFuncaoHistorico.selectItem[index]).id_organograma))
                    && (!historico.deleteBlocked || historicoFuncionario.funcionario.status === 1)
                ) {
                    edit.historicoEdit.push({
                        id: historico.id,
                        id_organograma_funcionario: historicoFuncionario.funcionario.id_organograma_funcionario,
                        id_organograma: selectFuncaoHistorico.items.find(({ value }) => value === selectFuncaoHistorico.selectItem[index]).id_organograma,
                        id_atividade: inputAtividadeHistorico[index],
                        turno: selectTurnoHistorico.items.find(({ value }) => value === selectTurnoHistorico.selectItem[index]).label,
                        quantidade: inputQuantidadeHistorico[index],
                        data_inicial: selectPeriodoHistorico.items.find(({ value }) => value === selectPeriodoHistorico.selectItem[index]).data,
                    });
                }
            });
            
            if(
                !previousModal[previousModal.length - 1].funcionarioToEdit.organograma_funcionario.id ||
                (previousModal[previousModal.length - 1].funcionarioToEdit.organograma_funcionario.observacao || '') !== previousModal[previousModal.length - 1].observacaoToEdit ||
                previousModal[previousModal.length - 1].newFuncionarioToEdit.id ||
                (previousModal[previousModal.length - 1].dataAdmToEdit === '' ? null : moment(previousModal[previousModal.length - 1].dataAdmToEdit, 'DD MM YYYY').format('YYYY-MM-DD')) !== previousModal[previousModal.length - 1].funcionarioToEdit.organograma_funcionario.admissao_prevista ||
                (previousModal[previousModal.length - 1].dataDemToEdit === '' ? null : moment(previousModal[previousModal.length - 1].dataDemToEdit, 'DD MM YYYY').format('YYYY-MM-DD')) !== previousModal[previousModal.length - 1].funcionarioToEdit.organograma_funcionario.demissao_prevista ||
                previousModal[previousModal.length - 1].funcionarioToEdit.organograma_funcionario.calcula_recisao !== previousModal[previousModal.length - 1].calculaRecisaoToEdit
            ) {

                edit.funcionarioOrganograma = {
                    id: previousModal[previousModal.length - 1].funcionarioToEdit.organograma_funcionario.id,
                    id_cenario_organograma: headerOrganograma.id_cenario_organograma,
                    id_funcionario_old: previousModal[previousModal.length - 1].funcionarioToEdit.id,
                    id_funcionario: previousModal[previousModal.length - 1].newFuncionarioToEdit.id || previousModal[previousModal.length - 1].funcionarioToEdit.id,
                    insercao_lote: previousModal[previousModal.length - 1].funcionarioToEdit.organograma_funcionario.insercao_lote || 0,
                    observacao: previousModal[previousModal.length - 1].observacaoToEdit,
                    admissao_prevista: previousModal[previousModal.length - 1].dataAdmToEdit && previousModal[previousModal.length - 1].dataAdmToEdit !== '' ? moment(previousModal[previousModal.length - 1].dataAdmToEdit, 'DD MM YYYY').format('YYYY-MM-DD') : previousModal[previousModal.length - 1].funcionarioToEdit.organograma_funcionario.admissao_prevista,
                    demissao_prevista: previousModal[previousModal.length - 1].dataDemToEdit && previousModal[previousModal.length - 1].dataDemToEdit !== '' ? moment(previousModal[previousModal.length - 1].dataDemToEdit, 'DD MM YYYY').format('YYYY-MM-DD') : null,
                    calcula_recisao: previousModal[previousModal.length - 1].calculaRecisaoToEdit,
                }

                if(previousModal[previousModal.length - 1].funcionarioToEdit.id && !previousModal[previousModal.length - 1].funcionarioToEdit.organograma_funcionario.id && !previousModal[previousModal.length - 1].funcionarioToEdit.ativo) {
                    edit.addDemitido = true;
                }
            }

            if(edit.funcionarioOrganograma || edit.removerVaga || edit.historicoDelete.length || edit.historicoEdit.length || edit.historicoNew.length) {
                edit.id_organograma_funcionario = previousModal[previousModal.length - 1].funcionarioToEdit.organograma_funcionario.id;
                edit.data_filtro = selectPeriodo.selectItem;
                salvarFuncionarioOrganograma(edit);
            } else {
                setSaving(false);
                closeHistoricoFuncionario();
            }

        }
    }

    function renderActionsModalHistoricoFuncionarioConfirm() {
        if(!historicoFuncionario.funcionario.id_organograma_funcionario || historicoFuncionario.funcionario.status === 1) {
            return (
                <input type='button' className={[swalstyles.buttons, swalstyles.confirmbutton].join(' ')}
                    value='CONFIRMAR'
                    disabled={selectFuncaoHistorico.selectItem.includes(null) || inputQuantidadeHistorico.includes(null) || !historicoFuncionario.historico.length ||
                        selectPeriodoHistorico.selectItem.find(periodo =>
                            (
                                historicoFuncionario.funcionario.data_demissao !== null &&
                                moment(selectPeriodoHistorico.items.find(({ value }) => value === periodo).data, 'YYYY MM DD').isAfter(moment(historicoFuncionario.funcionario.data_demissao, 'YYYY MM'))
                            ) || (
                                historicoFuncionario.funcionario.data_admissao !== null &&
                                moment(selectPeriodoHistorico.items.find(({ value }) => value === periodo).data, 'YYYY MM DD').isBefore(moment(historicoFuncionario.funcionario.data_admissao, 'YYYY MM'))
                            )
                        ) != null
                    }
                    onClick={() => handleSalvarHistoricoFuncionario()}
                />
            )
        }
    }

    function renderActionsModalHistoricoFuncionarioCancel() {
        return (
            <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                value='CANCELAR'
                onClick={() => {closeHistoricoFuncionario(false)}}
            />
        )
    }

    function renderActionsModalHistoricoFuncionario() {
        if(!saving) {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    {renderActionsModalHistoricoFuncionarioConfirm()}
                    {renderActionsModalHistoricoFuncionarioCancel()}
                </div>
            )
        } else {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    function renderModalHistoricoFuncionarioSelectDepartamento(index) {
        if(historicoFuncionario.funcionario.id) {
            return (
                <>
                    <div className={[swalstyles.conteinerhistoricofuncionariolabel, swalstyles.conteinerfuncionariotoeditlabelalert].join(' ')}>
                        DEPARTAMENTO
                        {renderAlertInconsistenciaDepartamento(historicoFuncionario.funcionario.id, historicoFuncionario.funcionario.ativo,
                        (selectDepartamentoHistorico.items.find(({ value }) => value === selectDepartamentoHistorico.selectItem[index]) || {id: null}).id,
                        (historicoFuncionario.funcionario.departamento || {id: null}).id, historicoFuncionario.historico[index].inconsistencia_permitida,
                        (!historicoFuncionario.funcionario.id_organograma_funcionario && !index ? true : historicoFuncionario.historico[index].atual))}
                    </div>
                    <div className={swalstyles.conteinerhistoricofuncionarioinputdptofuncao}>
                        <Select
                            inputId='select_historico_departamento'
                            value={selectDepartamentoHistorico.items.find(({ value }) => value === selectDepartamentoHistorico.selectItem[index])}
                            options={selectDepartamentoHistorico.items}
                            components={{ Option }}
                            onInputChange={handleInputMaskDepartamento}
                            filterOption={FilterOptions}
                            onChange={(e) => handleSelectDepartamento(e.value, index)}
                            theme={Theme}
                            className={previsaostyles.filterselecttoedit}
                            placeholder='Departamento não cadastrado no organograma'
                            noOptionsMessage={() => "Nenhuma Opção"}
                            isDisabled={historicoFuncionario.funcionario.status !== 1}
                        />
                    </div>
                </>
            )
        } else {
            return (
                <div className={swalstyles.conteinerhistoricofuncionariospacedepartamentofuncao}>
                    <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                        DEPARTAMENTO
                    </div>
                    <div className={[swalstyles.conteinerfuncionariotoeditdescgrid, swalstyles.conteinerfuncionariotoeditdesc].join(' ')}>
                        <div>
                            {selectDepartamentoHistorico.items.find(({ value }) => value === selectDepartamentoHistorico.selectItem[index]).codigo}
                        </div>
                        <div>
                            {selectDepartamentoHistorico.items.find(({ value }) => value === selectDepartamentoHistorico.selectItem[index]).descricao}
                        </div>
                    </div>
                </div>
            )
        }
    }

    function renderModalHistoricoFuncionarioSelectFuncao(index) {
        if(historicoFuncionario.funcionario.id) {
            return (
                <>
                    <div className={[swalstyles.conteinerhistoricofuncionariolabel, swalstyles.conteinerfuncionariotoeditlabelalert].join(' ')}>
                        FUNCAO
                        {renderAlertInconsistenciaFuncao(historicoFuncionario.funcionario.id, historicoFuncionario.funcionario.ativo,
                        (selectFuncaoHistorico.items.find(({ value }) => value === selectFuncaoHistorico.selectItem[index]) || {id: null}).id,
                        (historicoFuncionario.funcionario.funcao || {id: null}).id, historicoFuncionario.historico[index].inconsistencia_permitida,
                        (!historicoFuncionario.funcionario.id_organograma_funcionario && !index ? true : historicoFuncionario.historico[index].atual))}
                    </div>
                    <div className={swalstyles.conteinerhistoricofuncionarioinputdptofuncao}>
                        <Select
                            inputId={'select_historico_funcao'}
                            value={selectFuncaoHistorico.items.find(({ value }) => value === selectFuncaoHistorico.selectItem[index]) || null}
                            options={selectDepartamentoHistorico.selectItem[index] != null ?
                                selectFuncaoHistorico.items.filter(
                                    ({ id_departamento }) => id_departamento === selectDepartamentoHistorico.items.find(({ value }) => value === selectDepartamentoHistorico.selectItem[index]).id
                                ) : []
                            }
                            components={{ Option }}
                            filterOption={FilterOptions}
                            onChange={(e) => setSelectFuncaoHistorico(handleSelectMultipleValue(e.value, selectFuncaoHistorico, index))}
                            theme={Theme}
                            className={previsaostyles.filterselecttoedit}
                            placeholder='Nenhuma função compatível foi encontrada'
                            noOptionsMessage={() => "Nenhuma Opção"}
                            isDisabled={historicoFuncionario.funcionario.status !== 1}
                            index={index}
                        />
                        {renderCriarNovaFuncao(!(historicoFuncionario.funcionario.status !== 1), false, selectDepartamentoHistorico.items.find(({ value }) => value === selectDepartamentoHistorico.selectItem[index]))}
                    </div>
                </>
            )
        } else {
            return (
                <div className={swalstyles.conteinerhistoricofuncionariospacedepartamentofuncao}>
                    <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                        FUNCAO
                    </div>
                    <div className={[swalstyles.conteinerfuncionariotoeditdescgrid, swalstyles.conteinerfuncionariotoeditdesc].join(' ')}>
                        <div>
                            {selectFuncaoHistorico.items.find(({ value }) => value === selectFuncaoHistorico.selectItem[index]).codigo}
                        </div>
                        <div>
                            {selectFuncaoHistorico.items.find(({ value }) => value === selectFuncaoHistorico.selectItem[index]).descricao}
                        </div>
                    </div>
                </div>
            )
        }
    }

    function renderModalHistoricoFuncionarioSelectTurno(index) {
        return (
            <>
                <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                    TURNO
                </div>
                <Select
                    inputId='select_historico_turno'
                    value={selectTurnoHistorico.items.find(({ value }) => value === selectTurnoHistorico.selectItem[index])}
                    options={selectTurnoHistorico.items}
                    components={{ Option }}
                    filterOption={FilterOptions}
                    onChange={(e) => setSelectTurnoHistorico(handleSelectMultipleValue(e.value, selectTurnoHistorico, index))}
                    theme={Theme}
                    noOptionsMessage={() => "Nenhuma Opção"}
                    className={previsaostyles.filterselecttoedit}
                    isDisabled={historicoFuncionario.funcionario.status !== 1}
                />
            </>
        )
    }

    function renderModalHistoricoFuncionarioInputAtividade(index) {
        if(selectDepartamentoHistorico.items.find(({ value, tipo }) => value === selectDepartamentoHistorico.selectItem[index] && tipo >= 2)) {
            return (
                <>
                    <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                        ATIVIDADE
                    </div>
                    <input type='text' className={[swalstyles.funcionariotoeditinput, swalstyles.inputhistoricofuncionario].join(' ')}
                        value={inputAtividadeHistorico[index] != null ? inputAtividadeHistorico[index] : ''}
                        onChange={e => handleInputAtividade(e.target.value, index)}
                        disabled={historicoFuncionario.funcionario.status !== 1}
                    />
                </>
            )
        }
    }

    function renderAlertInconsistenciaPeriodo(periodo, data_demissao, data_admissao) {
        if(data_admissao !== null && moment(periodo.data, 'YYYY MM DD').isBefore(moment(data_admissao, 'YYYY MM'))) {
            return(
                <div className={swalstyles.conteinerpopup}>
                    <span className={[swalstyles.popup, swalstyles.popupleft].join(' ')}>Período Selecionado é<br />Anterior a Admissão</span>
                    <div className={[swalstyles.conteinericoninconsistenciadepartamentofuncao, swalstyles.conteinericoninconsistenciadepartamentofuncaoalert].join(' ')}
                        onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)} onClick={() => handleToastShow(`Período Selecionado é Anterior a Admissão!`)}>
                        <IoAlert className={[swalstyles.iconinconsistenciadepartamentofuncao, swalstyles.iconinconsistenciadepartamentofuncaoalert].join(' ')} />
                    </div>
                </div>
            )
        } else if(data_demissao !== null && moment(periodo.data, 'YYYY MM DD').isAfter(moment(data_demissao, 'YYYY MM'))) {
            return(
                <div className={swalstyles.conteinerpopup}>
                    <span className={[swalstyles.popup, swalstyles.popupleft].join(' ')}>Período Selecionado é<br />Posterior a Demissão</span>
                    <div className={[swalstyles.conteinericoninconsistenciadepartamentofuncao, swalstyles.conteinericoninconsistenciadepartamentofuncaoalert].join(' ')}
                        onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)} onClick={() => handleToastShow(`Período Selecionado é Posterior a Demissão!`)}>
                        <IoAlert className={[swalstyles.iconinconsistenciadepartamentofuncao, swalstyles.iconinconsistenciadepartamentofuncaoalert].join(' ')} />
                    </div>
                </div>
            )
        }
    }

    function renderModalHistoricoFuncionarioSelectPeriodo(index) {
        return (
            <>
                <div className={[swalstyles.conteinerhistoricofuncionariolabel, swalstyles.conteinerfuncionariotoeditlabelalert].join(' ')}>
                    PERIODO
                    {renderAlertInconsistenciaPeriodo(selectPeriodoHistorico.items.find(({ value }) => value === selectPeriodoHistorico.selectItem[index]), historicoFuncionario.funcionario.data_demissao, historicoFuncionario.funcionario.data_admissao)}
                </div>
                <Select
                    inputId='select_historico_periodo'
                    value={selectPeriodoHistorico.items.find(({ value }) => value === selectPeriodoHistorico.selectItem[index])}
                    options={selectPeriodoHistorico.items}
                    isOptionDisabled={(option) =>
                        (selectPeriodoHistorico.selectItem.includes(option.value) ||
                        (historicoFuncionario.funcionario.data_demissao !== null && moment(option.data, 'YYYY MM DD').isAfter(moment(historicoFuncionario.funcionario.data_demissao, 'YYYY MM'))) ||
                        (historicoFuncionario.funcionario.data_admissao !== null && moment(option.data, 'YYYY MM DD').isBefore(moment(historicoFuncionario.funcionario.data_admissao, 'YYYY MM')))) &&
                        !(option.value === selectPeriodoHistorico.selectItem[index])
                    }
                    components={{ Option }}
                    filterOption={FilterOptions}
                    onChange={(e) => setSelectPeriodoHistorico(handleSelectMultipleValue(e.value, selectPeriodoHistorico, index))}
                    theme={Theme}
                    noOptionsMessage={() => "Nenhuma Opção"}
                    className={previsaostyles.filterselecttoedit}
                    isDisabled={historicoFuncionario.funcionario.status !== 1}
                />
            </>
        )
    }

    function renderModalHistoricoFuncionarioInputQuantidade(index) {
        if(historicoFuncionario.funcionario.insercao_lote) {
            return (
                <>
                    <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                        QUANTIDADE
                    </div>
                    <input type='text' className={[swalstyles.funcionariotoeditinput, swalstyles.inputhistoricofuncionario].join(' ')}
                        value={inputQuantidadeHistorico[index].toFixed(2)} onBlur={e => handleInputQuantidade(e.target.value, index, true)}
                        onChange={e => handleInputQuantidade(e.target.value, index, false)}
                        disabled={historicoFuncionario.funcionario.status !== 1}
                    />
                </>
            )
        }
    }

    function handleModalDeleteHistoricoFuncionario(index) {
        let objDepartamento = Object.assign([], selectDepartamentoHistorico);
        let objFuncao = Object.assign([], selectFuncaoHistorico);
        let objTurno = Object.assign([], selectTurnoHistorico);
        let objPeriodo = Object.assign([], selectPeriodoHistorico);
        let objAtividade = Object.assign([], inputAtividadeHistorico);
        let objQuantidade = Object.assign([], inputQuantidadeHistorico);
        let objHistorico = Object.assign([], historicoFuncionario);

        objDepartamento.selectItem.splice(index, 1);
        objFuncao.selectItem.splice(index, 1);
        objTurno.selectItem.splice(index, 1);
        objPeriodo.selectItem.splice(index, 1);
        objAtividade.splice(index, 1);
        objQuantidade.splice(index, 1);

        if(objHistorico.historico[index].id) {
            objHistorico.historicoDeleted.push(objHistorico.historico[index].id);
        }

        objHistorico.historico.splice(index, 1);

        setSelectDepartamentoHistorico(objDepartamento);
        setSelectFuncaoHistorico(objFuncao);
        setSelectTurnoHistorico(objTurno);
        setSelectPeriodoHistorico(objPeriodo);
        setInputAtividadeHistorico(objAtividade);
        setInputQuantidadeHistorico(objQuantidade);
        setHistoricoFuncionario(objHistorico);
    }

    function renderModalDeleteHistoricoFuncionario(index) {
        if(!historicoFuncionario.historico[index].deleteBlocked && historicoFuncionario.funcionario.status === 1) {
            return (
                <div className={swalstyles.conteinerpopup}>
                    <span className={swalstyles.popup}>Remover</span>
                    <BsTrashFill className={[swalstyles.deletenovafuncao, swalstyles.redalert].join(' ')} onClick={() => handleModalDeleteHistoricoFuncionario(index)}
                    onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}/>
                </div>
            )
        }
    }

    function renderModalListHistoricoFuncionario() {
        return (
            historicoFuncionario.historico.map((historico, index) => {
                return(
                    <div className={historico.atual ? [swalstyles.listhistoricofuncionario, swalstyles.listhistoricofuncionarioatual].join(' ') : swalstyles.listhistoricofuncionario} key={index}>
                        <div className={swalstyles.listhistoricofuncionariodelete}>
                            {renderModalDeleteHistoricoFuncionario(index)}
                        </div>
                        <div>
                            {renderModalHistoricoFuncionarioSelectDepartamento(index)}
                            {renderModalHistoricoFuncionarioSelectFuncao(index)}
                        </div>
                        <div>
                            {renderModalHistoricoFuncionarioSelectTurno(index)}
                            {renderModalHistoricoFuncionarioInputAtividade(index)}
                        </div>
                        <div className={swalstyles.listhistoricofuncionarioatualspan}>
                            {renderModalHistoricoFuncionarioSelectPeriodo(index)}
                            {renderModalHistoricoFuncionarioInputQuantidade(index)}
                        </div>
                    </div>
                )
            })
        )
    }

    function renderModalHistoricoFuncionarioTitleFuncionario() {
        if(historicoFuncionario.funcionario.id) {
            return (
                <div className={swalstyles.titlemodalfuncionarios}>
                    {`${historicoFuncionario.funcionario.matricula} - ${historicoFuncionario.funcionario.nome}`}
                </div>
            )
        } else if(historicoFuncionario.funcionario.id_organograma_funcionario && historicoFuncionario.funcionario.insercao_lote) {
            return (
                <div className={swalstyles.titlemodalfuncionarios}>
                    LOTE DE ESCALA - Código: {historicoFuncionario.funcionario.id_organograma_funcionario}
                </div>
            )
        } else if(historicoFuncionario.funcionario.id_organograma_funcionario) {
            return (
                <div className={swalstyles.titlemodalfuncionarios}>
                    VAGA EM ABERTO - Código: {historicoFuncionario.funcionario.id_organograma_funcionario}
                </div>
            )
        } else if(historicoFuncionario.funcionario.insercao_lote) {
            return (
                <div className={swalstyles.titlemodalfuncionarios}>
                    LOTE DE ESCALA
                </div>
            )
        } else {
            return (
                <div className={swalstyles.titlemodalfuncionarios}>
                    VAGA EM ABERTO
                </div>
            )
        }
    }

    function renderModalHistoricoFuncionarioTitleDepartamentoFuncao() {
        if(historicoFuncionario.funcionario.id) {
            return (
                <>
                    <div>
                        {`${historicoFuncionario.funcionario.departamento.codigo} - ${historicoFuncionario.funcionario.departamento.descricao}`}
                    </div>
                    <div>
                        {`${historicoFuncionario.funcionario.funcao.codigo} - ${historicoFuncionario.funcionario.funcao.descricao}`}
                    </div>
                </>
            )
        }
    }

    function renderModalHistoricoFuncionarioTitleAdmDem() {
        return (
            <>
                <div>
                    Admissão: {`${historicoFuncionario.funcionario.data_admissao ? moment(historicoFuncionario.funcionario.data_admissao, 'YYYY MM DD').format('DD/MM/YYYY') : 'Não Informado'}`}
                </div>
                <div>
                    Demissão: {`${historicoFuncionario.funcionario.data_demissao ? moment(historicoFuncionario.funcionario.data_demissao, 'YYYY MM DD').format('DD/MM/YYYY') : 'Não Informado'}`}
                </div>
            </>
        )
    }

    function handleCriarNovoHistorico(periodo, deleteBlocked) {
        let objDepartamento = Object.assign([], selectDepartamentoHistorico);
        let objFuncao = Object.assign([], selectFuncaoHistorico);
        let objTurno = Object.assign([], selectTurnoHistorico);
        let objPeriodo = Object.assign([], selectPeriodoHistorico);
        let objAtividade = Object.assign([], inputAtividadeHistorico);
        let objQuantidade = Object.assign([], inputQuantidadeHistorico);
        let objHistorico = Object.assign([], historicoFuncionario);

        if(historicoFuncionario.historico.length) {
            objDepartamento.selectItem.push(selectDepartamentoHistorico.selectItem[selectDepartamentoHistorico.selectItem.length - 1]);
            objFuncao.selectItem.push(selectFuncaoHistorico.selectItem[selectFuncaoHistorico.selectItem.length - 1]);
        } else if(historicoFuncionario.funcionario.id_departamento_organograma && historicoFuncionario.funcionario.id_funcao_organograma) {
            let findedDepartamento = selectDepartamentoHistorico.items.find(({ id }) => id === historicoFuncionario.funcionario.id_departamento_organograma);
            let findedFuncao = selectFuncaoHistorico.items.find(({ id, id_departamento }) => id === historicoFuncionario.funcionario.id_funcao_organograma && id_departamento === historicoFuncionario.funcionario.id_departamento_organograma);

            objDepartamento.selectItem.push(findedDepartamento ? findedDepartamento.value : null);
            objFuncao.selectItem.push(findedFuncao ? findedFuncao.value : null);
        } else if(historicoFuncionario.funcionario.id) {
            let findedDepartamento = selectDepartamentoHistorico.items.find(({ id }) => id === historicoFuncionario.funcionario.departamento.id);
            let findedFuncao = selectFuncaoHistorico.items.find(({ id, id_departamento }) => id === historicoFuncionario.funcionario.funcao.id && id_departamento === historicoFuncionario.funcionario.departamento.id);

            objDepartamento.selectItem.push(findedDepartamento ? findedDepartamento.value : null);
            objFuncao.selectItem.push(findedFuncao ? findedFuncao.value : null);
        } else {
            objDepartamento.selectItem.push(null);
            objFuncao.selectItem.push(null);
        }

        objTurno.selectItem.push(historicoFuncionario.historico.length ? selectTurnoHistorico.selectItem[selectTurnoHistorico.selectItem.length - 1] : 0);
        objPeriodo.selectItem.push(periodo);
        objAtividade.push(inputAtividadeHistorico[inputAtividadeHistorico.length - 1]);
        objQuantidade.push(inputQuantidadeHistorico[inputQuantidadeHistorico.length - 1]);
        objHistorico.historico.push({
            id: null,
            atual: false,
            deleteBlocked: deleteBlocked,
        });

        setSelectDepartamentoHistorico(objDepartamento);
        setSelectFuncaoHistorico(objFuncao);
        setSelectTurnoHistorico(objTurno);
        setSelectPeriodoHistorico(objPeriodo);
        setInputAtividadeHistorico(objAtividade);
        setInputQuantidadeHistorico(objQuantidade);
        setHistoricoFuncionario(objHistorico);
    }

    function renderModalListHistoricoFuncionarioAdd() {
        if(historicoFuncionario.funcionario.status === 1 && (historicoFuncionario.funcionario.id || historicoFuncionario.funcionario.insercao_lote)) {
            let findedValue = selectPeriodoHistorico.items.find(({ value, data }) =>
                !selectPeriodoHistorico.selectItem.includes(value) &&
                !(historicoFuncionario.funcionario.data_demissao !== null && moment(data, 'YYYY MM DD').isAfter(moment(historicoFuncionario.funcionario.data_demissao, 'YYYY MM'))) &&
                !(historicoFuncionario.funcionario.data_admissao !== null && moment(data, 'YYYY MM DD').isBefore(moment(historicoFuncionario.funcionario.data_admissao, 'YYYY MM')))
            );

            if(findedValue) {
                return (
                    <div className={swalstyles.listaddhistoricofuncionario} onClick={() => {handleCriarNovoHistorico(findedValue.value, false)}}>
                        <IoMdAdd className={swalstyles.listaddhistoricofuncionarioicon}/>
                    </div>
                )
            }
        }
    }

    function renderModalListHistoricoFuncionarioValidaPeriodo() {
        if(selectPeriodoHistorico.selectItem.length) {
            var first_data_inicial = selectPeriodoHistorico.items.find(({ value }) => value === selectPeriodoHistorico.selectItem[0]).data;
            
            selectPeriodoHistorico.selectItem.forEach((selected) => {
                if(moment(selectPeriodoHistorico.items.find(({ value }) => value === selected).data, 'YYYY MM DD').isBefore(moment(first_data_inicial, 'YYYY MM DD'))) {
                    first_data_inicial = selectPeriodoHistorico.items.find(({ value }) => value === selected).data;
                }
            });

            if(moment(first_data_inicial, 'YYYY MM DD').isAfter(moment(historicoFuncionario.funcionario.data_admissao, 'YYYY MM DD').startOf('month')) && moment(first_data_inicial, 'YYYY MM DD').isAfter(moment(headerOrganograma.data_inicial, 'YYYY MM DD'))) {
                return (
                    <div className={[swalstyles.boldalert, swalstyles.redalert, swalstyles.smallersizetextalert].join(' ')}>
                        Existe uma lacuna de período não preenchido por um histórico!
                    </div>
                )
            }
        }

        return (
            <div className={[swalstyles.boldalert, swalstyles.redalert, swalstyles.smallersizetextalert, swalstyles.alertnewfuncaosemsalario].join(' ')}>
                Existe uma lacuna de período não preenchido por um histórico!
            </div>
        )
    }

    function renderModalHistoricoFuncionario() {
        if(modalHistoricoFuncionario) {
            if(historicoFuncionario.historico && !historicoFuncionario.historico.length) {
                let findedValue = selectPeriodoHistorico.items.find(({ value, data }) =>
                    !selectPeriodoHistorico.selectItem.includes(value) &&
                    !(historicoFuncionario.funcionario.data_demissao !== null && moment(data, 'YYYY MM DD').isAfter(moment(historicoFuncionario.funcionario.data_demissao, 'YYYY MM'))) &&
                    !(historicoFuncionario.funcionario.data_admissao !== null && moment(data, 'YYYY MM DD').isBefore(moment(historicoFuncionario.funcionario.data_admissao, 'YYYY MM')))
                );

                if(findedValue) {
                    handleCriarNovoHistorico(findedValue.value, true);
                }
            } else if(historicoFuncionario.historico) {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modallargerwidth, swalstyles.modalmaxheight3rows].join(' ')}>
                            <div>
                                {renderModalHistoricoFuncionarioTitleFuncionario()}
                                <div className={swalstyles.conteinertitlehistoricofuncionario}>
                                    <div className={swalstyles.conteinertitlehistoricofuncionarioL}>
                                        {renderModalHistoricoFuncionarioTitleDepartamentoFuncao()}
                                    </div>
                                    <div className={swalstyles.conteinertitlehistoricofuncionarioR}>
                                        {renderModalHistoricoFuncionarioTitleAdmDem()}
                                    </div>
                                </div>
                            </div>
                            <div className={[swalstyles.conteinerbody, swalstyles.conteinerbodymaxheight, swalstyles.conteinerbodyenableoverflowx].join(' ')}>
                                {renderModalListHistoricoFuncionarioValidaPeriodo()}
                                {renderModalListHistoricoFuncionario()}
                                {renderModalListHistoricoFuncionarioAdd()}
                            </div>
                            {renderActionsModalHistoricoFuncionario()}
                        </div>
                    </div>
                )
            }
            else {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modallargerwidth, swalstyles.modalmaxheight3rows].join(' ')}>
                            <div>
                                {renderModalHistoricoFuncionarioTitleFuncionario()}
                                <div className={swalstyles.conteinertitlehistoricofuncionario}>
                                    <div className={swalstyles.conteinertitlehistoricofuncionarioL}>
                                        {renderModalHistoricoFuncionarioTitleDepartamentoFuncao()}
                                    </div>
                                    <div className={swalstyles.conteinertitlehistoricofuncionarioR}>
                                        {renderModalHistoricoFuncionarioTitleAdmDem()}
                                    </div>
                                </div>
                            </div>
                            <div className={swalstyles.conteinerbuttons}>
                                <div className={loadingstyles.divloading}>
                                    <div className={loadingstyles.loading}></div>
                                </div>
                            </div>
                            <div></div>
                        </div>
                    </div>
                )
            }
        }
    }

    function handleCriarNovaFuncao(departamento) {
        if(previousModal.length) {
            nextHistoricoFuncionario(departamento)
        } else {
            handleNovoDepartamentoFuncao({departamento: departamento});
        }
    }

    function renderCriarNovaFuncao(show, hasMarginTop, departamento) {
        if(show && departamento != null) {
            const divClass = hasMarginTop ? [previsaostyles.conteinercriar, swalstyles.conteinerpopup] : [swalstyles.conteinerpopup];

            return (
                <div className={divClass.join(' ')}>
                    <span className={swalstyles.popup}>Adicionar Função</span>
                    <div className={previsaostyles.buttoncriar} onClick={() => handleCriarNovaFuncao({id: departamento.id, codigo: departamento.codigo, descricao: departamento.descricao})}
                        onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}
                    >
                        <IoMdAdd className={previsaostyles.iconcriar}/>
                    </div>
                </div>
            )
        }
    }

    function handleReiniciarFuncionariosVaga(organogramas, id_organograma_funcionario) {
        if(organogramas) {
            setOrganogramaReiniciarFuncionarioVaga({
                departamento: {
                    codigo: organogramas.codigo,
                    descricao: organogramas.descricao,
                },
                funcoes: organogramas.funcao.map(funcao => {
                    return {
                        codigo: funcao.codigo,
                        descricao: funcao.descricao,
                        id_organograma: funcao.id_organograma,
                        reiniciar: true,
                    }
                }),
            });
        }
        if(id_organograma_funcionario) {
            setIdOrganogramaFuncionarioReiniciarFuncionarioVaga(id_organograma_funcionario);
        }
        setModalReiniciarFuncionarioVaga(true);
    }

    function resetReiniciarFuncionarioVaga() {
        setModalReiniciarFuncionarioVaga(false);
        setOrganogramaReiniciarFuncionarioVaga({});
        setIdOrganogramaFuncionarioReiniciarFuncionarioVaga(null);
        setExcluirFuncionarioVagaCheckVagas(false);
    }

    function handleReiniciarFuncionarioVaga() {
        setSavingPopup(true);

        api.post('/previsao/reiniciaescala', {
            id_organograma_funcionario: idOrganogramaFuncionarioReiniciarFuncionarioVaga,
            ids_organograma: organogramaReiniciarFuncionarioVaga.funcoes ? organogramaReiniciarFuncionarioVaga.funcoes.filter(funcao => funcao.reiniciar).map(funcao => funcao.id_organograma) : [],
            excluir_vagas: excluirFuncionarioVagaCheckVagas,
        }).then(response => {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);

                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'UM ERRO INESPERADO ACONTECEU!',
                        text: 'POR FAVOR CONTATE UM ADMINISTRADOR DO SISTEMA',
                        icon: 'error',
                    });
                }
            }
        }).catch(error => {
            console.log(error);

            Swal.fire({
                customClass: {
                    container: swalstyles.swalcontainer,
                    popup: swalstyles.swalbackground
                },
                title: 'UM ERRO INESPERADO ACONTECEU!',
                text: 'POR FAVOR CONTATE UM ADMINISTRADOR DO SISTEMA',
                icon: 'error',
            });
        }).finally(() => {
            setSavingPopup(false);
            resetReiniciarFuncionarioVaga();

            if(idOrganogramaFuncionarioReiniciarFuncionarioVaga) {
                closeFuncionarioToEdit();
            } else {
                setLoading(true);
            }
        });
    }

    function renderModalReiniciarFuncionarioVagaTitulo() {
        if(idOrganogramaFuncionarioReiniciarFuncionarioVaga) {
            return (
                <div className={swalstyles.titlemodalfuncionarios}>
                    DESEJA REALMENTE REMOVER ESSE FUNCIONÁRIO DA ESCALA?
                </div>
            )
        } else {
            return (
                <div className={swalstyles.titlemodalfuncionarios}>
                    <div>
                        {organogramaReiniciarFuncionarioVaga.departamento.codigo} - {organogramaReiniciarFuncionarioVaga.departamento.descricao}
                    </div>
                    <div>
                        DESEJA REALMENTE REINICIAR A ESCALA DO DEPARTAMENTO?
                    </div>
                </div>
            )
        }
    }

    function handleModalReiniciarFuncionarioVagaSelectFuncoes(index) {
        const newObj = Object.assign({}, organogramaReiniciarFuncionarioVaga);
        newObj.funcoes[index].reiniciar = !newObj.funcoes[index].reiniciar;

        setOrganogramaReiniciarFuncionarioVaga(newObj);
    }

    function renderModalReiniciarFuncionarioVagaSelectFuncoes() {
        if(organogramaReiniciarFuncionarioVaga.departamento) {
            var maxColumnItems = Math.ceil(organogramaReiniciarFuncionarioVaga.funcoes.length / 2);

            return (
                <div className={swalstyles.conteinercheckdoublecoluns}>
                    <div className={swalstyles.conteinercheckdoublecolunstitle}>Funções que serão Reiniciadas:</div>
                    <div></div>
                    <div>
                        {organogramaReiniciarFuncionarioVaga.funcoes.filter((funcao, index) => index < maxColumnItems).map((funcao, index) => {
                            return (
                                <div className={swalstyles.conteinercheckdissidio} onClick={() => handleModalReiniciarFuncionarioVagaSelectFuncoes(index)} key={index}>
                                    <div className={swalstyles.checkconteiner}>
                                        <TiTick className={funcao.reiniciar ? swalstyles.checkicon : [swalstyles.checkicon, swalstyles.checkiconnone].join(' ')}/>
                                    </div>
                                    <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                                        {funcao.codigo} - {funcao.descricao}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div>
                        {organogramaReiniciarFuncionarioVaga.funcoes.filter((funcao, index) => index >= maxColumnItems).map((funcao, index) => {
                            return (
                                <div className={swalstyles.conteinercheckdissidio} onClick={() => handleModalReiniciarFuncionarioVagaSelectFuncoes(index+maxColumnItems)} key={index}>
                                    <div className={swalstyles.checkconteiner}>
                                        <TiTick className={funcao.reiniciar ? swalstyles.checkicon : [swalstyles.checkicon, swalstyles.checkiconnone].join(' ')}/>
                                    </div>
                                    <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                                        {funcao.codigo} - {funcao.descricao}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )
        }
    }

    function renderModalReiniciarFuncionarioVagaCheckVagas() {
        return (
            <div className={[swalstyles.conteinercheckdissidio, swalstyles.conteinercheckexcluirvagas].join(' ')} onClick={() => setExcluirFuncionarioVagaCheckVagas(!excluirFuncionarioVagaCheckVagas)}>
                <div className={swalstyles.checkconteiner}>
                    <TiTick className={excluirFuncionarioVagaCheckVagas ? swalstyles.checkicon : [swalstyles.checkicon, swalstyles.checkiconnone].join(' ')}/>
                </div>
                <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                    {organogramaReiniciarFuncionarioVaga.departamento ? 'Excluir todas as Vagas Remanescentes' : 'Excluir Vaga deixada pelo Funcionário'}
                </div>
            </div>
        )
    }

    function renderActionsModalReiniciarFuncionarioVaga() {
        if(!savingPopup) {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    <input type='button' className={[swalstyles.buttons, swalstyles.confirmbutton].join(' ')}
                        value='CONFIRMAR' onClick={() => handleReiniciarFuncionarioVaga()} disabled={!idOrganogramaFuncionarioReiniciarFuncionarioVaga && !organogramaReiniciarFuncionarioVaga.funcoes.find(funcao => funcao.reiniciar)}
                    />
                    <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                        value='CANCELAR' onClick={() => resetReiniciarFuncionarioVaga()}
                    />
                </div>
            )
        } else {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    function renderModalReiniciarFuncionarioVaga() {
        if(modalReiniciarFuncionarioVaga) {
            return (
                <div className={swalstyles.conteiner}>
                    <div className={swalstyles.modal}>
                        <div className={swalstyles.conteinerbody}>
                            {renderModalReiniciarFuncionarioVagaTitulo()}
                            {renderModalReiniciarFuncionarioVagaSelectFuncoes()}
                            {renderModalReiniciarFuncionarioVagaCheckVagas()}
                        </div>
                        {renderActionsModalReiniciarFuncionarioVaga()}
                    </div>
                </div>
            )
        }
    }

    function renderReiniciarFuncionariosVaga(show, organogramas, id_organograma_funcionario) {
        if(show) {
            return (
                <div className={[previsaostyles.conteinercriar, swalstyles.conteinerpopup].join(' ')}>
                    <span className={swalstyles.popup}>Reiniciar Escala</span>
                    <div className={previsaostyles.buttonreiniciar} onClick={() => handleReiniciarFuncionariosVaga(organogramas, id_organograma_funcionario)}
                        onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}
                    >
                        <TiArrowBack className={previsaostyles.iconreiniciar}/>
                    </div>
                </div>
            )
        }
    }

    function resetNovoDepartamentoFuncao() {
        setModalNovoDepartamentoFuncao(false);
        setSelectNovoDepartamento({
            items: [],
            selectItem: null,
        });
        setSelectedDepartamento({});
        setListNovaFuncao({
            items: [],
            selectItem: null,
        });
        setListedFuncao([]);
    }

    function closeNovoDepartamentoFuncao() {
        resetNovoDepartamentoFuncao();

        if(previousModal.length) {
            if(previousModal[previousModal.length - 1].modalName === 'historicoFuncionario') {
                handleHistoricoFuncionario(
                    previousModal[previousModal.length - 1].funcionario,
                    previousModal[previousModal.length - 1].selectItemDepartamento,
                    previousModal[previousModal.length - 1].selectItemFuncao,
                    previousModal[previousModal.length - 1].selectItemTurno,
                    previousModal[previousModal.length - 1].selectItemPeriodo,
                    previousModal[previousModal.length - 1].inputAtividade,
                    previousModal[previousModal.length - 1].inputQuantidade
                );
            }

            popPreviousModal();
        }
    }

    function nextNovoDepartamentoFuncao(data) {
        pushPreviousModal({
            modalName: 'novoDepartamentoFuncao',
            selectNovoDpto: selectNovoDepartamento,
            selectedDpto: selectedDepartamento,
            listNovaFunc: listNovaFuncao,
            listedFunc: listedFuncao,
        });

        resetNovoDepartamentoFuncao();

        handleExibirEditSalarioFuncao(data);
    }

    function handleNovoDepartamentoFuncao(data, funcao) {
        setModalNovoDepartamentoFuncao(true);

        if(data.departamento) {
            if(!data.departamento.id) {
                api.get(`/previsao/getUnusedDepartamentos?id_cenario_organograma=${headerOrganograma.id_cenario_organograma}&id_empresa=${headerOrganograma.id_empresa}`).then(function (response) {
                    if (response.data) {
                        if(response.data.error) {
                            console.log(`ERROR: ${response.data.error}`);
                        } else if(response.data.calc) {
                            setPrevisaoCalc(true);
                        } else {
                            if(response.data.departamentos) {
                                setSelectNovoDepartamento({
                                    items: response.data.departamentos,
                                    selectItem: null,
                                });
                            }
                        }
                    }
                }).catch(function (error) {
                    // handle error
                    alert(error);
                    console.log(error);
                });

                handleNovoDepartamentoFuncaoSearchFuncoes('');
            } else {
                setSelectedDepartamento(data.departamento);
                handleNovoDepartamentoFuncaoSearchFuncoes(data.departamento.id);
            }
            
        } else {
            if(funcao.id) {
                data.listNovaFunc.items.forEach((func, index) => {
                    if(func.funcao.id === funcao.id) {
                        data.listNovaFunc.items[index].salario = funcao.salario_base;
                    }
                });

                data.listedFunc.forEach((func, index) => {
                    if(func.id === funcao.id) {
                        data.listedFunc[index].salario = funcao.salario_base;
                    }
                });
            }

            setSelectNovoDepartamento(data.selectNovoDpto);
            setSelectedDepartamento(data.selectedDpto);
            setListNovaFuncao(data.listNovaFunc);
            setListedFuncao(data.listedFunc);
        }
    }

    function handleNovoDepartamentoFuncaoSearchFuncoes(id_departamento) {
        api.get(`/previsao/getFuncoesByDepartamento?id_cenario_organograma=${headerOrganograma.id_cenario_organograma}&id_empresa=${headerOrganograma.id_empresa}&data_filtro=${selectPeriodo.selectItem}&id_departamento=${id_departamento}`).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else {
                    if(response.data.funcoes && response.data.departamento_funcoes) {
                        setListNovaFuncao({
                            items: response.data.departamento_funcoes,
                            selectItem: null,
                        });

                        setListedFuncao(response.data.funcoes);
                    }
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        });
    }

    function handleNovoDepartamentoFuncaoChangeDepartamento(valueSelected) {
        const newListNovaFuncao = Object.assign([], listNovaFuncao);
        
        listedFuncao.filter(({ list_nova_funcao_value }) => list_nova_funcao_value != null).forEach(({ list_nova_funcao_value }) => {
            newListNovaFuncao.items.find(({ value }) => value === list_nova_funcao_value).show = true;
        });

        setListNovaFuncao(newListNovaFuncao);
        setListedFuncao([]);

        setSelectNovoDepartamento(handleSelectValue(valueSelected, selectNovoDepartamento));
    }

    function renderModalNovoDepartamentoFuncaoDepartamento() {
        if(selectedDepartamento.id) {
            return (
                <div>{selectedDepartamento.codigo} - {selectedDepartamento.descricao}</div>
            )
        } else {
            return (
                <Select
                    inputId='select_novo_departamento'
                    value={selectNovoDepartamento.items.find(({ value }) => value === selectNovoDepartamento.selectItem)}
                    options={selectNovoDepartamento.items}
                    components={{ Option }}
                    onInputChange={handleInputMaskDepartamento}
                    filterOption={FilterOptions}
                    onChange={(e) => handleNovoDepartamentoFuncaoChangeDepartamento(e.value)}
                    theme={Theme}
                    className={previsaostyles.filterselecttoedit}
                    placeholder='Selecione um Departamento'
                    noOptionsMessage={() => "Nenhuma Opção"}
                    isDisabled={selectNovoDepartamento.selectItem && !(listedFuncao.length || listNovaFuncao.items.length)}
                />
            )
        }
    }

    function renderAlertFuncaoSemSalario(salario) {
        if(!salario) {
            return (
                <div className={[swalstyles.conteinerpopup, swalstyles.conteinerpopupheight100percent].join(' ')}>
                    <span className={swalstyles.popup}>Função sem salário</span>
                    <RiAlertFill className={swalstyles.alertfuncaosemsalario}
                    onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}/>
                </div>
            )
        } else {
            return (
                <div></div>
            )
        }
    }

    function renderModalNovoDepartamentoFuncaoListFuncoes() {
        return (
            listedFuncao.map((funcao, index) => {
                if(funcao.id_organograma) {
                    return (
                        <div className={swalstyles.listfuncoesdepartamento} key={index}>
                            <div className={swalstyles.listfuncoesdepartamentodescfuncao}>
                                <div>{funcao.codigo}</div>
                                <div>-</div>
                                <div>{funcao.descricao}</div>
                            </div>
                            <div className={swalstyles.listfuncoesdepartamentosalariofuncao}>
                                {renderAlertFuncaoSemSalario(funcao.salario)}
                                <div>&#9474;</div>
                                {renderInfoSalario('novoDepartamentoFuncao', {funcao: funcao})}
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div className={[swalstyles.listfuncoesdepartamento, swalstyles.listfuncoesdepartamentonovafuncao, swalstyles.redalert].join(' ')} key={index}>
                            <div className={swalstyles.conteinerdeletenovafuncao}>
                                <div>&#9656;</div>
                                {renderDeleteNovaFuncao(index)}
                            </div>
                            <div className={swalstyles.listfuncoesdepartamentodescfuncao}>
                                <div>{funcao.codigo}</div>
                                <div>-</div>
                                <div>{funcao.descricao}</div>
                            </div>
                            <div className={swalstyles.listfuncoesdepartamentosalariofuncao}>
                                {renderAlertFuncaoSemSalario(funcao.salario)}
                                <div>&#9474;</div>
                                {renderInfoSalario('novoDepartamentoFuncao', {funcao: funcao})}
                            </div>
                        </div>
                    )
                }
            })
        )
    }

    function renderModalNovoDepartamentoFuncaoInserirFuncao() {
        return (
            <div className={swalstyles.conteinerlistfuncoesdepartamentoinsert}>
                <div className={swalstyles.listfuncoesdepartamentoinsert}>
                    <Select
                        inputId='select_nova_funcao'
                        value={null}
                        options={listNovaFuncao.items.filter(({ show }) => show)}
                        components={{ Option }}
                        filterOption={FilterOptions}
                        onChange={(e) => handleNovoDepartamentoFuncaoChangeFuncao(e.value)}
                        theme={Theme}
                        className={previsaostyles.filterselecttoedit}
                        placeholder='Selecione uma Função'
                        noOptionsMessage={() => "Nenhuma Opção"}
                        menuPosition='fixed'
                    />
                </div>
            </div>
        )
    }

    function renderModalNovoDepartamentoFuncaoFuncoes() {
        if(selectNovoDepartamento.items.length && selectNovoDepartamento.selectItem === null) {
            return (
                <div className={swalstyles.departamentonotselected}>
                    Nenhum departamento selecionado
                </div>
            )
        } else if(selectNovoDepartamento.items.length && !selectNovoDepartamento.items.find(({ value }) => value === selectNovoDepartamento.selectItem).departamento.id_cenario_departamento) {
            console.log(`'id_departamento: [${selectNovoDepartamento.items.find(({ value }) => value === selectNovoDepartamento.selectItem).departamento.id}]' não configurado na tabela 'orc_cenario_departamento' para o cenário atual`);
            return (
                <div className={swalstyles.departamentonotselected}>
                    <div>Departamento não configurado para esse cenário.</div>
                    <div>Por favor, contate um administrador do sistema.</div>
                </div>
            )
        } else {
            return (
                <>
                    {renderModalNovoDepartamentoFuncaoListFuncoes()}
                    {renderModalNovoDepartamentoFuncaoInserirFuncao()}
                </>
            )
        }
    }

    function renderModalNovoDepartamentoFuncaoAlertNewFuncao() {
        const classes = [swalstyles.boldalert, swalstyles.redalert, swalstyles.smallersizetextalert, swalstyles.alertnewfuncaosemsalario];

        if(listedFuncao.find(funcao => !funcao.salario)) {
            classes.pop();
        }

        return (
            <div className={classes.join(' ')}>
                Atenção! Existem funções sem salário!
            </div>
        )
    }

    function handleNovoDepartamentoFuncaoRemoveFuncao(index) {
        const newListNovaFuncao = Object.assign([], listNovaFuncao);
        newListNovaFuncao.items.find(({ value }) => value === listedFuncao[index].list_nova_funcao_value).show = true;
        setListNovaFuncao(newListNovaFuncao);

        const newListedFuncao = Object.assign([], listedFuncao);
        newListedFuncao.splice(index, 1);
        setListedFuncao(newListedFuncao);
    }

    function handleNovoDepartamentoFuncaoChangeFuncao(valueSelected) {
        const newFuncao = listNovaFuncao.items.find(({ value }) => value === valueSelected);

        const newListedFuncao = Object.assign([], listedFuncao);
        newListedFuncao.push({
            id: newFuncao.funcao.id,
            codigo: newFuncao.funcao.codigo,
            descricao: newFuncao.funcao.descricao,
            id_organograma: null,
            salario: newFuncao.salario,
            list_nova_funcao_value: newFuncao.value,
        });
        setListedFuncao(newListedFuncao);

        const newListNovaFuncao = Object.assign([], listNovaFuncao);
        newListNovaFuncao.items.find(({ value }) => value === valueSelected).show = false;
        setListNovaFuncao(newListNovaFuncao);
    }

    function handleConfirmNovoDepartamentoFuncao() {
        if(!listedFuncao.length) {
            handleToastShow('Por Favor, Insira ao Menos uma Função no Departamento!');
        } else {
            const body = {
                id_cenario_organograma: headerOrganograma.id_cenario_organograma,
                id_departamento: selectedDepartamento.id || selectNovoDepartamento.items.find(({ value }) => value === selectNovoDepartamento.selectItem).departamento.id,
                funcoes: listedFuncao.filter(funcao => !funcao.id_organograma),
            }

            if(body.funcoes.length) {
                setSaving(true);

                api.post(`/previsao/salvarNovoDepartamentoFuncao`, body).then(function (response) {
                    if (response.data) {
                        if(response.data.error) {
                            console.log(`ERROR: ${response.data.error}`);
        
                            Swal.fire({
                                customClass: {
                                    container: swalstyles.swalcontainer,
                                    popup: swalstyles.swalbackground
                                },
                                title: 'UM ERRO INESPERADO ACONTECEU!',
                                text: 'POR FAVOR CONTATE UM ADMINISTRADOR DO SISTEMA',
                                icon: 'error',
                            });
                        } else if(response.data.calc) {
                            setPrevisaoCalc(true);
                        } else if(response.data.alertMessage.length) {
                            Swal.fire({
                                customClass: {
                                    container: swalstyles.swalcontainer,
                                    popup: swalstyles.swalbackground
                                },
                                title: 'UM ERRO INESPERADO ACONTECEU!',
                                html: response.data.alertMessage.join('<br />'),
                                icon: 'warning',
                            });
                        } else {
                            setLoading(true);
                            setSaving(false);
                            closeNovoDepartamentoFuncao();
                        }
                    }
                }).catch(error => {
                    // handle error
                    alert(error);
                    console.log(error);
                });
            } else {
                closeNovoDepartamentoFuncao();
            }
        }
    }

    function renderActionsModalNovoDepartamentoFuncaoConfirm() {
        return (
            <input type='button' className={[swalstyles.buttons, swalstyles.confirmbutton].join(' ')}
                value='CONFIRMAR' onClick={() => handleConfirmNovoDepartamentoFuncao()}
                disabled={!listedFuncao.length}
            />
        )
    }

    function renderActionsModalNovoDepartamentoFuncaoCancel() {
        return (
            <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                value='CANCELAR'
                onClick={() => {closeNovoDepartamentoFuncao()}}
            />
        )
    }

    function renderActionsModalNovoDepartamentoFuncao() {
        if(!saving) {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    {renderActionsModalNovoDepartamentoFuncaoConfirm()}
                    {renderActionsModalNovoDepartamentoFuncaoCancel()}
                </div>
            )
        } else {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    function renderModalNovoDepartamentoFuncao() {
        if(modalNovoDepartamentoFuncao) {
            if((selectNovoDepartamento.items.length || selectedDepartamento.id) && (listedFuncao.length || listNovaFuncao.items.length)) {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modalmaxheight3rows].join(' ')}>
                            <div className={swalstyles.conteinermodaldepartamentofuncaoheader}>
                                {renderModalNovoDepartamentoFuncaoDepartamento()}
                            </div>
                            <div className={[swalstyles.conteinerbody, swalstyles.conteinerbodymaxheight].join(' ')}>
                                <div className={[swalstyles.boldalert, swalstyles.redalert, swalstyles.smallersizetextalert].join(' ')}>
                                    Os registros destacados ainda não foram salvos!
                                </div>
                                {renderModalNovoDepartamentoFuncaoAlertNewFuncao()}
                                <div className={swalstyles.conteinerlistfuncoesdepartamento}>
                                    {renderModalNovoDepartamentoFuncaoFuncoes()}
                                </div>
                            </div>
                            {renderActionsModalNovoDepartamentoFuncao()}
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modalmaxheight3rows].join(' ')}>
                            <div></div>
                            <div className={swalstyles.conteinerbuttons}>
                                <div className={loadingstyles.divloading}>
                                    <div className={loadingstyles.loading}></div>
                                </div>
                            </div>
                            <div></div>
                        </div>
                    </div>
                )
            }
        }
    }

    function renderDeleteNovaFuncao(index) {
        return (
            <div className={[swalstyles.conteinerpopup, swalstyles.conteinerpopupheight100percent].join(' ')}>
                <span className={swalstyles.popup}>Remover</span>
                <BsTrashFill className={swalstyles.deletenovafuncao} onClick={() => handleNovoDepartamentoFuncaoRemoveFuncao(index)}
                onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}/>
            </div>
        )
    }

    function handleInfoSalario(redirectTo, data) {
        if(redirectTo === 'funcionarioToEdit') {
            nextFuncionarioToEdit('editSalarioFuncao', data);
        } else if(redirectTo === 'funcionariosFuncao') {
            nextFuncionariosFuncao('editSalarioFuncao', data);
        } else if(redirectTo === 'novoDepartamentoFuncao') {
            nextNovoDepartamentoFuncao(data);
        }
    }

    function renderInfoSalario(redirectTo, data) {
        return (
            <div className={[swalstyles.conteinerpopup, swalstyles.conteinerpopupheight100percent].join(' ')}>
                <span className={swalstyles.popup}>Editar Salário</span>
                <BsInfoCircle className={swalstyles.infosalariofuncionariosfuncao} onClick={() => {handleInfoSalario(redirectTo, data)}}
                onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}/>
            </div>
        )
    }

    function resetEditSalarioFuncao() {
        setModalSalario(false);
        setListAgrupAgrupamento({});
    }

    function closeEditSalarioFuncao() {
        const funcao = {};

        if(listAgrupAgrupamento.funcao) {
            funcao.id = listAgrupAgrupamento.funcao.id;
            funcao.salario_base = listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 50).referencia_valor;
        }

        resetEditSalarioFuncao();

        if(previousModal[previousModal.length - 1].modalName === 'funcionariosFuncao') {
            handleExibirFuncionariosFuncao(previousModal[previousModal.length - 1].departamento, previousModal[previousModal.length - 1].funcao);
        } else if(previousModal[previousModal.length - 1].modalName === 'novoDepartamentoFuncao') {
            handleNovoDepartamentoFuncao({
                selectNovoDpto: previousModal[previousModal.length - 1].selectNovoDpto,
                selectedDpto: previousModal[previousModal.length - 1].selectedDpto,
                listNovaFunc: previousModal[previousModal.length - 1].listNovaFunc,
                listedFunc: previousModal[previousModal.length - 1].listedFunc
            }, funcao);
        } else if(previousModal[previousModal.length - 1].modalName === 'funcionarioToEdit') {
            handleExibirFuncionarioToEdit(previousModal[previousModal.length - 1].funcionarioToEdit, previousModal[previousModal.length - 1].observacaoToEdit, previousModal[previousModal.length - 1].dataAdmToEdit, previousModal[previousModal.length - 1].dataDemToEdit, previousModal[previousModal.length - 1].calculaRecisaoToEdit, previousModal[previousModal.length - 1].newFuncionarioToEdit);
        }

        popPreviousModal();
    }

    function nextEditSalarioFuncao(agrupamento) {
        pushPreviousModal({
            modalName: 'editSalarioFuncao',
            data: {
                funcao: listAgrupAgrupamento.funcao,
                funcionario: listAgrupAgrupamento.funcionario,
            },
        });

        resetEditSalarioFuncao();
        
        handleExibirHistoricoSalario(listAgrupAgrupamento.funcao, listAgrupAgrupamento.funcionario, agrupamento);
    }

    function handleExibirEditSalarioFuncao(data) {
        setListAgrupAgrupamento({
            funcao: data.funcao || null,
            funcionario: data.funcionario || null,
            agrupAgrupamento: [],
        });

        setModalSalario(true);

        api.get(`/previsao/getAgrupAgrupamento?id_funcao=${data.funcao ? data.funcao.id : ''}&id_funcionario=${data.funcionario ? data.funcionario.id : ''}&id_empresa=${headerOrganograma.id_empresa}&id_cenario_organograma=${headerOrganograma.id_cenario_organograma}&data_filtro=${selectPeriodo.selectItem}`).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else {
                    if(!response.data.error) {
                        setListAgrupAgrupamento({
                            funcao: data.funcao || null,
                            funcionario: data.funcionario || null,
                            agrupAgrupamento: response.data.agrupAgrupamento,
                            infoSalario: response.data.info_salario,
                        });
                    }
                }
            }
        });
    }

    function renderActionsModalSalarioClose() {
        return (
            <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                value='FECHAR'
                onClick={() => {closeEditSalarioFuncao()}}
            />
        )
    }

    function renderModalSalarioAgrupamento() {
        return (
            listAgrupAgrupamento.agrupAgrupamento.map((agrupamento, index) => {
                if(agrupamento.tipo === 0) {
                    return (
                        <div className={swalstyles.conteinersalarioorganograma} key={index} onClick={() => nextEditSalarioFuncao(agrupamento)}>
                            <div className={swalstyles.descsalarioorganograma}>
                                {agrupamento.descricao}
                            </div>
                            <div className={swalstyles.conteinerinputsalarioorganograma}>
                                <div className={swalstyles.conteinerdescsalarioatual}>Referência:</div>
                                <div className={swalstyles.conteinersalarioatual}>
                                    {(agrupamento.referencia_valor || 0).toFixed(2)}
                                </div>
                            </div>
                        </div>
                    )
                } else if (agrupamento.tipo === 1) {
                    return (
                        <div className={agrupamento.id === 50 && !agrupamento.referencia_valor ? [swalstyles.conteinersalarioorganograma, swalstyles.conteinersalarioorganogramaalert].join(' ') : swalstyles.conteinersalarioorganograma}
                            key={index} onClick={() => nextEditSalarioFuncao(agrupamento)}
                        >
                            <div className={swalstyles.descsalarioorganograma}>
                                {agrupamento.descricao}
                            </div>
                            <div className={swalstyles.conteinerinputsalarioorganograma}>
                                <div className={swalstyles.conteinerdescsalarioatual}>Valor:</div>
                                <div className={swalstyles.conteinersalarioatual}>
                                    {(agrupamento.referencia_valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                </div>
                            </div>
                        </div>
                    )
                }
            })
        )
    }

    function renderModalSalarioAlertSemSalario() {
        if(listAgrupAgrupamento.funcao) {
            const classes = [swalstyles.boldalert, swalstyles.redalert, swalstyles.smallersizetextalert];

            if(listAgrupAgrupamento.agrupAgrupamento.find(({ referencia_valor, id }) => id === 50 && referencia_valor > 0)) {
                classes.push(swalstyles.alertnewfuncaosemsalario);
            }

            return (
                <div className={classes.join(' ')}>
                    É necessário informar ao menos o salário base para essa função!
                </div>
            )
        }
    }

    function renderModalSalarioTitle() {
        if(listAgrupAgrupamento.funcao) {
            return (
                <div className={swalstyles.titlemodalfuncionarios}>
                    <div>Salário por Função:</div>
                    <div>{listAgrupAgrupamento.funcao.codigo} - {listAgrupAgrupamento.funcao.descricao}</div>
                </div>
            )
        } else {
            return (
                <div className={swalstyles.titlemodalfuncionarios}>
                    <div>Salário por Funcionário:</div>
                    <div>{listAgrupAgrupamento.funcionario.matricula} - {listAgrupAgrupamento.funcionario.nome}</div>
                </div>
            )
        }
    }

    function renderModalSalarioTotal() {
        let listSalario = [];

        if(listAgrupAgrupamento.funcao) {
            listSalario = [
                {text: 'Salário Base', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 50).referencia_valor, awaysShow: true},
                {text: 'Gratificação Fixa', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 1).referencia_valor, awaysShow: false},
                {text: 'Gratificação BPP', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 2).referencia_valor, awaysShow: false},
                {text: 'Gratificação Variável', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 3).referencia_valor, awaysShow: false},
                {text: 'Gratificação Excedente', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 11).referencia_valor, awaysShow: false},
                {text: 'Adicional Safra', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 18).referencia_valor, awaysShow: false},
                {text: 'Gratificação Rural', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 21).referencia_valor, awaysShow: false},
                {text: 'Insalubridade', value: listAgrupAgrupamento.infoSalario.insalubridade, awaysShow: false, add: true},
                {text: 'Produtividade', value: listAgrupAgrupamento.infoSalario.produtividade, awaysShow: false, add: true},
                {text: 'Hora Extra', value: listAgrupAgrupamento.infoSalario.hora_extra, awaysShow: false, add: true},
            ];
        } else {
            listSalario = [
                {text: 'Acerto Banco de Horas', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 7).referencia_valor, awaysShow: false},
                {text: 'Gratificação Bonificação', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 4).referencia_valor, awaysShow: false},
                {text: 'Gratificação Abono', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 6).referencia_valor, awaysShow: false},
                {text: 'Gratificação Complementar', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 19).referencia_valor, awaysShow: false},
                {text: 'Gratificação Minas', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 22).referencia_valor, awaysShow: false},
                {text: 'Outras Gratificações', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 5).referencia_valor, awaysShow: false},
                {text: 'Prêmio', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 30).referencia_valor, awaysShow: false},
                {text: 'Desc. Pag. Indevido', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 100).referencia_valor, awaysShow: false, sub: true},
                {text: 'Desc. Plano Saúde', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 101).referencia_valor, awaysShow: false, sub: true},
                {text: 'Desc. Refeição', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 102).referencia_valor, awaysShow: false, sub: true},
                {text: 'Desc. Sindicato', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 103).referencia_valor, awaysShow: false, sub: true},
                {text: 'Desc. Multas/Indenizações', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 104).referencia_valor, awaysShow: false, sub: true},
                {text: 'Desc. Farmácia/Exames', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 105).referencia_valor, awaysShow: false, sub: true},
                {text: 'Desc. Pensão Alimentícia', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 106).referencia_valor, awaysShow: false, sub: true},
                {text: 'Desc. Convênio Clube', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 107).referencia_valor, awaysShow: false, sub: true},
                {text: 'Desc. Ferramentas', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 108).referencia_valor, awaysShow: false, sub: true},
                {text: 'Desc. Materiais/EPIs', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 109).referencia_valor, awaysShow: false, sub: true},
                {text: 'Desc. Adiant. Salarial', value: listAgrupAgrupamento.agrupAgrupamento.find(({ id }) => id === 110).referencia_valor, awaysShow: false, sub: true},
            ];
        }

        return (
            <div className={swalstyles.conteinersalariototalatual}>
                <div>
                    TOTAL:
                </div>
                <div className={swalstyles.conteinerpopup}>
                    <span className={swalstyles.popup}>
                        {renderPopupDetailsSalario(listAgrupAgrupamento.funcao ? 'Salário Médio da Função' : 'Salário Médio do Funcionário', listSalario)}
                    </span>
                    <div className={[swalstyles.conteinersalarioatual, swalstyles.conteinerpopupdetailssalario].join(' ')}
                        onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}
                        onClick={() => handleToastShowHtml(renderPopupDetailsSalario(listAgrupAgrupamento.funcao ? 'Salário Médio da Função' : 'Salário Médio do Funcionário', listSalario))}
                    >
                        {listAgrupAgrupamento.infoSalario.salario_total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    </div>
                </div>
            </div>
        )
    }

    function renderModalSalario() {
        if(modalSalario) {
            if(listAgrupAgrupamento.agrupAgrupamento.length) {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modalmaxheight4rows].join(' ')}>
                            <div>
                                {renderModalSalarioTitle()}
                                {renderModalSalarioAlertSemSalario()}
                            </div>
                            <div className={[swalstyles.conteinerbody, swalstyles.conteinerbodymaxheight, swalstyles.conteinerbodyenableoverflowx].join(' ')}>
                                {renderModalSalarioAgrupamento()}
                            </div>
                            {renderModalSalarioTotal()}
                            <div className={swalstyles.conteinerbuttons}>
                                {renderActionsModalSalarioClose()}
                            </div>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modalmaxheight3rows].join(' ')}>
                            {renderModalSalarioTitle()}
                            <div className={swalstyles.conteinerbuttons}>
                                <div className={loadingstyles.divloading}>
                                    <div className={loadingstyles.loading}></div>
                                </div>
                            </div>
                            <div></div>
                        </div>
                    </div>
                )
            }
        }
    }

    function resetHistoricoSalario() {
        setModalHistoricoSalario(false);
        setHistoricoSalario({});
        setSelectPeriodoHistorico({
            items: [],
            selectItem: [],
        });
        setInputSalarioHistorico([]);
        setCheckDissidioHistorico([]);
    }

    function closeHistoricoSalario() {
        resetHistoricoSalario();

        handleExibirEditSalarioFuncao(previousModal[previousModal.length - 1].data);

        popPreviousModal();
    }

    function handleExibirHistoricoSalario(funcao, funcionario, agrupamento) {
        setHistoricoSalario({
            funcao: funcao,
            funcionario: funcionario,
            agrupamento: agrupamento,
        });

        setModalHistoricoSalario(true);

        api.get(`/previsao/getSalarioByAgrupamento?id_funcao=${funcao ? funcao.id : ''}&id_funcionario=${funcionario ? funcionario.id : ''}&id_agrup_agrupamento=${agrupamento.id}&id_cenario_organograma=${headerOrganograma.id_cenario_organograma}&data_filtro=${selectPeriodo.selectItem}`).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else {
                    setSelectPeriodoHistorico({
                        items: response.data.itemsPeriodo,
                        selectItem: response.data.selectItemPeriodo,
                    })

                    setInputSalarioHistorico(response.data.inputSalario);
                    setCheckDissidioHistorico(response.data.checkDissidio);

                    setHistoricoSalario({
                        funcao: funcao,
                        funcionario: funcionario,
                        agrupamento: agrupamento,
                        historico: response.data.salario || [],
                        historicoDeleted: [],
                    });
                }
            }
        });
    }

    function salvarHistoricoSalario(body) {
        body.id_cenario_organograma = headerOrganograma.id_cenario_organograma;

        api.post(`/previsao/salvarHistoricoSalario`, body).then(function (response) {
            if (response.data) {
                if(response.data.error) {
                    console.log(`ERROR: ${response.data.error}`);

                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'UM ERRO INESPERADO ACONTECEU!',
                        text: 'POR FAVOR CONTATE UM ADMINISTRADOR DO SISTEMA',
                        icon: 'error',
                    });
                } else if(response.data.calc) {
                    setPrevisaoCalc(true);
                } else if(response.data.alertMessage.length) {
                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'UM ERRO INESPERADO ACONTECEU!',
                        html: response.data.alertMessage.join('<br />'),
                        icon: 'warning',
                    });
                } else {
                    setLoading(true);
                    setSaving(false);

                    closeHistoricoSalario();
                }
            }
        }).catch(error => {
            // handle error
            alert(error);
            console.log(error);
        });
    }

    function handleSalvarHistoricoSalario() {
        const edit = { historicoDelete: [], historicoNew: [], historicoEdit: [] };
        setSaving(true);

        historicoSalario.historicoDeleted.forEach(id_historico => {
            edit.historicoDelete.push(id_historico);
        });

        historicoSalario.historico.forEach((historico, index) => {
            if(!historico.id) {
                if(historicoSalario.funcao) {
                    edit.historicoNew.push({
                        id_empresa: headerOrganograma.id_empresa,
                        id_funcao: historicoSalario.funcao.id,
                        id_agrup_agrupamento: historicoSalario.agrupamento.id,
                        referencia_valor: inputSalarioHistorico[index],
                        data_inicial: selectPeriodoHistorico.items.find(({ value }) => value === selectPeriodoHistorico.selectItem[index]).data,
                        dissidio: checkDissidioHistorico[index] ? 1 : 0,
                    });
                } else {
                    edit.historicoNew.push({
                        id_empresa: headerOrganograma.id_empresa,
                        id_funcionario: historicoSalario.funcionario.id,
                        id_agrup_agrupamento: historicoSalario.agrupamento.id,
                        referencia_valor: inputSalarioHistorico[index],
                        data_inicial: selectPeriodoHistorico.items.find(({ value }) => value === selectPeriodoHistorico.selectItem[index]).data,
                        dissidio: checkDissidioHistorico[index] ? 1 : 0,
                    });
                }
            } else if(
                ((selectPeriodoHistorico.selectItem[index] != null && historico.data_inicial !== selectPeriodoHistorico.items.find(({ value }) => value === selectPeriodoHistorico.selectItem[index]).data) ||
                (historico.referencia_valor !== inputSalarioHistorico[index]) ||
                (historico.dissidio != checkDissidioHistorico[index]))
                && !historico.deleteBlocked
            ) {
                if(historicoSalario.funcao) {
                    edit.historicoEdit.push({
                        id: historico.id,
                        id_empresa: headerOrganograma.id_empresa,
                        id_funcao: historicoSalario.funcao.id,
                        id_agrup_agrupamento: historicoSalario.agrupamento.id,
                        referencia_valor: inputSalarioHistorico[index],
                        data_inicial: selectPeriodoHistorico.items.find(({ value }) => value === selectPeriodoHistorico.selectItem[index]).data,
                        dissidio: checkDissidioHistorico[index] ? 1 : 0,
                    });
                } else {
                    edit.historicoEdit.push({
                        id: historico.id,
                        id_empresa: headerOrganograma.id_empresa,
                        id_funcionario: historicoSalario.funcionario.id,
                        id_agrup_agrupamento: historicoSalario.agrupamento.id,
                        referencia_valor: inputSalarioHistorico[index],
                        data_inicial: selectPeriodoHistorico.items.find(({ value }) => value === selectPeriodoHistorico.selectItem[index]).data,
                        dissidio: checkDissidioHistorico[index] ? 1 : 0,
                    });
                }
            }
        });

        if(edit.historicoDelete.length || edit.historicoEdit.length || edit.historicoNew.length) {
            edit.isEditingUnico = historicoSalario.funcao ? false : true;

            salvarHistoricoSalario(edit);
        } else {
            setSaving(false);
            closeHistoricoSalario();
        }
    }

    function renderActionsModalHistoricoSalarioConfirm() {
        if(!(historicoSalario.funcionario && historicoSalario.funcionario.status === 2)) {
            return (
                <input type='button' className={[swalstyles.buttons, swalstyles.confirmbutton].join(' ')}
                    value='CONFIRMAR'
                    onClick={() => handleSalvarHistoricoSalario()}
                />
            )
        }
    }

    function renderActionsModalHistoricoSalarioCancel() {
        return (
            <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                value='CANCELAR'
                onClick={() => {closeHistoricoSalario()}}
            />
        )
    }

    function renderActionsModalHistoricoSalario() {
        if(!saving) {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    {renderActionsModalHistoricoSalarioConfirm()}
                    {renderActionsModalHistoricoSalarioCancel()}
                </div>
            )
        } else {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    function renderModalHistoricoSalarioTitle() {
        if(historicoSalario.funcao) {
            return (
                <div className={swalstyles.titlemodalfuncionarios}>
                    <div>Histórico de: {historicoSalario.agrupamento.descricao}</div>
                    <div>{historicoSalario.funcao.codigo} - {historicoSalario.funcao.descricao}</div>
                </div>
            )
        } else {
            return (
                <div className={swalstyles.titlemodalfuncionarios}>
                    <div>Histórico de: {historicoSalario.agrupamento.descricao}</div>
                    <div>{historicoSalario.funcionario.matricula} - {historicoSalario.funcionario.nome}</div>
                </div>
            )
        }
    }

    function handleModalDeleteHistoricoSalario(index) {
        let objPeriodo = Object.assign([], selectPeriodoHistorico);
        let objSalario = Object.assign([], inputSalarioHistorico);
        let objDissidio = Object.assign([], checkDissidioHistorico);
        let objHistorico = Object.assign([], historicoSalario);

        objPeriodo.selectItem.splice(index, 1);
        objSalario.splice(index, 1);
        objDissidio.splice(index, 1);

        if(objHistorico.historico[index].id) {
            objHistorico.historicoDeleted.push(objHistorico.historico[index].id);
        }

        objHistorico.historico.splice(index, 1);

        setSelectPeriodoHistorico(objPeriodo);
        setInputSalarioHistorico(objSalario);
        setCheckDissidioHistorico(objDissidio);
        setHistoricoSalario(objHistorico);
    }

    function renderModalDeleteHistoricoSalario(index) {
        if(!historicoSalario.historico[index].deleteBlocked && !(historicoSalario.funcionario && historicoSalario.funcionario.status === 2)) {
            return (
                <div className={swalstyles.conteinerpopup}>
                    <span className={swalstyles.popup}>Remover</span>
                    <BsTrashFill className={[swalstyles.deletenovafuncao, swalstyles.redalert].join(' ')} onClick={() => handleModalDeleteHistoricoSalario(index)}
                    onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}/>
                </div>
            )
        }
    }

    function renderHistoricoInputSalario(index) {
        if(historicoSalario.agrupamento.tipo) {
            return (inputSalarioHistorico[index]).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        } else {
            return (inputSalarioHistorico[index]).toFixed(2);
        }
    }

    function renderModalHistoricoSalarioInputSalario(index) {
        return (
            <>
                <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                    {historicoSalario.agrupamento.tipo ? 'VALOR' : 'REFERÊNCIA'}
                </div>
                <input type='text' className={[swalstyles.funcionariotoeditinput, swalstyles.inputhistoricofuncionario].join(' ')}
                    value={renderHistoricoInputSalario(index)}
                    onChange={e => handleInputSalario(e.currentTarget.value, index)}
                    disabled={historicoSalario.historico[index].deleteBlocked || (historicoSalario.funcionario && historicoSalario.funcionario.status === 2)}
                />
            </>
        )
    }

    function renderModalHistoricoSalarioSelectPeriodo(index) {
        return (
            <>
                <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                    PERIODO
                </div>
                <Select
                    inputId='select_historico_periodo'
                    value={selectPeriodoHistorico.items.find(({ value }) => value === selectPeriodoHistorico.selectItem[index])}
                    options={selectPeriodoHistorico.items}
                    isOptionDisabled={(option) =>
                        selectPeriodoHistorico.selectItem.includes(option.value) && !(option.value === selectPeriodoHistorico.selectItem[index])
                    }
                    components={{ Option }}
                    filterOption={FilterOptions}
                    onChange={(e) => setSelectPeriodoHistorico(handleSelectMultipleValue(e.value, selectPeriodoHistorico, index))}
                    theme={Theme}
                    className={previsaostyles.filterselecttoedit}
                    isDisabled={historicoSalario.historico[index].deleteBlocked || (historicoSalario.funcionario && historicoSalario.funcionario.status === 2)}
                    placeholder={historicoSalario.historico[index].deleteBlocked || historicoSalario.historico[index].afterPeriodo ? historicoSalario.historico[index].label : 'Selecione o Período'}
                    noOptionsMessage={() => "Nenhuma Opção"}
                />
            </>
        )
    }

    function renderModalHistoricoSalarioCheckDissidioCheck(show) {
        return (
            <TiTick className={show ? swalstyles.checkicon : [swalstyles.checkicon, swalstyles.checkiconnone].join(' ')}/>
        )
    }

    function renderModalHistoricoSalarioCheckDissidio(index) {
        return (
            <div className={historicoSalario.historico[index].deleteBlocked ? swalstyles.conteinercheckdissidioblocked : swalstyles.conteinercheckdissidio} onClick={() => handleCheckDissidio(index, historicoSalario.historico[index].deleteBlocked)}>
                <div className={swalstyles.checkconteiner}>
                    {renderModalHistoricoSalarioCheckDissidioCheck(checkDissidioHistorico[index])}
                </div>
                <div className={swalstyles.conteinerhistoricofuncionariolabel}>
                    Dissídio
                </div>
            </div>
        )
    }

    function renderModalListHistoricoSalario() {
        return (
            historicoSalario.historico.map((historico, index) => {
                if(historicoSalario.agrupamento.tipo && historicoSalario.funcao) {
                    return(
                        <div className={historico.atual ? [swalstyles.listhistoricofuncionario, swalstyles.listhistoricosalariodissidio, swalstyles.listhistoricofuncionarioatual].join(' ') : [swalstyles.listhistoricofuncionario, swalstyles.listhistoricosalariodissidio].join(' ')} key={index}>
                            <div className={swalstyles.listhistoricofuncionariodelete}>
                                {renderModalDeleteHistoricoSalario(index)}
                            </div>
                            <div>
                                {renderModalHistoricoSalarioInputSalario(index)}
                            </div>
                            <div>
                                {renderModalHistoricoSalarioSelectPeriodo(index)}
                            </div>
                            <div className={[swalstyles.listhistoricofuncionarioatualspan, swalstyles.conteinercheck].join(' ')}>
                                {renderModalHistoricoSalarioCheckDissidio(index)}
                            </div>
                        </div>
                    )
                } else {
                    return(
                        <div className={historico.atual ? [swalstyles.listhistoricofuncionario, swalstyles.listhistoricosalario, swalstyles.listhistoricofuncionarioatual].join(' ') : [swalstyles.listhistoricofuncionario, swalstyles.listhistoricosalario].join(' ')} key={index}>
                            <div className={swalstyles.listhistoricofuncionariodelete}>
                                {renderModalDeleteHistoricoSalario(index)}
                            </div>
                            <div>
                                {renderModalHistoricoSalarioInputSalario(index)}
                            </div>
                            <div className={swalstyles.listhistoricofuncionarioatualspan}>
                                {renderModalHistoricoSalarioSelectPeriodo(index)}
                            </div>
                        </div>
                    )
                }
            })
        )
    }

    function handleCriarNovoHistoricoSalario(periodo) {
        let objPeriodo = Object.assign([], selectPeriodoHistorico);
        let objSalario = Object.assign([], inputSalarioHistorico);
        let objDissidio = Object.assign([], checkDissidioHistorico);
        let objHistorico = Object.assign([], historicoSalario);

        objPeriodo.selectItem.push(periodo);

        if(historicoSalario.historico.length) {
            objSalario.push(inputSalarioHistorico[inputSalarioHistorico.length - 1]);
            objDissidio.push(historicoSalario.agrupamento.tipo ? true : false);
        } else {
            objSalario.push(0);
            objDissidio.push(false);
        }

        objHistorico.historico.push({
            id: null,
            atual: false,
            deleteBlocked: false,
        });

        setSelectPeriodoHistorico(objPeriodo);
        setInputSalarioHistorico(objSalario);
        setCheckDissidioHistorico(objDissidio);
        setHistoricoSalario(objHistorico);
    }

    function renderModalListHistoricoSalarioAdd() {
        if(!(historicoSalario.funcionario && historicoSalario.funcionario.status === 2)) {
            let findedValue = historicoSalario.historico.length ? selectPeriodoHistorico.items.find(({ value }) => !selectPeriodoHistorico.selectItem.includes(value)) : {value: 0};
            
            if(findedValue) {
                return (
                    <div className={[swalstyles.listaddhistoricofuncionario, swalstyles.listaddhistoricosalario].join(' ')} onClick={() => {handleCriarNovoHistoricoSalario(findedValue.value)}}>
                        <IoMdAdd className={swalstyles.listaddhistoricofuncionarioicon}/>
                    </div>
                )
            }
        }
    }

    function renderModalListHistoricoSalarioNaoEncontrado() {
        if(!historicoSalario.historico.length && historicoSalario.funcionario && historicoSalario.funcionario.status === 2) {
            return (
                <div className={swalstyles.conteinerhistoricosalarionothistorico}>
                    <div>Nada a Exibir!</div>
                    <div>Não é Possível Cadastrar um novo Histórico pois este Funcionário foi Removido da Previsão.</div>
                </div>
            )
        }
    }

    function renderModalHistoricoSalario() {
        if(modalHistoricoSalario) {
            if(historicoSalario.historico) {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modalmaxheight3rows].join(' ')}>
                            <div>
                                {renderModalHistoricoSalarioTitle()}
                            </div>
                            <div className={[swalstyles.conteinerbody, swalstyles.conteinerbodymaxheight, swalstyles.conteinerbodyenableoverflowx].join(' ')}>
                                {renderModalListHistoricoSalario()}
                                {renderModalListHistoricoSalarioAdd()}
                                {renderModalListHistoricoSalarioNaoEncontrado()}
                            </div>
                            {renderActionsModalHistoricoSalario()}
                        </div>
                    </div>
                )
            }
            else {
                return (
                    <div className={swalstyles.conteiner}>
                        <div className={[swalstyles.modal, swalstyles.modalmaxheight3rows].join(' ')}>
                            <div>
                                {renderModalHistoricoSalarioTitle()}
                            </div>
                            <div className={swalstyles.conteinerbuttons}>
                                <div className={loadingstyles.divloading}>
                                    <div className={loadingstyles.loading}></div>
                                </div>
                            </div>
                            <div></div>
                        </div>
                    </div>
                )
            }
        }
    }

    function renderStatusDetails(funcao) {
        if(funcao.quantidade_prevista > funcao.quantidade_padrao) {
            return (
                <IoMdArrowDropup className={[previsaostyles.escalaiconsdiff, previsaostyles.iconerror].join(' ')} />
            )
        } else if(funcao.quantidade_prevista < funcao.quantidade_padrao) {
            return (
                <IoMdArrowDropdown className={[previsaostyles.escalaiconsdiff, previsaostyles.iconok].join(' ')} />
            )
        } else {
            return (
                <IoIosRemove className={previsaostyles.escalaiconsdiff} />
            )
        }
    }

    function renderBodyEscalaDetails(previsao) {
        return (
            previsao.departamento.funcao.filter(funcao =>
                (regexTextoAproximado(funcao.codigo, inputFuncao) || regexTextoAproximado(funcao.descricao, inputFuncao)) &&
                funcao.organograma_funcionario.some(({ tipo_demissao, vaga_aberta }) => (vaga_aberta === vagasAberto || !vagasAberto) && (tipo_demissao === tipoDemissao || tipoDemissao === null))
            ).map((funcao, index) => {
                let classEscala = [previsaostyles.conteinerescalafuncao];

                if(previsao.show_details) {
                    classEscala.push(previsaostyles.showdetailsfuncao);
                }
                if(!funcao.salario_base) {
                    classEscala.push(previsaostyles.salarionull);
                }
                
                let quantidade_prevista = funcao.organograma_funcionario.reduce((accumulator, currentValue) => {if((currentValue.vaga_aberta === vagasAberto || !vagasAberto) && (currentValue.tipo_demissao === tipoDemissao || tipoDemissao === null)){return accumulator + currentValue.quantidade_prevista} else {return accumulator}}, 0);

                return (
                    <div className={classEscala.join(' ')}
                        key={index} onClick={() => handleExibirFuncionariosFuncao(previsao.departamento, funcao)}
                    >
                        <div className={[previsaostyles.escalafuncaocodigo,previsaostyles.conteinerescalafuncaoitem].join(' ')}>
                            <div>{funcao.codigo}</div>
                            <div>{funcao.descricao}</div>
                        </div>
                        <div className={[previsaostyles.conteinerescalafuncaoitem, previsaostyles.hideescaladescsalario].join(' ')}>{(funcao.soma_salario * quantidade_prevista).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                        <div className={previsaostyles.conteinerescalafuncaoitem}>{Number.isInteger(funcao.quantidade_padrao) ? funcao.quantidade_padrao.toFixed(0) : funcao.quantidade_padrao.toFixed(2)}</div>
                        <div className={previsaostyles.conteinerescalafuncaoitem}>{Number.isInteger(quantidade_prevista) ? quantidade_prevista.toFixed(0) : quantidade_prevista.toFixed(2)}</div>
                        <div className={previsaostyles.conteinerescalafuncaoitem}>{Number.isInteger(funcao.quantidade_padrao) && Number.isInteger(quantidade_prevista) ? (quantidade_prevista - funcao.quantidade_padrao).toFixed(0) : (quantidade_prevista - funcao.quantidade_padrao).toFixed(2)}</div>
                        <div className={[previsaostyles.conteinerescalaiconsdiff, previsaostyles.conteinerescalafuncaoitem].join(' ')}>
                            {renderStatusDetails(funcao)}
                        </div>
                    </div>
                )
            })
        )
    }
    
    function sumFuncaoSalario(funcao) {
        let resultSum = 0;

        funcao.forEach(({ soma_salario, organograma_funcionario }) => {
            resultSum += soma_salario * organograma_funcionario.reduce((accumulator, currentValue) => {
                if((currentValue.vaga_aberta === vagasAberto || !vagasAberto) && (currentValue.tipo_demissao === tipoDemissao || tipoDemissao === null)){
                    return accumulator + currentValue.quantidade_prevista
                } else {
                    return accumulator
                }
            }, 0);
        });

        return resultSum;
    }

    function sumFuncaoQuantidadePadrao(funcao) {
        let resultSum = 0;

        funcao.forEach(({ quantidade_padrao, organograma_funcionario }) => {
            if(organograma_funcionario.some(({ tipo_demissao, vaga_aberta }) => (vaga_aberta === vagasAberto || !vagasAberto) && (tipo_demissao === tipoDemissao || tipoDemissao === null))) {
                resultSum += quantidade_padrao;
            }
        });

        return {
            number: resultSum,
            text: Number.isInteger(resultSum) ? resultSum.toFixed(0) : resultSum.toFixed(2),
        }
    }

    function sumFuncaoQuantidadePrevista(funcao) {
        let resultSum = 0;

        funcao.forEach(({ organograma_funcionario }) => {
            resultSum += organograma_funcionario.reduce((accumulator, currentValue) => {
                if((currentValue.vaga_aberta === vagasAberto || !vagasAberto) && (currentValue.tipo_demissao === tipoDemissao || tipoDemissao === null)){
                    return accumulator + currentValue.quantidade_prevista
                } else {
                    return accumulator
                }
            }, 0);
        });

        return {
            number: resultSum,
            text: Number.isInteger(resultSum) ? resultSum.toFixed(0) : resultSum.toFixed(2),
        }
    }

    function subFuncaoPrevistaPadrao(funcao) {
        let resultSum = 0;

        funcao.forEach(({ quantidade_padrao, organograma_funcionario }) => {
            if(organograma_funcionario.some(({ tipo_demissao, vaga_aberta }) => (vaga_aberta === vagasAberto || !vagasAberto) && (tipo_demissao === tipoDemissao || tipoDemissao === null))) {
                resultSum += organograma_funcionario.reduce((accumulator, currentValue) => {
                    if((currentValue.vaga_aberta === vagasAberto || !vagasAberto) && (currentValue.tipo_demissao === tipoDemissao || tipoDemissao === null)){
                        return accumulator + currentValue.quantidade_prevista
                    } else {
                        return accumulator
                    }
                }, 0) - quantidade_padrao;
            }
        });

        return {
            number: resultSum,
            text: Number.isInteger(resultSum) ? resultSum.toFixed(0) : resultSum.toFixed(2),
        }
    }

    function sumDepartamentoSalario(previsao) {
        let resultSum = 0;

        previsao.forEach(({ departamento }) => {
            resultSum += sumFuncaoSalario(departamento.funcao.filter(({ codigo, descricao }) => (regexTextoAproximado(codigo, inputFuncao) || regexTextoAproximado(descricao, inputFuncao))));
        });

        return resultSum;
    }

    function sumDepartamentoQuantidadePadrao(previsao) {
        let resultSum = 0;

        previsao.forEach(({ departamento }) => {
            resultSum += sumFuncaoQuantidadePadrao(departamento.funcao.filter(({ codigo, descricao }) => (regexTextoAproximado(codigo, inputFuncao) || regexTextoAproximado(descricao, inputFuncao)))).number;
        });

        return Number.isInteger(resultSum) ? resultSum.toFixed(0) : resultSum.toFixed(2);
    }

    function sumDepartamentoQuantidadePrevista(previsao) {
        let resultSum = 0;

        previsao.forEach(({ departamento }) => {
            resultSum += sumFuncaoQuantidadePrevista(departamento.funcao.filter(({ codigo, descricao }) => (regexTextoAproximado(codigo, inputFuncao) || regexTextoAproximado(descricao, inputFuncao)))).number;
        });

        return Number.isInteger(resultSum) ? resultSum.toFixed(0) : resultSum.toFixed(2);
    }

    function subDepartamentoPrevistaPadrao(previsao) {
        let resultSum = 0;

        previsao.forEach(({ departamento }) => {
            let funcao = departamento.funcao.filter(({ codigo, descricao }) => (regexTextoAproximado(codigo, inputFuncao) || regexTextoAproximado(descricao, inputFuncao)));
            resultSum += sumFuncaoQuantidadePrevista(funcao).number - sumFuncaoQuantidadePadrao(funcao).number;
        });

        return Number.isInteger(resultSum) ? resultSum.toFixed(0) : resultSum.toFixed(2);
    }

    function renderTotaisEscala(previsao) {
        if (!previsaoNotFound) {
            return (
                <div className={previsaostyles.conteinerescalatotais}>
                    <div>TOTAIS</div>
                    <div className={previsaostyles.hideescaladescsalario}>{(sumDepartamentoSalario(previsao)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                    <div>{sumDepartamentoQuantidadePadrao(previsao)}</div>
                    <div>{sumDepartamentoQuantidadePrevista(previsao)}</div>
                    <div>{subDepartamentoPrevistaPadrao(previsao)}</div>
                </div>
            )
        }
    }

    function renderBodyEscalaCamposCalculados(funcao) {
        return (
            <>
                <div className={previsaostyles.hideescaladescsalario}>{sumFuncaoSalario(funcao).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</div>
                <div>{sumFuncaoQuantidadePadrao(funcao).text}</div>
                <div>{sumFuncaoQuantidadePrevista(funcao).text}</div>
                <div>{subFuncaoPrevistaPadrao(funcao).text}</div>
            </>
        )
    }

    function renderBodyEscala() {
        if (previsaoEscala.length && !previsaoNotFound) {
            return (
                previsaoEscala.filter((previsao) => 
                    (calcStatus(previsao.departamento.funcao) === selectStatus.selectItem || selectStatus.selectItem === 0) &&
                    (regexTextoAproximado(previsao.departamento.codigo, inputDepartamento) || regexTextoAproximado(previsao.departamento.descricao, inputDepartamento)) &&
                    (previsao.departamento.funcao.some(({ codigo, descricao, organograma_funcionario }) => (
                        (regexTextoAproximado(codigo, inputFuncao) || regexTextoAproximado(descricao, inputFuncao)) &&
                        organograma_funcionario.some(({ tipo_demissao, vaga_aberta }) => (vaga_aberta === vagasAberto || !vagasAberto) && (tipo_demissao === tipoDemissao || tipoDemissao === null))
                    )))
                ).map((previsao, index) => {
                    return (
                        <div className={previsao.show_details ? previsaostyles.conteinerbodyescalaselected : ''} key={index}>
                            <div className={previsao.show_details ? [previsaostyles.conteinerescaladepartamento, previsaostyles.showdetailsdepartamento].join(' ') : previsaostyles.conteinerescaladepartamento} onClick={() => handleShowDetails(previsao.departamento.id)}>
                                <div className={previsaostyles.escaladepartamentocodigo}>
                                    <div>{previsao.departamento.codigo}</div>
                                    <div>{previsao.departamento.descricao}</div>
                                </div>
                                {renderBodyEscalaCamposCalculados(previsao.departamento.funcao.filter(({ codigo, descricao }) => (regexTextoAproximado(codigo, inputFuncao) || regexTextoAproximado(descricao, inputFuncao))))}
                                <div>{renderStatus(calcStatus(previsao.departamento.funcao))}</div>
                                <div>{renderEscalaOpenClose(previsao.show_details)}</div>
                            </div>
                            {renderBodyEscalaDetails(previsao)}
                            <div className={previsaostyles.conteinerbodybuttons}>
                                {renderCriarNovaFuncao(previsao.show_details, true, previsao.departamento)}
                                {renderReiniciarFuncionariosVaga(previsao.show_details, previsao.departamento)}
                            </div>
                        </div>
                    )
                })
            )
        } else {
            return (
                <div className={previsaostyles.conteinerbodyescalawait}>
                    Aguarde, estamos trazendo as informações...
                </div>
            )
        }
    }

    function renderCriarNovoDepartamento() {
        return (
            <div className={swalstyles.conteinerpopup}>
                <span className={swalstyles.popup}>Adicionar Departamento</span>
                <div className={[previsaostyles.buttoncriardpto, previsaostyles.buttoncriar].join(' ')} onClick={() => handleNovoDepartamentoFuncao({departamento: {id: null}})}
                    onMouseEnter={e => handlePopupShow(e)} onMouseLeave={e => handlePopupShow(e)}
                >
                    <IoMdAdd className={previsaostyles.iconcriar}/>
                    <div>Novo Departamento</div>
                </div>
            </div>
        )
    }

    function renderHeadEscala() {
        return (
            <div>
                <div className={previsaostyles.conteinervagasabertonovodpto}>
                    {renderVagasAberto()}
                    {renderCriarNovoDepartamento()}
                </div>
                <div className={previsaostyles.conteinerheadescala}>
                    <div>DESCRIÇÃO</div>
                    <div className={previsaostyles.hideescaladescsalario}>SALÁRIO</div>
                    <div className={previsaostyles.escaladesccompleta}>PADRÃO</div>
                    <div className={previsaostyles.escaladescresumida}>PAD.</div>
                    <div className={previsaostyles.escaladesccompleta}>PREVISTO</div>
                    <div className={previsaostyles.escaladescresumida}>PREV.</div>
                    <div className={previsaostyles.escaladesccompleta}>DIFERENÇA</div>
                    <div className={previsaostyles.escaladescresumida}>DIF.</div>
                </div>
            </div>
        )
    }

    function renderLoadingEscala() {
        if(loading) {
            return (
                <div className={[swalstyles.conteiner, swalstyles.conteinerloading].join(' ')}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    function renderEscala() {
        return (
            <div className={previsaostyles.conteinerescalaoverflow}>
                <div className={previsaostyles.conteinerescala}>
                    {renderLoadingEscala()}
                    {renderHeadEscala()}
                    {renderBodyEscala()}
                    {renderTotaisEscala(
                        previsaoEscala.filter(({ departamento }) => 
                            (regexTextoAproximado(departamento.codigo, inputDepartamento) || regexTextoAproximado(departamento.descricao, inputDepartamento)) && (calcStatus(departamento.funcao) === selectStatus.selectItem || selectStatus.selectItem === 0)
                        )
                    )}
                </div>
            </div>
        )
    }

    function renderVagasAberto() {
        if (vagasAberto) {
            return (
                <div className={previsaostyles.vagasaberto}>Vagas em Aberto</div>
            )
        } else {
            return (
                <div className={[previsaostyles.vagasaberto, previsaostyles.vagasabertohide].join(' ')}>Vagas em Aberto</div>
            )
        }
    }

    function renderOptions() {
        return (
            <div className={previsaostyles.conteinerfilterstop}>
                <div className={previsaostyles.conteinerfiltersother}>
                    <div className={previsaostyles.conteinerfiltermes}>
                        <label htmlFor='select_periodo'>PERIODO:</label>
                        <Select
                            inputId='select_periodo'
                            value={selectPeriodo.items.find(({ value }) => value === selectPeriodo.selectItem)}
                            options={selectPeriodo.items}
                            components={{ Option }}
                            filterOption={FilterOptions}
                            onChange={(e) => {setSelectPeriodo(handleSelectValue(e.value, selectPeriodo, true)); setLoading(true)}}
                            theme={Theme}
                            className={previsaostyles.filterselect}
                            noOptionsMessage={() => "Nenhuma Opção"}
                            menuPosition='absolute'
                        />
                    </div>
                    <div className={previsaostyles.conteinerfilterdemissao}>
                        <span>DEMISSÃO:</span>
                        <div className={previsaostyles.conteinertipodemissao}>
                            <div className={tipoDemissao === 0 ? previsaostyles.tipodemissaoselected : ''} onClick={() => {setTipoDemissao(tipoDemissao !== 0 ? 0 : null)}}>SEM DEMISSÃO</div>
                            <div className={tipoDemissao === 1 ? previsaostyles.tipodemissaoselected : ''} onClick={() => {setTipoDemissao(tipoDemissao !== 1 ? 1 : null)}}>COM DEMISSÃO</div>
                        </div>
                    </div>
                </div>
                <div className={previsaostyles.conteinerfiltersbuttons}>
                    <div className={[previsaostyles.filterbutton, previsaostyles.filterbuttonsearch].join(' ')} onClick={() => {handleAjustarEmMassa()}}>
                        <div className={previsaostyles.filterbuttontext}>
                            Ajustar em Massa
                        </div>
                    </div>
                    <div className={[previsaostyles.filterbutton, previsaostyles.filterbuttonsearch].join(' ')} onClick={() => {handleInconsistenciasDepartamentoFuncao()}}>
                        <div className={previsaostyles.filterbuttontext}>
                            Inconsistências de Contratação
                        </div>
                    </div>
                    <div className={[previsaostyles.filterbutton, previsaostyles.filterbuttonsearch].join(' ')} onClick={() => {handlePesquisarFuncionarios(1, true)}}>
                        <div className={previsaostyles.filterbuttontext}>
                            Funcionários e Vagas
                        </div>
                    </div>
                    <div className={[previsaostyles.filterbutton, previsaostyles.filterbuttonvagas].join(' ')} onClick={() => {handleVagasEmAberto()}}>
                        <div className={previsaostyles.filterbuttontext}>
                            Vagas em aberto
                        </div>
                        <div className={previsaostyles.filterbuttonvalue}>
                            {quantidadeVagasAberto}
                        </div>
                    </div>
                    <div className={[previsaostyles.filterbutton, previsaostyles.filterbuttonalerts].join(' ')} onClick={() => {handlePesquisarFuncionarios(245, false)}}>
                        <div className={previsaostyles.filterbuttontext}>
                            Funcionários não escalados 
                        </div>
                        <div className={previsaostyles.filterbuttonvalue}>
                            {quantidadeFuncionariosSemEscala}
                        </div>
                    </div>
                    <div className={[previsaostyles.filterbutton, previsaostyles.filterbuttonalerts].join(' ')} onClick={() => {handlePesquisarFuncionarios(3, false)}}>
                        <div className={previsaostyles.filterbuttontext}>
                            Funcionários demitidos
                        </div>
                        <div className={previsaostyles.filterbuttonvalue}>
                            {quantidadeFuncionariosDemitidos}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function renderFilter() {
        return (
            <div className={previsaostyles.conteinerfiltersinputsselect}>
                <div className={previsaostyles.conteinerfilters}>
                    <input
                        className={previsaostyles.filterinput}
                        type='text'
                        placeholder='Digite o código ou descrição do departamento'
                        value={inputDepartamento}
                        onChange={(e) => setInputDepartamento(regexMaskDepartamento(e.target.value))}
                    />
                    <input
                        className={previsaostyles.filterinput}
                        type='text'
                        placeholder='Digite o código ou descrição da função'
                        value={inputFuncao}
                        onChange={(e) => setInputFuncao(e.target.value)}
                    />
                </div>
                <div className={previsaostyles.conteinerfiltersselect}>
                    <label htmlFor='select_status' className={previsaostyles.filterselectlabel}>STATUS:</label>
                    <Select
                        inputId='select_status'
                        value={selectStatus.items.find(({ value }) => value === selectStatus.selectItem)}
                        options={selectStatus.items}
                        components={{ Option, SingleValue }}
                        filterOption={FilterOptions}
                        onChange={(e) => setSelectStatus(handleSelectValue(e.value, selectStatus))}
                        theme={Theme}
                        className={previsaostyles.filterselect}
                        noOptionsMessage={() => "Nenhuma Opção"}
                        menuPosition='absolute'
                    />
                </div>
            </div>
        )
    }

    function resetCalcularPrevisao() {
        setEtapaCalculo(handleSelectValue(null, etapaCalculo));
        setModalCalcularPrevisao(false);
    }

    function handleNextCalcularPrevisao(error) {
        if(error) {
            setEtapaCalculo(handleSelectValue(0, etapaCalculo));
        } else if(etapaCalculo.items.length !== (etapaCalculo.selectItem + 1)) {
            setEtapaCalculo(handleSelectValue(etapaCalculo.selectItem ? (etapaCalculo.selectItem + 1) : 1, etapaCalculo));
        }
    }

    function handleModalCalcularPrevisao() {
        Swal.fire({
            customClass: {
                container: swalstyles.swalcontainer,
                popup: swalstyles.swalbackground
            },
            title: `DESEJA REALMENTE INICIAR O CÁLCULO DA PREVISÃO?`,
            text: `NÃO SERÁ POSSÍVEL EFETUAR NENHUMA ALTERAÇÃO ATÉ A CONCLUSÃO DESSE PROCESSO!`,
            confirmButtonText: 'CONFIRMAR', 
            focusDeny: true,
            showDenyButton: true,
            denyButtonText: 'CANCELAR',
            allowOutsideClick: false,
        }).then(result => {
            if(result.isConfirmed) {
                setModalCalcularPrevisao(true);
                setSaving(true);
                handleNextCalcularPrevisao();
            }
        });
    }

    function renderActionsModalCalcularPrevisaoCancel() {
        return (
            <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                value='FECHAR'
                onClick={() => {resetCalcularPrevisao()}}
            />
        )
    }

    function renderActionsModalCalcularPrevisao() {
        if(!saving) {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    {renderActionsModalCalcularPrevisaoCancel()}
                </div>
            )
        } else {
            return (
                <div className={swalstyles.conteinerbuttons}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    function renderStatusCalculoPrevisao() {
        if(etapaCalculo.selectItem != null) {
            return (
                <div>
                    <div>
                        {etapaCalculo.items.find(({ value }) => value === etapaCalculo.selectItem).title}
                    </div>
                    <div>
                        {etapaCalculo.items.find(({ value }) => value === etapaCalculo.selectItem).text}
                    </div>
                </div>
            )
        } else {
            return (
                <div>UM ERRO INESPERADO ACONTECEU!</div>
            )
        }
    }

    function renderEtapaCalculoPrevisao() {
        if(etapaCalculo.selectItem != null && etapaCalculo.items.find(({ value }) => value === etapaCalculo.selectItem).isEtapa) {
            return (
                <>
                    Etapa: {etapaCalculo.selectItem} de {etapaCalculo.items.filter(({ isEtapa }) => isEtapa).length}
                    <div className={loadingstyles.ldsellipsis}><div></div><div></div><div></div><div></div></div>
                </>
            )
        }
    }

    function renderModalCalcularPrevisaoStatus() {
        return (
            <div className={swalstyles.conteinerstatuscalculo}>
                {renderStatusCalculoPrevisao()}
                <div className={swalstyles.conteineretapacalculo}>
                    {renderEtapaCalculoPrevisao()}
                </div>
            </div>
        )
    }

    function renderModalCalcularPrevisao() {
        if(modalCalcularPrevisao) {
            return (
                <div className={swalstyles.conteiner}>
                    <div className={swalstyles.modal}>
                        <div className={swalstyles.titlemodalcalculo}>
                            CÁLCULO DA PREVISÃO
                        </div>
                        <div className={[swalstyles.conteinerbody, swalstyles.conteinerbodymaxheight].join(' ')}>
                            {renderModalCalcularPrevisaoStatus()}
                        </div>
                        {renderActionsModalCalcularPrevisao()}
                    </div>
                </div>
            )
        }
    }

    function renderCalcularPrevisao() {
        if(previsaoEscala.length && !previsaoNotFound) {
            return (
                <div className={previsaostyles.conteinercalculasalario}>
                    <input type='button' className={[swalstyles.buttons, swalstyles.confirmbutton].join(' ')}
                        value='Calcular Previsão' onClick={() => handleModalCalcularPrevisao()}
                    />
                    <div className={previsaostyles.datacalculo}>
                        Calculado Em: {headerOrganograma.data_calculo ? moment(headerOrganograma.data_calculo, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss') : '(Não Calculado Ainda)'}
                    </div>
                </div>
            )
        }
    }

    function renderEmpresaOrganograma() {
        if(headerOrganograma.id_empresa && headerOrganograma.id_empresa !== parseInt(localStorage.empresa_id)) {
            return (
                <div className={previsaostyles.empresaorganograma}>
                    {headerOrganograma.desc_empresa}
                </div>
            )
        }
    }

    function renderPrevisao() {
        if(previsaoNotFound) {
            return (
                <div className={previsaostyles.notfound}>
                    <div>NENHUMA PREVISÃO FOI ENCONTRADA.</div>
                    <div>POR FAVOR, AGUARDE ATÉ O PERÍODO DE CADASTRO DOS ORGANOGRAMAS</div>
                    <div>OU VERIFIQUE COM UM ADMINISTRADOR DO SISTEMA SOBRE ALGUM ERRO.</div>
                </div>
            )
        } else if(previsaoCalc) {
            return (
                <div className={previsaostyles.notfound}>
                    <div>O CÁLCULO DA PREVISÃO FOI INICIADO.</div>
                    <div>NÃO É POSSÍVEL REALIZAR ALTERAÇÕES DURANTE ESSE PROCESSO!</div>
                </div>
            )
        } else {
            return (
                <div className={previsaostyles.initialconteiner}>
                    {renderOptions()}
                    <div className={previsaostyles.conteinerheaderfilter}>
                        <div className={previsaostyles.conteinerheader}>
                            <div className={previsaostyles.tipoprevisao}>
                                <b>Status:</b> <u>{headerOrganograma.status === 0 ? 'aberta' : headerOrganograma.status === 1 ? 'em execução' : headerOrganograma.status === 2 ? 'encerrada' : '. . .'}</u>
                            </div>
                            <div className={previsaostyles.titleprevisao}>
                                PREVISÃO DE ESCALA
                            </div>
                            {renderEmpresaOrganograma()}
                        </div>
                        {renderFilter()}
                    </div>
                    {renderEscala()}
                    {renderCalcularPrevisao()}
                </div>
            )
        }
    }

    return (
        <>
            {renderModalCalcularPrevisao()}
            {renderModalHistoricoSalario()}
            {renderModalSalario()}
            {renderModalNovoDepartamentoFuncao()}
            {renderModalHistoricoFuncionario()}
            {renderModalFuncionarioToEdit()}
            {renderModalSelectVaga()}
            {renderModalFuncionariosFuncao()}
            {renderModalFilters()}
            {renderModalInconsistenciasDepartamentoFuncao()}
            {renderModalAjustarEmMassa()}
            {renderModalReiniciarFuncionarioVaga()}
            <div className="container-lg">
                {renderPrevisao()}
            </div>
        </>
    )
}